// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/events_images/speaker-top.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/events_images//Banner-Image.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/events_images/bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/events_images/MoreSpeaker.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/events_images/agenda-top.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/events_images/agenda-pattern.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/events_images/footer-patterns.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/events_images/register-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
@File: Evnia Template Styles

* This file contains the styling for the actual tepmlate, this
is the file you need to edit to change the look of the
tepmlate.

This files table contents are outlined below>>>>>

*******************************************
*******************************************

** - Default CSS
** - Preloader CSS
** - Navbar CSS
** - Main Banner CSS
** - About CSS
** - Why Choose Us CSS
** - CTA CSS
** - Speakers CSS
** - Schedule CSS
** - FunFacts CSS
** - Pricing CSS
** - Partner CSS
** - Blog CSS
** - Buy Tickets CSS
** - Subscribe CSS
** - Page Title CSS
** - Login CSS
** - Signup CSS
** - 404 Error CSS
** - FAQ CSS
** - Coming Soon CSS
** - Pagination CSS
** - Blog Details CSS
** - Sidebar CSS
** - Contact Us CSS
** - Footer CSS
** - Back To Top CSS
*/
/*================================================
Default CSS
=================================================*/
body {
  padding: 0;
  margin: 0;
  font-size: 15px;
  background: linear-gradient(90deg, #18284d, #101a33);
}

.row {
  @media (max-width: 767px) {
    margin: 0 !important;
  }
}

/* a {
  display: inline-block;
  transition: 0.5s;
  text-decoration: none;
}
a:hover,
a:focus {
  text-decoration: none;
} */

.d-table {
  width: 100%;
  height: 100%;
}
.d-table-cell {
  vertical-align: middle;
}

.ptb-120 {
  padding-top: 120px;
  padding-bottom: 60px;
  @media (min-width: 2560px) {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }

  @media only screen and (min-width: 768px) and (max-width: 993px) {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @media (max-width: 767px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
}

/* img {
  max-width: 100%;
  height: auto;
}

p {
  line-height: 1.9;
  color: #ffffff;
  margin-bottom: 15px;
  font-size: 15px;
}
p:last-child {
  margin-bottom: 0;
} */

/* .h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700;
  color: #ffffff;
} */

.text-right {
  text-align: end;
}

.text-left {
  text-align: start;
}

.form-group {
  margin-bottom: 30px;
}

textarea.form-control {
  min-height: auto !important;
  height: auto;
}

label {
  margin-bottom: 10px;
}

/*btn btn-primary*/
.btn {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: #ffffff;
  box-shadow: 0 8px 6px -6px rgba(50, 51, 51, 0.4) !important;
  border: none !important;
  padding: 10px 16px !important;
  border-radius: 0 !important;
  transition: 0.5s !important;
  @media (min-width: 1600px) {
    font-size: 1.25vw !important;
  }
}

.btn-primary {
  color: #ffffff;
  background: #0d1028 !important;
  position: relative;
  z-index: 1;
}
.btn-primary::before,
.btn-primary::after {
  content: "";
  position: absolute;
  top: 0;
  width: 51%;
  background: #fe4614;
  height: 100%;
  z-index: -1;
  transition: 0.5s;
}
.btn-primary::before {
  left: 0;
}
.btn-primary::after {
  right: 0;
}
.btn-primary:hover::before,
.btn-primary:hover::after,
.btn-primary:focus::before,
.btn-primary:focus::after {
  width: 0;
}
.btn-primary.focus,
.btn-primary:focus {
  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);
  color: #ffffff;
}
.btn-primary:hover,
.btn-primary:focus {
  background: #ffffff !important;
  color: #253d77 !important;
  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25) !important;
}
.btn-primary:not(:disabled):not(.disabled).active:focus,
.btn-primary:not(:disabled):not(.disabled):active:focus {
  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);
}
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active {
  background: #0d1028;
  color: #ffffff;
}
.btn-primary.disabled,
.btn-primary:disabled {
  opacity: 1;
  background: #0d1028;
}

.btn-secondary {
  color: #ffffff;
  background: #0d1028;
  position: relative;
  z-index: 1;
}
.btn-secondary::before,
.btn-secondary::after {
  content: "";
  position: absolute;
  top: 0;
  width: 51%;
  background: #00acee;
  height: 100%;
  z-index: -1;
  transition: 0.5s;
}
.btn-secondary::before {
  left: 0;
}
.btn-secondary::after {
  right: 0;
}
.btn-secondary:hover::before,
.btn-secondary:hover::after,
.btn-secondary:focus::before,
.btn-secondary:focus::after {
  width: 0;
}
.btn-secondary.focus,
.btn-secondary:focus {
  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);
  color: #ffffff;
}
.btn-secondary:hover,
.btn-secondary:focus {
  background: #0d1028;
  color: #ffffff;
  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);
}
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.btn-secondary:not(:disabled):not(.disabled):active:focus {
  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);
}
.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active {
  background: #0d1028;
  color: #ffffff;
}
.btn-secondary.disabled,
.btn-secondary:disabled {
  opacity: 1;
  background: #0d1028;
}

.navbar-brand {
  width: 10vw;
  @media (max-width: 767px) {
    width: 60vw;
  }
  @media (max-width: 575px) {
    padding-left: 4vw;
  }
}

/*section-title*/
.EventsPage {
  background: linear-gradient(90deg, #18284d, #101a33);
}
.speakers-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 40vh;
  position: relative;
  display: flex;
  align-items: center;
  @media (max-width: 993px) {
    height: 30vh;
  }
  @media (max-width: 768px) {
    height: 45vh;
  }
}

.speakers-row {
  @media (max-width: 993px) {
    padding: 12px;
  }
}

.speakers-section .bg-title {
  color: transparent;
  -webkit-text-stroke: 0.5px #fff;
  font-weight: 700;
  font-size: 90px;
  font-family: Arial, Helvetica, sans-serif !important;
  line-height: 150%;
  position: absolute;
  bottom: 2%;
  left: 5%;
  text-transform: uppercase;
  letter-spacing: 1px;
  z-index: 0;
  margin-top: -25px;
  @media (min-width: 1600px) {
    font-size: 5.625vw;
  }
  @media (max-width: 991px) {
    font-size: 50px !important;
  }
  @media (max-width: 767px) {
    font-size: 30px !important;
  }
}
.section-title {
  z-index: 100;
  padding-top: 120px;
  @media (min-width: 2000px) {
    padding-top: 25vh;
  }
  @media (max-width: 993px) {
    padding-top: 80px;
  }
  @media (max-width: 768px) {
    padding-top: 60px;
  }
}
.speakers-section-title {
  z-index: 100;
}
.section-title h1 {
  color: #e74860;
  font-size: 40px;
  text-align: center;
  @media (min-width: 1600px) {
    font-size: 2.5vw;
  }
  @media (max-width: 767px) {
    font-size: 36px;
  }
}

.speakers-section-title h1 {
  color: #e74860;
  font-size: 40px;
  text-align: center;
  @media (min-width: 1600px) {
    font-size: 2.5vw;
  }
  @media (max-width: 767px) {
    font-size: 36px;
  }
}
.section-title span {
  color: #ffffff;
  letter-spacing: 1px;
  font-size: 16px;
  text-transform: uppercase;
  display: block;
  text-align: right;
  @media (min-width: 1600px) {
    font-size: 1.05vw;
  }
}

.speakers-section-title span {
  color: #ffffff !important;
  letter-spacing: 1px;
  font-size: 16px !important;
  text-transform: uppercase !important;
  display: block;
  text-align: right !important;
  @media (min-width: 1600px) {
    font-size: 1.1vw !important;
  }
}
.section-title h2 {
  color: #e74860;
  font-size: 40px;
  text-align: right;
  @media (min-width: 1600px) {
    font-size: 2.5vw;
  }
}
.speakers-section-title h2 {
  color: #e74860;
  font-size: 40px;
  text-align: right;
  @media (min-width: 1600px) {
    font-size: 2.5vw;
  }
}
.section-title h2 b {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 80%, #ff2d55 80%);
  font-weight: unset;
  background-size: 100px 1.07em !important;
}
.section-title .btn {
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -18px;
}

/*owl-carousel-btn*/
.owl-theme .owl-nav.disabled + .owl-dots {
  margin-top: 0;
  line-height: 0.01;
}
.owl-theme .owl-dots .owl-dot span {
  width: 15px;
  height: 15px;
  margin: 0 4px;
  background: transparent;
  border: 1px solid #dfdfdf;
  display: block;
  transition: 0.5s;
  border-radius: 50%;
  position: relative;
}
.owl-theme .owl-dots .owl-dot:hover,
.owl-theme .owl-dots .owl-dot:focus {
  outline: 0;
  box-shadow: unset !important;
}
.owl-theme .owl-dots .owl-dot:hover span,
.owl-theme .owl-dots .owl-dot:focus span {
  background: #00acee;
  border-color: #00acee;
}
.owl-theme .owl-dots .owl-dot.active span {
  background: #ff2d55;
  border-color: #ff2d55;
}

/*form-control*/
.form-control {
  height: 50px;
  padding: 15px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #eeeeee;
  border-radius: 0;
  transition: 0.5s;
}
.form-control:hover,
.form-control:focus,
.form-control.active {
  box-shadow: unset;
  border-color: #ff2d55;
}

/*================================================
Preloader CSS
=================================================*/
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  overflow: hidden;
  background: #0d1028;
}
.preloader .loader {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 110px;
  height: 110px;
  margin: -80px 0 0 -75px;
  border-radius: 50%;
  border: 7px solid transparent;
  border-top-color: #ff2d55;
  animation: spin 1.7s linear infinite;
  z-index: 11;
}
.preloader .loader:before {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 50%;
  border: 7px solid transparent;
  border-top-color: #efa506;
  animation: spin-reverse 0.6s linear infinite;
}
.preloader .loader:after {
  content: "";
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 7px solid transparent;
  border-top-color: #00acee;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes spin-reverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
/*================================================
Navbar CSS
=================================================*/
.elkevent-nav {
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 20px;
  width: 100%;
  z-index: 999;
  height: auto;
}
.elkevent-nav nav ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.elkevent-nav nav .navbar-nav .nav-item {
  position: relative;
  padding: 15px 0;
}
.elkevent-nav nav .navbar-nav .nav-item a {
  font-weight: 500;
  font-size: 16px;
  text-transform: uppercase;
  color: #ffffff !important;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 15px;
  margin-right: 15px;
  @media (min-width: 1600px) {
    font-size: 1.05vw;
  }
}
.elkevent-nav nav .navbar-nav .nav-item a:hover,
.elkevent-nav nav .navbar-nav .nav-item a:focus,
.elkevent-nav nav .navbar-nav .nav-item a.active {
  color: #ff2d55;
}
.elkevent-nav nav .navbar-nav .nav-item:hover a {
  color: #ff2d55;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu {
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.05);
  background: #0d1028;
  position: absolute;
  top: 80px;
  right: 0;
  width: 250px;
  z-index: 99;
  display: block;
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 20px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li {
  position: relative;
  padding: 0;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a {
  font-size: 15px;
  font-weight: 500;
  text-transform: capitalize;
  padding: 9px 15px;
  margin: 0;
  display: block;
  color: #ffffff;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a:hover,
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a:focus,
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a.active {
  color: #ff2d55;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li .dropdown-menu {
  position: absolute;
  right: 220px;
  top: 0;
  opacity: 0 !important;
  visibility: hidden !important;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li a {
  color: #ffffff;
  text-transform: capitalize;
}
.elkevent-nav
  nav
  .navbar-nav
  .nav-item
  .dropdown-menu
  li
  .dropdown-menu
  li
  a:hover,
.elkevent-nav
  nav
  .navbar-nav
  .nav-item
  .dropdown-menu
  li
  .dropdown-menu
  li
  a:focus,
.elkevent-nav
  nav
  .navbar-nav
  .nav-item
  .dropdown-menu
  li
  .dropdown-menu
  li
  a.active {
  color: #ff2d55;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li:hover .dropdown-menu {
  opacity: 1 !important;
  visibility: visible !important;
  top: -20px !important;
}
.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li:hover a {
  color: #ff2d55;
}
.elkevent-nav nav .navbar-nav .nav-item:hover ul {
  opacity: 1;
  visibility: visible;
  top: 100%;
}
.elkevent-nav nav .others-option {
  margin-left: 13px;
}
.elkevent-nav.is-sticky {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;
  z-index: 999;
  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
  background-color: #0d1028 !important;
  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
}

.navbar-toggler {
  border: none;
  /* background: #eee !important; */
  padding: 10px;
  border-radius: 0;
  border: none !important;
}
.navbar-toggler:focus {
  box-shadow: none !important;
}
.navbar-toggler .icon-bar {
  width: 28px;
  transition: all 0.3s;
  background: #ff2d55;
  height: 2px;
  display: block;
}
.navbar-toggler .top-bar {
  transform: rotate(45deg);
  transform-origin: 10% 10%;
  left: 4px;
  position: relative;
}
.navbar-toggler .middle-bar {
  opacity: 0;
  margin: 6px 0;
}
.navbar-toggler .bottom-bar {
  transform: rotate(-45deg);
  transform-origin: 10% 90%;
  left: 4px;
  position: relative;
}
.navbar-toggler.collapsed .top-bar {
  transform: rotate(0);
  left: 0;
}
.navbar-toggler.collapsed .middle-bar {
  opacity: 1;
}
.navbar-toggler.collapsed .bottom-bar {
  transform: rotate(0);
  left: 0;
}

/*================================================
Main Banner CSS
=================================================*/
.main-banner-sec-col {
  margin-left: 1vw;
  @media (max-width: 551px) {
    margin-left: 0vw;
  }
}
.main-banner {
  height: 100vh;
  position: relative;
  z-index: 1;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  @media only screen and (min-width: 600px) and (max-width: 993px) {
    height: 60vh !important;
  }
}

.main-banner-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
}

.main-banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.21);
  z-index: -1;
}

@media (max-width: 575px) {
  .main-banner {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat
      center center/cover;
  }

  .main-banner-video {
    display: none;
  }
}

.main-banner::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #0d1028;
  opacity: 0.77;
}

.slideshow-banner::before {
  z-index: 1;
}
.slideshow-banner .main-banner-content {
  margin-top: 50px;
}
.slideshow-banner .main-banner-content::before {
  display: none;
}
.slideshow-banner .slideshow {
  z-index: -1;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.slideshow-banner .slideshow li span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  color: transparent;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  opacity: 0;
  z-index: 0;
  backface-visibility: hidden;
  animation: imageAnimation 24s linear infinite 0s;
}
.slideshow-banner .slideshow li:nth-child(2) span {
  animation-delay: 6s;
}
.slideshow-banner .slideshow li:nth-child(3) span {
  animation-delay: 12s;
}
.slideshow-banner .slideshow li:nth-child(4) span {
  animation-delay: 18s;
}
.slideshow-banner .event-countdown {
  position: relative;
  right: 0;
  bottom: 0;
  text-align: left;
}
.slideshow-banner .event-countdown #days {
  margin-left: 0;
}

.video-banner {
  overflow: hidden;
}
.video-banner .video-background {
  position: absolute;
  left: 0;
  top: 0;
  width: auto;
  height: auto;
  min-height: 100%;
  min-width: 100%;
  z-index: -2;
}

/* .item-bg1 {
  background-image: url("/images/main-bg1.jpg");
}

.item-bg2 {
  background-image: url("/images/main-bg2.jpg");
}

.item-bg3 {
  background-image: url("/images/slider-bg1.jpg");
}

.item-bg4 {
  background-image: url("/images/slider-bg2.jpg");
}

.item-bg5 {
  background-image: url("/images/slider-bg3.jpg");
} */

.main-banner-content {
  /* max-width: 850px; */
  position: relative;
  z-index: 1;
}
/* .main-banner-content::before {
  content: "";
  position: absolute;
  top: -75px;
  width: 100%;
  max-width: 380px;
  text-align: center;
  height: 500px;
  left: 18%;
  margin-left: -190px;
  z-index: -1;
  border: 18px solid rgba(104, 89, 222, 0.24);
  box-sizing: border-box;
  box-shadow: 0 60px 40px -40px rgba(0, 0, 0, 0.3);
} */
.main-banner-content h1 {
  color: #ffffff;
  margin-bottom: 8px;
  font-weight: 900;
  font-size: 65px;
  @media (min-width: 1600px) {
    font-size: 4vw;
  }
}
.main-banner-content h2 {
  background: linear-gradient(180deg, #f15a2b, #e74860);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 40px;
  font-weight: 600;
  font-size: 32px !important;
  line-height: 150%;
  @media (min-width: 1600px) {
    font-size: 2vw !important;
  }
  @media (max-width: 991px) {
    font-size: 25px !important;
    margin-bottom: 20px;
  }
  @media (max-width: 768px) {
    font-size: 24px !important;
  }
}
.main-banner-content h3 {
  color: #ffffff;
  font-weight: 400;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  @media (min-width: 1600px) {
    font-size: 1.25vw;
  }
  @media (max-width: 768px) {
    font-size: 16px !important;
    gap: 10px;
  }
  @media (max-width: 375px) {
    gap: 3px;
  }
}

.main-banner-icons {
  padding: 0 !important;
  width: 1.5vw !important;
  height: 1.5vw !important;
  @media (max-width: 991px) {
    width: 24px !important;
    height: 24px !important;
  }
  @media (max-width: 768px) {
    width: 14px !important;
    height: 14px !important;
  }
}

.main-banner-content h3 span {
  margin-left: 24px;
  @media (max-width: 768px) {
    margin-left: 0px;
    width: 90vw;
  }
}

.main-banner-content h1 span {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 80%, #ff2d55 80%);
  background-size: 100px 1.2em !important;
}
.main-banner-content h1 b:nth-of-type(1) {
  color: #efa506;
}
.main-banner-content h1 b:nth-of-type(2) {
  color: #ff2d55;
}
.main-banner-content h1 b:nth-of-type(3) {
  color: #ffffff;
  animation: colorchange 20s;
}
.main-banner-content h1 b:nth-of-type(4) {
  color: #00acee;
}
.main-banner-content ul {
  padding: 0;
  margin: 25px 0 40px;
  list-style-type: none;
}
.main-banner-content ul li {
  color: #fff;
  margin-right: 20px;
  font-size: 17px;
  display: inline-block;
}
.main-banner-content ul li i {
  margin-right: 3px;
  color: #ff2d55;
}
.main-banner-content ul li:last-child {
  margin-right: 0;
}
.main-banner-content p {
  color: #efa506;
  font-size: 22px;
  letter-spacing: 1px;
  margin-bottom: 10px;
}
.main-banner-content p span {
  color: #00acee;
}
.main-banner-content .button-box a {
  display: inline-block;
}
.main-banner-content .button-box .video-btn {
  margin-left: 30px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
}
.main-banner-content .button-box .video-btn i {
  width: 50px;
  display: inline-block;
  height: 50px;
  line-height: 51px;
  text-align: center;
  background-color: #00acee;
  border-radius: 50%;
  font-size: 17px;
  margin-right: 8px;
  z-index: 1;
  position: relative;
  transition: 0.5s;
}
.main-banner-content .button-box .video-btn i::after {
  z-index: -1;
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 50px;
  height: 50px;
  animation: ripple 1.6s ease-out infinite;
  animation-delay: 3s;
  opacity: 0;
  border-radius: 50%;
  background: rgba(51, 102, 204, 0.5);
}
.main-banner-content .button-box .video-btn:hover,
.main-banner-content .button-box .video-btn:focus {
  color: #00acee;
}
.main-banner-content .button-box .video-btn:hover i,
.main-banner-content .button-box .video-btn:focus i {
  background-color: #ff2d55;
  color: #ffffff;
}
.main-banner-content.banner-content-center {
  text-align: center;
}

.countdown-area {
  padding: 50px 0;
  background: #8dc63f;
}
.countdown-area .event-countdown {
  position: relative;
  right: 0;
  bottom: 0;
  text-align: center;
}
.countdown-area .event-countdown #timer div {
  margin: 0 55px;
}
.countdown-area .event-countdown #timer div#seconds {
  color: #ff2d55;
}

.event-countdown {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  text-align: center;
  width: 100%;
}
.event-countdown #timer div {
  display: inline-block;
  font-size: 55px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 35px;
  position: relative;
}
.event-countdown #timer div#days {
  color: #ff2d55;
}
.event-countdown #timer div#hours {
  color: #00acee;
}
.event-countdown #timer div#hours span {
  right: -50px;
  margin-top: -12px;
}
.event-countdown #timer div#minutes {
  color: #ffffff;
}
.event-countdown #timer div#minutes span {
  right: -55px;
  margin-top: -12px;
}
.event-countdown #timer div#seconds {
  color: #efa506;
}
.event-countdown #timer div#seconds span {
  right: -60px;
  margin-top: -12px;
}
.event-countdown #timer span {
  display: block;
  color: #ffffff;
  margin-top: 0;
  font-size: 14px;
  font-weight: 500;
  position: absolute;
  right: -40px;
  top: 50%;
  text-transform: uppercase;
  transform: rotate(-90deg);
  margin-top: -10px;
  letter-spacing: 2px;
}

.countdown1 {
  bottom: 15px !important;
}
.countdown1 #timer div {
  font-size: 60px;
}
.countdown1 #timer span {
  display: inline-block;
  font-size: 14px;
  position: initial;
  transform: rotate(0deg);
}

@keyframes ripple {
  0%,
  35% {
    transform: scale(0);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.8;
  }
  100% {
    opacity: 0;
    transform: scale(2);
  }
}
.shape1 {
  position: absolute;
  left: 70px;
  bottom: 70px;
  z-index: -1;
  animation: movebounce 5s linear infinite;
  opacity: 0.6;
}

.shape2 {
  position: absolute;
  right: 70px;
  bottom: 70px;
  z-index: -1;
  opacity: 0.6;
}

.shape3 {
  position: absolute;
  left: 70px;
  top: 70px;
  z-index: -1;
  opacity: 0.6;
}

.shape4 {
  position: absolute;
  right: 100px;
  top: 100px;
  z-index: -1;
  opacity: 0.6;
  animation: movebounce 5s linear infinite;
}

.rotateme {
  animation-name: rotateme;
  animation-duration: 40s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes rotateme {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes movebounce {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes colorchange {
  0% {
    color: #ff2d55;
  }
  25% {
    color: #ffffff;
  }
  50% {
    color: red;
  }
  75% {
    color: #00acee;
  }
  0% {
    color: #efa506;
  }
}
.home-slides .swiper-button-next,
.home-slides .swiper-button-prev {
  width: 50px;
  height: 50px;
  line-height: 50px;
  background-color: #00acee;
  color: #ffffff;
  transition: 0.5s;
  opacity: 0.7;
}
.home-slides .swiper-button-next::after,
.home-slides .swiper-button-prev::after {
  font-size: 25px;
}
.home-slides .swiper-button-next:hover,
.home-slides .swiper-button-prev:hover {
  background-color: #ff2d55;
  color: #ffffff;
}

/*================================================
About CSS
=================================================*/
.about-area {
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.about-area.bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.about-content span {
  color: #ffffff;
  letter-spacing: 1px;
  font-size: 16px;
  text-transform: uppercase;
  display: block;
  @media (min-width: 1600px) {
    font-size: 1.05vw !important;
  }
}
.about-content h2 {
  font-size: 32px !important;
  margin-top: 10px;
  margin-bottom: 25px;
  color: #e74860;
  @media (min-width: 1600px) {
    font-size: 2vw !important;
  }
  @media (max-width: 768px) {
    font-size: 28px !important;
  }
}
.about-content h2 b {
  /* background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 80%, #ff2d55 80%); */
  font-weight: unset;
  background-size: 100px 1.05em !important;
}
.about-content .signature {
  margin-top: 35px;
  margin-bottom: 35px;
}
.about-content .btn-primary {
  margin-right: 20px;
}

.about-image {
  position: relative;
  object-fit: cover;
}
.about-image .about-img {
  width: 100%;
  height: 100%;
}
.about-image .about-img2 {
  position: absolute;
  left: 20px;
  bottom: -80px;
}
.about-image .shape-img {
  position: absolute;
  top: -28px;
  left: 48%;
  animation: movebounce 5s linear infinite;
}
.about-image .btn {
  position: absolute;
  bottom: -20px;
  right: 0;
}

/*about-style-two*/
.about-area-two {
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.about-area-two.bg-image {
  /* background-image: url("/images/bg.jpg"); */
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.about-area-two .about-image .about-img1 {
  position: relative;
  right: 0;
  top: 0;
}
.about-area-two .about-image .btn {
  bottom: 0;
}
.about-area-two .about-content .signature {
  margin-bottom: 0;
}

/*about-style-three*/
.about-area-three {
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.about-area-three.bg-image {
  /* background-image: url("/images/bg.jpg"); */
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.about-area-three .about-image .about-img1 {
  position: relative;
  right: 0;
  top: 0;
}
.about-area-three .about-image .btn {
  bottom: 0;
  left: 70px;
  right: auto;
}
.about-area-three .about-content .signature {
  margin-bottom: 0;
}
.about-area-three .about-content h6 {
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 20px;
}
.about-area-three .about-content p {
  margin-bottom: 0;
}
.about-area-three .about-content ul {
  padding: 0;
  margin: 20px 0 0;
  list-style-type: none;
}
.about-area-three .about-content ul li {
  list-style-type: disc;
  margin-bottom: 10px;
  color: #ffffff;
  margin-left: 20px;
  position: relative;
}
.about-area-three .about-content ul li i {
  color: #ff2d55;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -7px;
}
.about-area-three .about-content ul li:last-child {
  margin-bottom: 0;
}

.about-tab {
  color: #ffffff !important;
  font-size: 16px !important;
  @media (min-width: 1600px) {
    font-size: 1.05vw !important;
  }
  /* @media only screen and (min-width: 600px) and (max-width: 993px) {
    min-height: 32vh !important;
  } */
}

.anticon .anticon-ellipsis {
  display: none;
}

.about-tab .ant-tabs-nav-wrap {
  justify-content: left;
}

.ant-tabs-top > .ant-tabs-nav::before {
  border-bottom: none !important;
}

.about-tab .ant-tabs-tab {
  color: #ffffff !important;
  font-size: 16px;
  @media (min-width: 1600px) {
    font-size: 1.05vw !important;
  }
}

.ant-tabs .ant-tabs-tab:hover {
  color: #ffffff !important;
}

.ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible) {
  color: #ffffff !important;
}

.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #f0592a !important;
}

.about-tab .ant-tabs-ink-bar::after {
  background: #f0592a !important;
  height: 2px !important;
  border-radius: 1px;
}

/*================================================
Why Choose Us CSS
=================================================*/
.why-choose-us {
  position: relative;
  z-index: 1;
}
.why-choose-us::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: #0d1028;
  opacity: 0.7;
}
.why-choose-us .slideshow {
  z-index: -1;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.why-choose-us .slideshow li span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  color: transparent;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  opacity: 0;
  z-index: 0;
  backface-visibility: hidden;
  animation: imageAnimation 24s linear infinite 0s;
}
.why-choose-us .slideshow li:nth-child(2) span {
  animation-delay: 6s;
}
.why-choose-us .slideshow li:nth-child(3) span {
  animation-delay: 12s;
}
.why-choose-us .slideshow li:nth-child(4) span {
  animation-delay: 18s;
}

.col-lg-3:first-child .single-box {
  border-left: none;
}

.single-box {
  position: relative;
  z-index: 1;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  height: 450px;
}
.single-box .d-table-cell {
  vertical-align: bottom;
}
.single-box .content {
  position: absolute;
  padding-left: 25px;
  padding-right: 25px;
  bottom: 0;
  left: 0;
  transition: 0.5s;
}
.single-box .content::before {
  content: "";
  position: absolute;
  bottom: 5px;
  width: 100%;
  max-width: 280px;
  text-align: center;
  height: 260px;
  left: 50%;
  margin-left: -155px;
  z-index: -1;
  border: 10px solid rgba(104, 89, 222, 0.03);
}
.single-box .content .icon {
  font-size: 45px;
  color: #ff2d55;
}
.single-box .content h3 {
  font-size: 26px;
  color: #ffffff;
  margin-top: 15px;
  margin-bottom: 15px;
}
.single-box .content p {
  color: #ffffff;
  margin-bottom: 0;
  transition: 0.5s;
}
.single-box .content .btn {
  opacity: 0;
  visibility: hidden;
}
.single-box:hover .content,
.single-box:focus .content {
  bottom: 35px;
}
.single-box:hover .content p,
.single-box:focus .content p {
  margin-bottom: 25px;
}
.single-box:hover .content .btn,
.single-box:focus .content .btn {
  opacity: 1;
  visibility: visible;
}

@keyframes imageAnimation {
  0% {
    opacity: 0;
    animation-timing-function: ease-in;
  }
  12.5% {
    opacity: 1;
    animation-timing-function: ease-out;
  }
  25% {
    opacity: 1;
  }
  37.5% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.no-cssanimations .slideshow li span {
  opacity: 1;
}

/*why-choose-style-two*/
.why-choose-us-two {
  max-width: 1920px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.why-choose-content {
  text-align: center;
  padding: 20px 25px;
  position: relative;
  z-index: 1;
}
.why-choose-content h3 {
  font-size: 24px;
  margin-bottom: 15px;
}
.why-choose-content p {
  margin-bottom: 0;
}
.why-choose-content a {
  color: #ff2d55;
  margin-top: 15px;
}
.why-choose-content a:hover,
.why-choose-content a:focus {
  letter-spacing: 1px;
}
.why-choose-content span {
  font-size: 100px;
  font-weight: 700;
  color: #f2f2f2;
  line-height: 90px;
  position: absolute;
  left: 0;
  right: 0;
  margin: -10px auto 0;
  z-index: -1;
  top: 0;
}

/*================================================
CTA CSS
=================================================*/
.cta-area {
  background-color: #ff2d55;
  padding-top: 50px;
  padding-bottom: 50px;
}
.cta-area span {
  display: block;
  color: #ffffff;
  font-size: 20px;
}
.cta-area h3 {
  color: #ffffff;
  font-size: 35px;
  margin-bottom: 10px;
}

/*================================================
Speakers CSS
=================================================*/
.single-speakers {
  overflow: hidden;
  position: relative;
}
.single-speakers::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(
    transparent 0%,
    transparent 40%,
    rgba(0, 0, 0, 0.3) 58%,
    rgba(0, 0, 0, 0.8) 89%,
    rgba(0, 0, 0, 0.63) 100%
  );
  width: 100%;
  height: 100%;
}
.single-speakers .speakers-content {
  position: absolute;
  bottom: 35px;
  left: 35px;
  transition: 0.5s;
}

.single-speakers .speakers-content h3 {
  font-size: 24px;
  margin-bottom: 0;
  color: #ff2d55;
}
.sponsors-row {
  @media (max-width: 520px) {
    margin-bottom: 20vw !important;
  }
}
.more-speakers-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  width: 100%;
  padding: 1vw;
  @media (max-width: 993px) {
    height: 100%;
    /* height: calc(100% + 8vh); */
  }
}

.more-speakers-content h3 {
  line-height: 200%;
  color: #ffffff;
  font-weight: 600;
  font-size: 32px !important;
  line-height: 150%;
  @media (min-width: 1600px) {
    font-size: 2vw !important;
  }
  @media (max-width: 991px) {
    font-size: 25px !important;
    margin-bottom: 20px;
  }
  @media (max-width: 768px) {
    font-size: 24px !important;
  }
}

.more-speakers-content h3 span {
  background: linear-gradient(180deg, #f15a2b, #e74860);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: bold;
}

.coming-soon-speakers {
  position: relative;
  z-index: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  @media (max-width: 993px) {
    height: 50vh;
  }
}
/* .coming-soon-speakers::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0.88;
} */
.coming-soon-speakers h3 {
  color: #fff !important;
  font-size: 32px;
  font-weight: 400;
  @media (min-width: 1600px) {
    font-size: 2vw !important;
  }

  @media (max-width: 767px) {
    font-size: 20px !important;
  }
}
.coming-soon-speakers h1 {
  font-size: 64px;
  font-weight: 900;
  color: #e74860 !important;
  @media (min-width: 1600px) {
    font-size: 4vw !important;
  }
  @media (max-width: 767px) {
    font-size: 36px !important;
  }
}

.single-speakers .speakers-content h3:hover,
.single-speakers .speakers-content h3:focus {
  color: #8dc63f;
}
.single-speakers .speakers-content span {
  display: block;
  margin-top: 6px;
  color: #ffffff;
  transition: 0.5s;
}
.single-speakers ul {
  padding: 15px;
  margin: 0 0 0;
  opacity: 0;
  visibility: hidden;
  list-style-type: none;
  transition: 0.5s;
  position: absolute;
  right: -15px;
  top: 0;
  background-color: #ffffff;
}
.single-speakers ul li {
  display: block;
  margin-bottom: 10px;
}
.single-speakers ul li:last-child {
  margin-bottom: 0;
}
.single-speakers ul li a {
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background-color: #ff2d55;
  color: #ffffff;
  border-radius: 50%;
  font-size: 14px;
}
.single-speakers ul li a.facebook {
  background-color: #4267b2;
}
.single-speakers ul li a.twitter {
  background-color: #38a1f3;
}
.single-speakers ul li a.instagram {
  background: radial-gradient(
      circle farthest-corner at 35% 90%,
      #fec564,
      transparent 50%
    ),
    radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),
    radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),
    radial-gradient(
      ellipse farthest-corner at 20% -50%,
      #5258cf,
      transparent 50%
    ),
    radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),
    radial-gradient(
      ellipse farthest-corner at 60% -20%,
      #893dc2,
      transparent 50%
    ),
    radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),
    linear-gradient(
      #6559ca,
      #bc318f 30%,
      #e33f5f 50%,
      #f77638 70%,
      #fec66d 100%
    );
}
.single-speakers ul li a.linkedin {
  background-color: #0077b5;
}
.single-speakers ul li a:hover,
.single-speakers ul li a:focus {
  background-color: #ff2d55;
  color: #ffffff;
}
.single-speakers:hover .speakers-content,
.single-speakers:focus .speakers-content {
  bottom: 45px;
}
.single-speakers:hover ul,
.single-speakers:focus ul {
  right: 0;
  opacity: 1;
  visibility: visible;
}

/*Speakers-Style-Two*/
.elkevent-single-speakers {
  overflow: hidden;
  position: relative;
  height: 100%;
  /* padding: 15px; */
  @media (max-width: 993px) {
    /* padding-bottom: 8vh; */
  }
}
.elkevent-single-speakers .speakers-content {
  position: absolute;
  bottom: -25px;
  left: 0;
  background-color: #ffffff;
  width: 100%;
  height: auto;
  padding: 25px;
  opacity: 0;
  visibility: hidden;
  transition: 0.5s;
  @media (max-width: 993px) {
    min-height: 10vh;
    bottom: 0 !important ;
    opacity: 1 !important;
    visibility: visible !important;
  }
}
.elkevent-single-speakers .speakers-content h3 {
  font-size: 24px;
  font-weight: 900 !important;
  color: #121d39;
  margin-bottom: 0;
  text-align: center;
  @media (min-width: 1600px) {
    font-size: 1.5vw;
  }
}
.elkevent-single-speakers .speakers-content h3 a {
  color: #121d39;
}
.elkevent-single-speakers .speakers-content h3 a:hover,
.elkevent-single-speakers .speakers-content h3 a:focus {
  color: #121d39;
}
.elkevent-single-speakers .speakers-content span {
  text-align: center;
  display: block;
  font-size: 16px;
  margin-top: 8px;
  color: #e74860;
  transition: 0.5s;
  @media (min-width: 1600px) {
    font-size: 1.05vw;
  }
}
.elkevent-single-speakers ul {
  padding: 15px 20px 10px;
  margin: 0 0 0;
  opacity: 0;
  visibility: hidden;
  list-style-type: none;
  transition: 0.5s;
  position: absolute;
  right: -15px;
  top: 0;
  background-color: #ffffff;
}
.elkevent-single-speakers ul li {
  display: block;
  margin-bottom: 5px;
}
.elkevent-single-speakers ul li a {
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background-color: #ff2d55;
  color: #ffffff;
  border-radius: 50%;
  font-size: 14px;
}
.elkevent-single-speakers ul li a.facebook {
  background-color: #4267b2;
}
.elkevent-single-speakers ul li a.twitter {
  background-color: #38a1f3;
}
.elkevent-single-speakers ul li a.instagram {
  background: radial-gradient(
      circle farthest-corner at 35% 90%,
      #fec564,
      transparent 50%
    ),
    radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),
    radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),
    radial-gradient(
      ellipse farthest-corner at 20% -50%,
      #5258cf,
      transparent 50%
    ),
    radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),
    radial-gradient(
      ellipse farthest-corner at 60% -20%,
      #893dc2,
      transparent 50%
    ),
    radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),
    linear-gradient(
      #6559ca,
      #bc318f 30%,
      #e33f5f 50%,
      #f77638 70%,
      #fec66d 100%
    );
}
.elkevent-single-speakers ul li a.linkedin {
  background-color: #0077b5;
}
.elkevent-single-speakers ul li a:hover,
.elkevent-single-speakers ul li a:focus {
  background-color: #ff2d55;
  color: #ffffff;
}
.elkevent-single-speakers img {
  transition: 0.5s;
  position: relative;
}
.elkevent-single-speakers:hover .speakers-content,
.elkevent-single-speakers:focus .speakers-content {
  bottom: 0;
  opacity: 1;
  visibility: visible;
}
.elkevent-single-speakers:hover ul,
.elkevent-single-speakers:focus ul {
  right: 0;
  opacity: 1;
  visibility: visible;
}
.elkevent-single-speakers:hover img,
.elkevent-single-speakers:focus img {
  transform: scale(1.1);
  filter: brightness(1) drop-shadow(0 0 10px rgba(255, 255, 255, 0.4));
  transition: transform 0.5s ease, filter 0.5s ease;
}

/*Speakers-style-three*/
.speakers-area {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.speakers-area-two {
  padding-bottom: 90px;
}

.single-speakers-box {
  margin-bottom: 30px;
  text-align: center;
  transition: 0.5s;
  box-shadow: 0 15px 20px 0 rgba(0, 0, 0, 0.06);
}
.single-speakers-box .speakers-content {
  background: #ffffff;
  padding: 30px 0;
  position: relative;
  transition: 0.5s;
}
.single-speakers-box .speakers-content::before {
  content: "";
  width: 0;
  height: 20px;
  color: #ffffff;
  background: #ff2d55;
  position: absolute;
  top: -20px;
  right: 0;
  transition: 0.5s;
}
.single-speakers-box .speakers-content h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #0d1028;
}
.single-speakers-box .speakers-content span {
  display: block;
  text-transform: capitalize;
  transition: 0.5s;
  color: #ff2d55;
}
.single-speakers-box .speakers-content .social {
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: absolute;
  top: -37px;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: scale(0);
  transition: 0.5s;
}
.single-speakers-box .speakers-content .social li {
  display: inline-block;
}
.single-speakers-box .speakers-content .social li a {
  display: block;
  width: 35px;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  color: #a0a0a0;
  margin-right: 10px;
  position: relative;
  z-index: 1;
}
.single-speakers-box .speakers-content .social li a:hover {
  color: #ffffff;
}
.single-speakers-box .speakers-content .social li a:hover::before {
  background: #00acee;
  color: #ffffff;
  transform: rotate(-45deg);
}
.single-speakers-box .speakers-content .social li a::before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff;
  transform: rotate(45deg);
  z-index: -1;
  transition: 0.5s;
}
.single-speakers-box:hover {
  box-shadow: 0 0 28px 0 rgba(6, 74, 255, 0.22);
}
.single-speakers-box:hover::before,
.single-speakers-box:hover::after {
  border-color: #ff2d55;
  transform: scale(1);
}
.single-speakers-box:hover .speakers-content {
  background: #ff2d55;
}
.single-speakers-box:hover .speakers-content::before {
  width: 100%;
}
.single-speakers-box:hover .speakers-content .social {
  transform: scale(1);
}
.single-speakers-box:hover .speakers-content h3,
.single-speakers-box:hover .speakers-content span {
  color: #ffffff;
}

/*================================================
Schedule CSS
=================================================*/
.agenda-top-area {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 40vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  @media (max-width: 993px) {
    height: 15vh !important;
  }
}
.coming-soon-speakers h1 {
  font-size: 64px;
  font-weight: 900;
  color: #e74860 !important;
}

.schedule-area {
  position: relative;
}
.schedule-area.bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.events-last-div {
  margin-bottom: 0;
}

.events-div {
  margin-bottom: 4vh;
  @media (max-width: 767px) {
    margin-bottom: 16px;
  }
}

.event-tabs {
  box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);
  margin: 60px 0 120px 0;
  @media (max-width: 767px) {
    margin: 30px 0 60px 0;
  }
}
.event-tabs .react-tabs__tab-list {
  border: none;
  margin: 0;
  display: flex;
  width: 100%;
  text-align: center;
}
.event-tabs .react-tabs__tab-list li {
  display: block;
  flex: 1 1;
  background-color: #ffffff;
  transition: 0.5s;
  position: relative;
  border: none;
  font-size: 28px;
  font-weight: 700;
  color: #121d39;
  text-transform: uppercase;
  padding: 25px 10px;
  border-radius: 5px 5px 0 0;
  @media (min-width: 1600px) {
    font-size: 1.5vw;
  }
}
.event-tabs .react-tabs__tab-list li::before {
  width: 30px;
  height: 30px;
  left: 0;
  bottom: -15px;
  position: absolute;
  background: #e74860;
  color: #253d77;
  content: "";
  transform: rotate(45deg);
  right: 0;
  margin: 0 auto;
  opacity: 0;
  visibility: hidden;
  transition: 0.5s;
}
.event-tabs .react-tabs__tab-list li span {
  display: block;
  font-size: 16px;
  text-transform: capitalize;
  margin-top: 5px;
  @media (min-width: 1600px) {
    font-size: 1.25vw;
    margin-top: 1.5vh;
  }
}
.event-tabs .react-tabs__tab-list li:focus::after {
  background-color: transparent;
}
/* .event-tabs .react-tabs__tab-list li:nth-child(2) {
  background-color: #E74860;
}
.event-tabs .react-tabs__tab-list li:nth-child(3) {
  background-color: #8dc63f;
}
.event-tabs .react-tabs__tab-list  {
  background-color: #efa506;
} */
.event-tabs .react-tabs__tab-list li.react-tabs__tab--selected {
  background-color: #e74860;
  color: #ffffff;
}
.event-tabs .react-tabs__tab-list li.react-tabs__tab--selected::before {
  opacity: 1;
  visibility: visible;
}
.event-tabs .react-tabs__tab-panel {
  padding: 30px;
  background-color: #f8f8f830;
}
.event-tabs .react-tabs__tab-panel .accordion {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: none;
}
.event-tabs .react-tabs__tab-panel .accordion .accordion__item {
  display: block;
  margin-bottom: 15px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background-color: #ffffff;
  border-radius: 10px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.event-tabs .react-tabs__tab-panel .accordion .accordion__item:hover {
  background-color: #121d39;
}

.event-tabs .react-tabs__tab-panel .accordion .accordion__item:last-child {
  margin-bottom: 0;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button {
  background-color: transparent;
  display: flex;
  position: relative;
  align-items: center !important;
  padding-left: 25px;
  padding-bottom: 35px;
  padding-top: 35px;
  @media (max-width: 767px) {
    padding-bottom: 0 !important;
  }
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button::before {
  display: none;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .author {
  max-width: 100px;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .author-multi {
  overflow: hidden;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .author-multi
  img {
  width: 47%;
  border-radius: 50%;
  margin-bottom: 0.2rem;
  margin-right: 1.5%;
  margin-left: 1.5%;
  margin-top: 0.2rem;
  float: left;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-info
  h3 {
  font-size: 36px;
  margin-bottom: 15px;
  text-transform: capitalize;
  color: #121d39;
  font-weight: 600;
  @media (min-width: 1600px) {
    font-size: 2.25vw;
  }
  @media (max-width: 767px) {
    font-size: 20px !important;
  }
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button:hover
  .schedule-info
  h3 {
  color: #e74860;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-info
  h4 {
  color: #121d39;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 15px;
  text-transform: capitalize;
  line-height: 140%;
  @media (min-width: 1600px) {
    font-size: 1.25vw;
  }
  @media (max-width: 767px) {
    font-size: 16px !important;
  }
}

.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button:hover
  .schedule-info
  h4 {
  color: #ffffff;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-time {
  color: #e74860 !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  display: flex;
  justify-content: right;
  @media (min-width: 1600px) {
    font-size: 1.25vw !important;
  }
  @media (max-width: 767px) {
    justify-content: center;
    font-size: 16px !important;
  }
}

.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item:hover
  .accordion__button
  .schedule-time {
  color: #ffffff !important;
}

.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-info
  ul {
  padding: 0;
  list-style-type: none;
  margin: 0;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-info
  ul
  li {
  display: inline-block;
  color: #707070;
  margin-right: 20px;
  font-size: 14px;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-info
  ul
  li:last-child {
  margin-right: 0;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-info
  ul
  li
  i {
  margin-right: 5px;
  color: #ff2d55;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .accordion__button
  .schedule-info
  ul
  li
  span {
  color: #00acee;
}
.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .schedule-desc
  p {
  color: #121d39 !important;
  font-size: 16px;
  @media (min-width: 1600px) {
    font-size: 1.05vw;
  }
  @media (max-width: 767px) {
    font-size: 14px;
    margin-top: 20px;
  }
  @media (max-width: 600px) {
    display: none;
  }
}

.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item:hover
  .schedule-desc
  p {
  color: #ffffff !important;
}

.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item
  .schedule-desc
  li {
  color: #e74860 !important;
  font-size: 1rem;
}

.event-tabs
  .react-tabs__tab-panel
  .accordion
  .accordion__item:hover
  .schedule-desc
  li {
  color: #e74860 !important;
}

.btn-box {
  text-align: center;
  margin-top: 50px;
}
.btn-box .btn {
  margin: 0 15px;
}

/*schedule-style-two*/
.schedule-slides-item .single-schedule {
  position: relative;
  background: #ffffff;
  text-align: center;
  padding: 0 0 0 200px;
}
.schedule-slides-item .single-schedule .schedule-date {
  font-size: 24px;
  color: #ffffff;
  background: #ff2d55;
  text-transform: uppercase;
  padding: 25px 40px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 200px;
}
.schedule-slides-item .single-schedule .schedule-date span {
  display: block;
  font-size: 15px;
  text-transform: capitalize;
  margin-top: 5px;
}
.schedule-slides-item .single-schedule .schedule-content {
  display: flex;
  align-items: center !important;
  border-bottom: 1px solid #eeeeee;
  padding: 20px;
  text-align: left;
}
.schedule-slides-item .single-schedule .schedule-content .author {
  max-width: 100px;
  margin-right: 25px;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(1) {
  clip-path: polygon(
    50% 0%,
    38.11% 6.7%,
    24.99% 6.72%,
    18.06% 18.44%,
    6.7% 25%,
    6.56% 38.64%,
    0% 50%,
    6.7% 61.89%,
    6.7% 75%,
    18.44% 81.94%,
    25% 93.3%,
    38.64% 93.44%,
    50% 100%,
    61.88% 93.3%,
    75% 93.3%,
    81.94% 81.56%,
    93.3% 74.9%,
    93.44% 61.36%,
    100% 50%,
    93.3% 38.11%,
    93.3% 25%,
    81.56% 18.06%,
    74.96% 6.7%,
    61.36% 6.56%,
    50% 0%
  );
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(2) {
  clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(3) {
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(4) {
  border-radius: 50%;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(5) {
  clip-path: polygon(
    50% 0%,
    90% 20%,
    100% 60%,
    75% 100%,
    25% 100%,
    0% 60%,
    10% 20%
  );
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(6) {
  clip-path: polygon(
    30% 0%,
    70% 0%,
    100% 30%,
    100% 70%,
    70% 100%,
    30% 100%,
    0% 70%,
    0% 30%
  );
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(7) {
  clip-path: polygon(
    50% 0%,
    83% 12%,
    100% 43%,
    94% 78%,
    68% 100%,
    32% 100%,
    6% 78%,
    0% 43%,
    17% 12%
  );
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(8) {
  clip-path: polygon(
    50% 0%,
    80% 10%,
    100% 35%,
    100% 70%,
    80% 90%,
    50% 100%,
    20% 90%,
    0% 70%,
    0% 35%,
    20% 10%
  );
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(9) {
  clip-path: circle(50% at 50% 50%);
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .author
  img:nth-child(10) {
  clip-path: polygon(
    50% 0%,
    90% 20%,
    100% 60%,
    75% 100%,
    25% 100%,
    0% 60%,
    10% 20%
  );
}
.schedule-slides-item .single-schedule .schedule-content .author-multi {
  overflow: hidden;
}
.schedule-slides-item .single-schedule .schedule-content .author-multi img {
  width: 47%;
  border-radius: 50%;
  margin-bottom: 0.4rem;
  margin-right: 3%;
  float: left;
}
.schedule-slides-item .single-schedule .schedule-content .schedule-info h3 {
  font-size: 20px;
  margin-bottom: 12px;
  @media (min-width: 1600px) {
    font-size: 1.25vw;
  }
}
.schedule-slides-item .single-schedule .schedule-content .schedule-info h3 a {
  color: #0d1028;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  h3
  a:hover,
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  h3
  a:focus {
  color: #ff2d55;
}
.schedule-slides-item .single-schedule .schedule-content .schedule-info ul {
  padding: 0;
  list-style-type: none;
  margin: 0;
}
.schedule-slides-item .single-schedule .schedule-content .schedule-info ul li {
  display: inline-block;
  color: #707070;
  margin-right: 20px;
  font-size: 14px;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  ul
  li:last-child {
  margin-right: 0;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  ul
  li
  i {
  margin-right: 6px;
  color: #ff2d55;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  ul
  li:last-child {
  margin-right: 0;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  ul
  li
  a {
  display: inline-block;
  color: #00acee;
}
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  ul
  li
  a:hover,
.schedule-slides-item
  .single-schedule
  .schedule-content
  .schedule-info
  ul
  li
  a:focus {
  color: #ff2d55;
}
.schedule-slides-item .single-schedule:nth-child(2) .schedule-date {
  background: #00acee;
}
.schedule-slides-item .single-schedule:nth-child(3) .schedule-date {
  background: #efa506;
}
.schedule-slides-item .single-schedule:nth-child(4) .schedule-date {
  background: #8dc63f;
}
.schedule-slides-item .single-schedule:nth-child(5) .schedule-date {
  background: #00acee;
}
.schedule-slides-item .single-schedule:nth-child(6) .schedule-date {
  background: #efa506;
}
.schedule-slides-item .single-schedule:nth-child(7) .schedule-date {
  background: #8dc63f;
}

.schedule-slides .swiper-button-next,
.schedule-slides .swiper-button-prev {
  color: #0d1028;
  transition: 0.5s;
}
.schedule-slides .swiper-button-next::after,
.schedule-slides .swiper-button-prev::after {
  font-size: 25px;
}
.schedule-slides .swiper-button-next:hover,
.schedule-slides .swiper-button-next:focus,
.schedule-slides .swiper-button-prev:hover,
.schedule-slides .swiper-button-prev:focus {
  color: #ff2d55;
}

/*schedule-style-three*/
.schedule-style-three {
  padding-bottom: 90px;
}
.schedule-style-three
  .col-lg-6:nth-child(2)
  .single-schedule-item
  .schedule-date {
  background-color: #00acee;
}
.schedule-style-three
  .col-lg-6:nth-child(3)
  .single-schedule-item
  .schedule-date {
  background-color: #efa506;
}
.schedule-style-three
  .col-lg-6:nth-child(4)
  .single-schedule-item
  .schedule-date {
  background-color: #8dc63f;
}
.schedule-style-three
  .col-lg-6:nth-child(5)
  .single-schedule-item
  .schedule-date {
  background-color: #00acee;
}
.schedule-style-three
  .col-lg-6:nth-child(6)
  .single-schedule-item
  .schedule-date {
  background-color: #efa506;
}
.schedule-style-three
  .col-lg-6:nth-child(7)
  .single-schedule-item
  .schedule-date {
  background-color: #8dc63f;
}

.single-schedule-item {
  text-align: center;
  margin-bottom: 30px;
  background-color: #ffffff;
  box-shadow: 0 15px 20px 0 rgba(0, 0, 0, 0.06);
}
.single-schedule-item .schedule-date {
  font-size: 24px;
  color: #ffffff;
  background: #ff2d55;
  text-transform: uppercase;
  padding: 20px;
}
.single-schedule-item .schedule-date span {
  display: block;
  font-size: 14px;
  text-transform: capitalize;
  margin-top: 5px;
}
.single-schedule-item .schedule-item-wrapper .schedule-content {
  display: flex;
  align-items: center !important;
  border-bottom: 1px solid #eeeeee;
  padding: 25px 20px;
  text-align: left;
}
.single-schedule-item .schedule-item-wrapper .schedule-content .author {
  max-width: 90px;
  margin-right: 20px;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(1) {
  clip-path: polygon(
    50% 0%,
    38.11% 6.7%,
    24.99% 6.72%,
    18.06% 18.44%,
    6.7% 25%,
    6.56% 38.64%,
    0% 50%,
    6.7% 61.89%,
    6.7% 75%,
    18.44% 81.94%,
    25% 93.3%,
    38.64% 93.44%,
    50% 100%,
    61.88% 93.3%,
    75% 93.3%,
    81.94% 81.56%,
    93.3% 74.9%,
    93.44% 61.36%,
    100% 50%,
    93.3% 38.11%,
    93.3% 25%,
    81.56% 18.06%,
    74.96% 6.7%,
    61.36% 6.56%,
    50% 0%
  );
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(2) {
  clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(3) {
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(4) {
  border-radius: 50%;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(5) {
  clip-path: polygon(
    50% 0%,
    90% 20%,
    100% 60%,
    75% 100%,
    25% 100%,
    0% 60%,
    10% 20%
  );
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(6) {
  clip-path: polygon(
    30% 0%,
    70% 0%,
    100% 30%,
    100% 70%,
    70% 100%,
    30% 100%,
    0% 70%,
    0% 30%
  );
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(7) {
  clip-path: polygon(
    50% 0%,
    83% 12%,
    100% 43%,
    94% 78%,
    68% 100%,
    32% 100%,
    6% 78%,
    0% 43%,
    17% 12%
  );
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(8) {
  clip-path: polygon(
    50% 0%,
    80% 10%,
    100% 35%,
    100% 70%,
    80% 90%,
    50% 100%,
    20% 90%,
    0% 70%,
    0% 35%,
    20% 10%
  );
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(9) {
  clip-path: circle(50% at 50% 50%);
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author
  img:nth-child(10) {
  clip-path: polygon(
    50% 0%,
    90% 20%,
    100% 60%,
    75% 100%,
    25% 100%,
    0% 60%,
    10% 20%
  );
}
.single-schedule-item .schedule-item-wrapper .schedule-content .author-multi {
  overflow: hidden;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .author-multi
  img {
  width: 47%;
  border-radius: 50%;
  margin-bottom: 0.4rem;
  margin-right: 3%;
  float: left;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  h3 {
  font-size: 18px;
  margin-bottom: 12px;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  h3
  a {
  color: #0d1028;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  h3
  a:hover,
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  h3
  a:focus {
  color: #ff2d55;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul {
  padding: 0;
  list-style-type: none;
  margin: 0;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul
  li {
  display: inline-block;
  color: #707070;
  margin-right: 20px;
  line-height: 1.9;
  font-size: 14px;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul
  li
  i {
  margin-right: 5px;
  color: #ff2d55;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul
  li
  .icofont-user-suited {
  margin-right: 8px;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul
  li:last-child {
  margin-right: 0;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul
  li
  a {
  display: inline-block;
  color: #00acee;
}
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul
  li
  a:hover,
.single-schedule-item
  .schedule-item-wrapper
  .schedule-content
  .schedule-info
  ul
  li
  a:focus {
  color: #ff2d55;
}
.single-schedule-item .schedule-item-wrapper .schedule-content:last-child {
  border-bottom: none;
}

/*schedule-style-four*/
.schedule-style-four .event-tabs {
  background-color: transparent;
  box-shadow: unset;
}
.schedule-style-four .react-tabs__tab-list {
  display: block;
}
.schedule-style-four .react-tabs__tab-list li::before {
  left: -15px;
  bottom: 37%;
  margin: 0 0 0;
  right: auto;
}
.schedule-style-four .tab_content {
  box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);
}

/*================================================
FunFacts CSS
=================================================*/
.funfacts-area {
  position: relative;
  z-index: 1;
  /* background-image: url("../assets/events_images/funfacts-bg.jpg"); */
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.funfacts-area::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #0d1028;
  opacity: 0.88;
}

.single-funfact {
  text-align: center;
}
.single-funfact .icon {
  color: #ffffff;
  font-size: 40px;
}
.single-funfact h3 {
  color: #ffffff;
  font-size: 55px;
  margin-top: 10px;
  margin-bottom: 8px;
}
.single-funfact p {
  color: #ffffff;
  letter-spacing: 1px;
  font-size: 16px;
  margin-bottom: 0;
  line-height: 1;
}

/*funfact-style-two*/
.funFact {
  position: relative;
  padding-left: 60px;
}
.funFact .icon {
  color: #ffffff;
  font-size: 40px;
  position: absolute;
  left: 0;
  top: 0;
}
.funFact h3 {
  color: #ffffff;
  font-size: 55px;
  margin-top: 0;
  margin-bottom: 8px;
}
.funFact p {
  color: #ffffff;
  letter-spacing: 1px;
  font-size: 16px;
  margin-bottom: 0;
  line-height: 1;
}

.col-lg-3:nth-child(1) .single-funfact h3,
.col-lg-3:nth-child(1) .funFact h3 {
  color: #ff2d55;
}
.col-lg-3:nth-child(2) .single-funfact h3,
.col-lg-3:nth-child(2) .funFact h3 {
  color: #00acee;
}
.col-lg-3:nth-child(3) .single-funfact h3,
.col-lg-3:nth-child(3) .funFact h3 {
  color: #efa506;
}
.col-lg-3:nth-child(4) .single-funfact h3,
.col-lg-3:nth-child(4) .funFact h3 {
  color: #8dc63f;
}

/*================================================
Pricing CSS
=================================================*/
.pricing-area {
  position: relative;
  z-index: 1;
}
.pricing-area.bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.pricing-table-box {
  padding-bottom: 30px;
  background: #ffffff;
  text-align: center;
  z-index: 1;
  position: relative;
  border-radius: 5px;
  /* background-image: url("/images/patt.png"); */
  background-position: center center;
  overflow: hidden;
  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);
  transition: 0.5s;
}
.pricing-table-box .pricingTable-header {
  padding: 30px 15px 10px;
  background: #ff2d55;
  clip-path: polygon(50% 100%, 100% 60%, 100% 0, 0 0, 0 60%);
  position: relative;
}
.pricing-table-box .pricingTable-header::before {
  content: "";
  width: 400px;
  height: 400px;
  border-radius: 50%;
  position: absolute;
  right: -50%;
  top: -130%;
  background: repeating-radial-gradient(
    rgba(255, 255, 255, 0.04),
    rgba(255, 255, 255, 0.17) 20%
  );
  transition: 0.5s;
}
.pricing-table-box .title {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
  margin-bottom: 15px;
}
.pricing-table-box .price-value {
  display: block;
  font-size: 55px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 30px;
}
.pricing-table-box .price-value sup {
  font-size: 23px;
  top: -25px;
}
.pricing-table-box .pricing-content {
  padding: 35px 0;
  margin-bottom: 0;
  list-style-type: none;
}
.pricing-table-box .pricing-content li {
  color: #707070;
  text-transform: capitalize;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 12px;
  padding-bottom: 12px;
}
.pricing-table-box .pricing-content li:last-child {
  margin-bottom: 0;
}
.pricing-table-box .pricing-content li:first-child {
  border-top: 1px solid #eeeeee;
  padding-top: 12px;
}
.pricing-table-box:hover,
.pricing-table-box:focus,
.pricing-table-box.active {
  transform: translateY(-10px);
}
.pricing-table-box:hover .pricingTable-header::before,
.pricing-table-box:focus .pricingTable-header::before,
.pricing-table-box.active .pricingTable-header::before {
  right: 50%;
}

/*pricing-style-two*/
.pricing-plan {
  position: relative;
  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);
  text-align: center;
  padding-bottom: 30px;
  transition: 0.5s;
  background-color: #ffffff;
}
.pricing-plan h3 {
  font-size: 24px;
  padding: 30px 15px;
  margin-bottom: 100px;
  background-color: #ff2d55;
  color: #ffffff;
  transition: 0.5s;
}
.pricing-plan h3 span {
  display: block;
  color: #ff2d55;
  background: #ffffff;
  height: 150px;
  width: 150px;
  line-height: 155px;
  font-size: 35px;
  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);
  margin: 30px auto -95px;
  border-radius: 50%;
  transition: 0.5s;
}
.pricing-plan h3 span sup {
  font-weight: 500;
}
.pricing-plan .pricing-content {
  padding: 0 0 35px;
  margin-bottom: 0;
  list-style-type: none;
}
.pricing-plan .pricing-content li {
  color: #707070;
  text-transform: capitalize;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 12px;
  padding-bottom: 12px;
}
.pricing-plan .pricing-content li:last-child {
  margin-bottom: 0;
}
.pricing-plan .pricing-content li:first-child {
  border-top: 1px solid #eeeeee;
  padding-top: 12px;
}
.pricing-plan:hover,
.pricing-plan:focus {
  transform: translateY(-8px);
}

.col-lg-4:nth-child(2) .pricing-table-box .pricingTable-header {
  background: #00acee;
}
.col-lg-4:nth-child(2) .pricing-table-box .btn-primary::before,
.col-lg-4:nth-child(2) .pricing-table-box .btn-primary::after {
  background: #00acee;
}
.col-lg-4:nth-child(2) .pricing-plan h3 {
  background: #00acee;
}
.col-lg-4:nth-child(2) .pricing-plan h3 span {
  color: #00acee;
}
.col-lg-4:nth-child(2) .pricing-plan .btn-primary::before,
.col-lg-4:nth-child(2) .pricing-plan .btn-primary::after {
  background: #00acee;
}
.col-lg-4:nth-child(3) .pricing-table-box .pricingTable-header {
  background: #8dc63f;
}
.col-lg-4:nth-child(3) .pricing-table-box .btn-primary::before,
.col-lg-4:nth-child(3) .pricing-table-box .btn-primary::after {
  background: #8dc63f;
}
.col-lg-4:nth-child(3) .pricing-plan h3 {
  background: #8dc63f;
}
.col-lg-4:nth-child(3) .pricing-plan h3 span {
  color: #8dc63f;
}
.col-lg-4:nth-child(3) .pricing-plan .btn-primary::before,
.col-lg-4:nth-child(3) .pricing-plan .btn-primary::after {
  background: #8dc63f;
}

/*================================================
Partner CSS
=================================================*/
.partner-area {
  overflow: hidden;
  background-color: #ffffff;
}
.partner-section-title h2 {
  color: #121d39;
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 10px;
  text-align: center;
  text-transform: uppercase;
  @media (min-width: 1600px) {
    font-size: 1.75vw;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
}
.partner-section-title h1 {
  font-size: 52px;
  padding-bottom: 24px;
  text-align: center;
  background: linear-gradient(180deg, #f15a2b, #e74860);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0;
  border-bottom: 1px solid #d1d1d1;
  @media (min-width: 1600px) {
    font-size: 3.25vw;
  }

  @media (max-width: 767px) {
    font-size: 36px;
  }
}

.diamond-sponsors {
  background: linear-gradient(180deg, #d9317a, #e74860);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  padding-top: 30px;
  text-align: center;
  text-transform: uppercase;
  @media (min-width: 1600px) {
    font-size: 1.75vw;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.platinum-sponsors {
  background: linear-gradient(180deg, #00acee, #121d39);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  padding: 30px 0;
  text-align: center;
  /* border-bottom: 1px solid #d1d1d1; */
  text-transform: uppercase;
  @media (min-width: 1600px) {
    font-size: 1.75vw;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.platinum-sponsors span {
  color: #121d39;
  font-size: 20px;
  font-weight: 400;
  margin: 0;
  text-align: center;
  text-transform: capitalize;
  @media (min-width: 1600px) {
    font-size: 1.5vw;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.gold-sponsors {
  background: linear-gradient(180deg, #c6b23f, #f15a2b);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  /* padding: 30px 0; */
  /* border-bottom: 1px solid #d1d1d1; */
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  @media (min-width: 1600px) {
    font-size: 1.75vw;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.silver-sponsors {
  background: linear-gradient(180deg, #a8a9ab, #838989);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 28px;
  font-weight: 600;
  margin: 30px 0 0 0;
  text-align: center;
  text-transform: uppercase;
  @media (min-width: 1600px) {
    font-size: 1.75vw;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.other-sponsors span {
  color: #121d39;
  font-size: 20px;
  font-weight: 400;
  margin: 0;
  text-align: center;
  text-transform: capitalize;
  @media (min-width: 1600px) {
    font-size: 1.5vw;
  }
  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.partners-col {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
  padding: 1vw;
  @media (max-width: 767px) {
    width: 50%;
  }
  /* @media (max-width: 575px) {
    width: 100%;
  } */
}

.partners-img {
  width: 100%;
  border-radius: 8px;
  transition: box-shadow 0.3s ease-in-out;
}

.partners-img:hover {
  box-shadow: 4px 4px 4px 4px #d8dde6;
}

.partner-area .partner-title {
  text-align: center;
  margin-bottom: 50px;
}
.partner-area .partner-title h3 {
  font-size: 24px;
  font-weight: 900;
  margin-bottom: 0;
  color: #ff2d55;
  text-transform: uppercase;
  transform: translateX(0) !important;
}
.partner-area .partner-title.gold-sponsor h3 {
  color: #8dc63f;
}
.partner-area .partner-item {
  text-align: center;
}
.partner-area .partner-item a {
  position: relative;
}
.partner-area .partner-item a img {
  width: unset !important;
  display: inline-block !important;
}
.partner-area .partner-item a img:last-child {
  position: absolute;
  left: 0;
  top: 30px;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  visibility: hidden;
  transition: 0.5s;
}
.partner-area .partner-item:hover a img:last-child {
  opacity: 1;
  visibility: visible;
  top: 0;
}
.partner-area .border {
  border: 0.3px solid #eeeeee !important;
  margin-top: 40px;
  margin-bottom: 40px;
}

/*================================================
Blog CSS
=================================================*/
.blog-area {
  position: relative;
  z-index: 1;
}
.blog-area.bg-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.single-blog-post {
  margin-bottom: 30px;
  background-color: #ffffff;
  box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.06);
}
.single-blog-post .blog-image {
  position: relative;
  overflow: hidden;
}
.single-blog-post .blog-image a {
  display: block;
}
.single-blog-post .blog-image a img {
  transition: 0.5s;
}
.single-blog-post .blog-image .post-tag {
  position: absolute;
  right: 0;
  top: 60px;
  transition: 0.5s;
}
.single-blog-post .blog-image .post-tag a {
  background: #ff2d55;
  color: #ffffff;
  padding: 9px 28px;
}
.single-blog-post .blog-post-content {
  padding: 25px;
}
.single-blog-post .blog-post-content .date {
  color: #8dc63f;
  display: block;
  text-transform: uppercase;
  font-size: 14px;
  transition: 0.5s;
}
.single-blog-post .blog-post-content h3 {
  margin-top: 13px;
  margin-bottom: 15px;
  line-height: 30px;
  font-size: 22px;
}
.single-blog-post .blog-post-content h3 a {
  color: #0d1028;
}
.single-blog-post .blog-post-content h3 a:hover,
.single-blog-post .blog-post-content h3 a:focus {
  color: #ff2d55;
}
.single-blog-post .blog-post-content p {
  margin-bottom: 15px;
}
.single-blog-post .read-more-btn {
  position: relative;
  font-weight: 500;
  color: #ff2d55;
}
.single-blog-post .read-more-btn:hover {
  color: #00acee;
  letter-spacing: 1px;
}
.single-blog-post:hover .blog-image a img,
.single-blog-post:focus .blog-image a img {
  transform: scale(1.2);
}
.single-blog-post:hover .blog-image .post-tag,
.single-blog-post:focus .blog-image .post-tag {
  top: 70px;
}
.single-blog-post:hover .blog-image .post-tag a,
.single-blog-post:focus .blog-image .post-tag a {
  background: #8dc63f;
  color: #ffffff;
}

.blog-slides .swiper-pagination {
  position: sticky;
}
.blog-slides .swiper-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
}
.blog-slides
  .swiper-pagination
  .swiper-pagination-bullet.swiper-pagination-bullet-active,
.blog-slides .swiper-pagination .swiper-pagination-bullet:hover {
  background-color: #ff2d55;
}

/*blog-style-two*/
.blog-section {
  padding-bottom: 90px;
}

.single-blog-card {
  position: relative;
  margin-bottom: 30px;
}
.single-blog-card > a {
  display: block;
}
.single-blog-card > a img {
  width: 100%;
}
.single-blog-card::before {
  opacity: 0.6;
  background: #0d1028;
  content: "";
  height: 100%;
  bottom: 0;
  left: 0;
  z-index: 1;
  right: 0;
  position: absolute;
  width: 100%;
}
.single-blog-card .post-tag {
  position: absolute;
  right: 0;
  top: 30px;
  transition: 0.5s;
  z-index: 2;
}
.single-blog-card .post-tag a {
  background: #ff2d55;
  color: #ffffff;
  padding: 9px 28px;
}
.single-blog-card .blog-post-content {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 20px 30px 0;
  transition: 0.5s;
  z-index: 2;
}
.single-blog-card .blog-post-content h3 {
  font-size: 22px;
  margin-bottom: 15px;
  line-height: 1.5;
}
.single-blog-card .blog-post-content h3 a {
  color: #ffffff;
}
.single-blog-card .blog-post-content h3 a:hover,
.single-blog-card .blog-post-content h3 a:focus {
  color: #ff2d55;
}
.single-blog-card .blog-post-content p {
  color: #ffffff;
}
.single-blog-card .blog-post-content .read-more-btn {
  position: relative;
  font-weight: 500;
  opacity: 0;
  visibility: hidden;
  color: #ff2d55;
}
.single-blog-card .blog-post-content .read-more-btn:hover {
  color: #00acee;
  letter-spacing: 1px;
}
.single-blog-card:hover .post-tag,
.single-blog-card:focus .post-tag {
  top: 40px;
}
.single-blog-card:hover .post-tag a,
.single-blog-card:focus .post-tag a {
  background: #8dc63f;
  color: #ffffff;
}
.single-blog-card:hover .blog-post-content,
.single-blog-card:focus .blog-post-content {
  padding-bottom: 30px;
}
.single-blog-card:hover .blog-post-content .read-more-btn,
.single-blog-card:focus .blog-post-content .read-more-btn {
  opacity: 1;
  visibility: visible;
}

/*================================================
Buy Tickets CSS
=================================================*/
.buy-tickets-area {
  position: relative;
  z-index: 1;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.buy-tickets-area::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #0d1028;
  opacity: 0.88;
}
.buy-tickets-area.ptb-120 {
  padding-bottom: 200px;
}

.buy-tickets .section-title {
  margin-bottom: 0;
}
.buy-tickets .section-title h2 {
  color: #ffffff;
}
.buy-tickets .section-title p {
  color: #ffffff;
  margin: 0;
}
.buy-tickets .buy-ticket-btn {
  text-align: right;
}

/*================================================
Subscribe CSS
=================================================*/
.subscribe-area {
  text-align: center;
  position: absolute;
  z-index: 2;
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  @media (min-width: 2560px) {
    top: -10vh;
  }
  @media (max-width: 767px) {
    margin-top: 5rem;
  }
  @media (max-width: 500px) {
    width: 90%;
  }
}

.form-mobile-view{
  @media (max-width: 767px) {
    margin-top: 4rem;
  }
}

.subscribe-area::before {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 72%;
  content: "";
  z-index: -1;
}
.subscribe-area .subscribe-inner {
  padding: 20px 50px;
  transform: unset !important;
  background: linear-gradient(60deg, #e74860, #f15a2b);
  background-repeat: no-repeat;
}
.subscribe-area .subscribe-inner p {
  color: #121d39;
  font-size: 20px;
  letter-spacing: 1px;
  display: block;
  text-transform: uppercase;
  margin-bottom: 0 !important;
  @media (min-width: 1600px) {
    font-size: 1.25vw;
  }
}
.subscribe-area .subscribe-inner p span {
  color: #ffffff;
  text-transform: capitalize !important;
}

.learn-about-us a {
  color: #ffffff !important;
  font-size: 20px !important;
  margin-top: 12px;
  display: block;
  @media (min-width: 1600px) {
    font-size: 1.25vw !important;
  }
}

.subscribe-area .subscribe-inner h2 a {
  font-size: 36px;
  margin-top: 12px;
  margin-bottom: 12px;
  color: #ffffff !important;
  text-decoration: none !important;
  @media (min-width: 1600px) {
    font-size: 2vw;
  }
}
.subscribe-area .subscribe-inner .newsletter-form {
  max-width: 650px;
  position: relative;
  margin: 12px auto 24px;
}
.subscribe-area .subscribe-inner .newsletter-form .form-control {
  border: none;
  height: 60px;
  box-shadow: 0 8px 6px -6px rgba(50, 51, 51, 0.4);
}
.subscribe-area .subscribe-inner .newsletter-form .btn {
  position: absolute;
  right: 0;
  top: 0;
  text-transform: uppercase;
  height: 60px;
}
.subscribe-area .subscribe-inner .newsletter-form .btn:after,
.subscribe-area .subscribe-inner .newsletter-form .btn::before {
  background: #121d39;
}

/*================================================
Page Title CSS
=================================================*/
.page-title-area {
  position: relative;
  z-index: 1;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  padding-top: 250px;
  padding-bottom: 180px;
}
.page-title-area::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #0d1028;
  opacity: 0.88;
}
.page-title-area h1 {
  color: #ffffff;
  margin-bottom: 0;
  text-transform: uppercase;
  font-size: 40px;
}
.page-title-area span {
  display: block;
  color: #ffffff;
  margin-top: 10px;
  font-size: 17px;
}
.page-title-area ul {
  padding: 0;
  margin: 12px 0 0;
  list-style-type: none;
}
.page-title-area ul li {
  display: inline-block;
  position: relative;
  color: #ff2d55;
  font-size: 16px;
  margin: 0 13px;
}
.page-title-area ul li a {
  color: #ffffff;
}
.page-title-area ul li a:hover,
.page-title-area ul li a:focus {
  color: #00acee;
}
.page-title-area ul li::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 50%;
  width: 2px;
  height: 15px;
  background: #efa506;
  margin-top: -9px;
  transform: rotate(10deg);
}
.page-title-area ul li:first-child {
  margin-left: 0;
}
.page-title-area ul li:first-child::before {
  display: none;
}
.page-title-area ul li:last-child {
  margin-right: 0;
}

/*================================================
Login CSS
=================================================*/
.login-area {
  height: 100vh;
  position: relative;
  z-index: 100000;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.login-area::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #ff2d55;
  opacity: 0.77;
}
.login-area .login-form {
  max-width: 540px;
  background: #ffffff;
  margin: 0 auto;
}
.login-area .login-form h3 {
  background: #00acee;
  padding: 30px 0 25px;
  font-size: 24px;
  margin-bottom: 0;
  color: #ffffff;
  text-align: center;
  text-transform: uppercase;
}
.login-area .login-form form {
  padding: 35px;
}
.login-area .login-form form label {
  font-weight: 500;
}
.login-area .login-form form .form-control {
  background: transparent;
  font-size: 13px;
}
.login-area .login-form .btn {
  display: block;
  width: 100%;
  margin-top: 20px;
}
.login-area .login-form p {
  overflow: hidden;
  margin-bottom: 0;
  margin-top: 20px;
}
.login-area .login-form p a {
  color: #0d1028;
  font-weight: 600;
}
.login-area .login-form p a:hover,
.login-area .login-form p a:focus {
  color: #ff2d55;
}
.login-area .login-form p a.pull-left {
  float: left;
}
.login-area .login-form p a.pull-right {
  float: right;
}

/*================================================
Signup CSS
=================================================*/
.signup-area {
  height: 100vh;
  position: relative;
  z-index: 10000;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.signup-area::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #ff2d55;
  opacity: 0.77;
}
.signup-area .signup-form {
  max-width: 540px;
  background: #ffffff;
  margin: 0 auto;
}
.signup-area .signup-form h3 {
  background: #00acee;
  padding: 30px 0 25px;
  font-size: 24px;
  margin-bottom: 0;
  color: #ffffff;
  text-align: center;
  text-transform: uppercase;
}
.signup-area .signup-form form {
  padding: 35px;
}
.signup-area .signup-form form label {
  font-weight: 500;
}
.signup-area .signup-form form .form-control {
  background: transparent;
  font-size: 13px;
}
.signup-area .signup-form .btn {
  display: block;
  width: 100%;
  margin-top: 20px;
}
.signup-area .signup-form p {
  text-align: center;
  color: #0d1028;
  margin-bottom: 0;
  margin-top: 20px;
}
.signup-area .signup-form p a {
  color: #0d1028;
  display: inline-block;
  font-weight: 600;
}
.signup-area .signup-form p a:hover,
.signup-area .signup-form p a:focus {
  color: #ff2d55;
}

/*================================================
404 Error CSS
=================================================*/
.error-area {
  background-color: #f1f1f1;
  padding: 30px 15px;
  height: 100vh;
  text-align: center;
  z-index: 10000;
  position: relative;
}
.error-area h1 {
  font-size: 150px;
  font-weight: bold;
  line-height: 110px;
  margin: 0;
  color: #ff2d55;
}
.error-area h1 span {
  color: #efa506;
}
.error-area h1 b {
  font-weight: unset;
  color: #8dc63f;
}
.error-area h3 {
  margin: 35px 0 15px;
}
.error-area p {
  margin: 10px 0 20px;
}

/*================================================
FAQ CSS
=================================================*/
.faq-accordion {
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
  padding: 60px;
  background: #ffffff;
  border-radius: 10px;
}
.faq-accordion .accordion {
  border: none;
  border-radius: 0;
}
.faq-accordion .accordion__item {
  margin-bottom: 15px;
}
.faq-accordion .accordion__item .accordion__button {
  background-color: #ffffff;
  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);
  color: #0d1028;
  outline: 0;
  font-weight: 600;
  font-size: 18px;
}
.faq-accordion .accordion__item:last-child {
  margin-bottom: 0;
}
.faq-accordion .accordion__item + .accordion__item {
  border: none;
}

.faq-contact {
  margin-top: 45px;
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
  padding: 60px;
  text-align: center;
  border-radius: 4px;
}
.faq-contact h3 {
  font-size: 25px;
  margin-bottom: 35px;
}
.faq-contact .form-group {
  margin-bottom: 25px;
}
.faq-contact .form-control {
  background-color: #f5f5f5;
}

/*================================================
Coming Soon CSS
=================================================*/
.coming-soon {
  position: relative;
  z-index: 1000;
  height: 100vh;
  text-align: center;
  /* background-image: url("../assets/events_images/main-bg3.jpg"); */
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
}
.coming-soon::before {
  z-index: -1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #0d1028;
  opacity: 0.66;
  position: absolute;
  content: "";
}
.coming-soon .coming-soon-content {
  max-width: 650px;
  margin: 0 auto;
}
.coming-soon .coming-soon-content h1 {
  color: #ffffff;
  font-size: 45px;
  text-transform: uppercase;
  margin-bottom: 0;
  line-height: 57px;
}
.coming-soon .coming-soon-content p {
  color: #c7c3c7;
  margin-top: 20px;
  margin-bottom: 35px;
}
.coming-soon .coming-soon-content form {
  position: relative;
}
.coming-soon .coming-soon-content form .form-control {
  background: transparent;
  border: 1px solid #ffffff;
  border-radius: 50px;
  color: #ffffff;
  height: 55px;
  padding-left: 20px;
}
.coming-soon .coming-soon-content form .form-control:focus,
.coming-soon .coming-soon-content form .form-control:hover {
  border-color: #ff2d55;
}
.coming-soon .coming-soon-content form .form-control::placeholder {
  color: #c7c3c7;
}
.coming-soon .coming-soon-content form button {
  position: absolute;
  right: -1px;
  height: 100%;
  background: #ff2d55;
  top: 0;
  color: #ffffff;
  border: none;
  width: 130px;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 500;
  border-radius: 0 50px 50px 0;
  transition: 0.5s;
  outline: 0 !important;
  border: none;
}
.coming-soon .coming-soon-content form button:hover,
.coming-soon .coming-soon-content form button:focus {
  background: #00acee;
}
.coming-soon .coming-soon-content #timer {
  margin-bottom: 35px;
}
.coming-soon .coming-soon-content #timer div {
  display: inline-block;
  font-size: 45px;
  font-weight: 700;
  color: #ffffff;
  width: 135px;
  height: 135px;
  border: 1px solid #eeeeee;
  border-radius: 50%;
  padding-top: 34px;
  line-height: 40px;
  margin: 0 10px;
}
.coming-soon .coming-soon-content #timer span {
  display: block;
  font-size: 16px;
  font-weight: 400;
}

/*================================================
Pagination CSS
=================================================*/
.pagination-area {
  margin-top: 30px;
}
.pagination-area ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.pagination-area ul li a {
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0 5px;
  background-color: #ffffff;
  border-radius: 0 !important;
  text-align: center;
  line-height: 40px;
  color: #0d1028;
  font-size: 17px;
  font-weight: 500;
  box-shadow: 0 2px 10px 0 #d8dde6;
  border: none;
}
.pagination-area ul li a.active,
.pagination-area ul li a:hover,
.pagination-area ul li a:focus {
  background: #ff2d55;
  color: #ffffff;
  box-shadow: unset;
}

/*================================================
Blog Details CSS
=================================================*/
.blog-details .post-image {
  margin-bottom: 35px;
}
.blog-details h3 {
  font-size: 25px;
  margin-top: 5px;
  margin-bottom: 15px;
}
.blog-details .blog-meta ul {
  padding: 0;
  margin: 15px 0;
  list-style-type: none;
}
.blog-details .blog-meta ul li {
  display: inline-block;
  position: relative;
  color: #707070;
  font-size: 14px;
  margin-left: 9px;
  margin-right: 9px;
}
.blog-details .blog-meta ul li i {
  margin-right: 4px;
  color: #ff2d55;
}
.blog-details .blog-meta ul li::before {
  width: 2px;
  height: 14px;
  background: #707070;
  left: -10px;
  top: 50%;
  position: absolute;
  content: "";
  margin-top: -6px;
  transform: rotate(11deg);
}
.blog-details .blog-meta ul li a {
  display: inline-block;
  color: #707070;
}
.blog-details .blog-meta ul li a:hover,
.blog-details .blog-meta ul li a:focus {
  color: #00acee;
}
.blog-details .blog-meta ul li:last-child {
  margin-right: 0;
}
.blog-details .blog-meta ul li:first-child {
  margin-left: 0;
}
.blog-details .blog-meta ul li:first-child::before {
  display: none;
}
.blog-details p {
  margin-top: 15px;
  margin-bottom: 0;
}
.blog-details p:last-child {
  margin-bottom: 0;
}
.blog-details blockquote,
.blog-details .blockquote {
  background: #f6f6f6 none repeat scroll 0 0;
  padding: 35px 20px 35px 100px;
  position: relative;
  margin-top: 25px;
  margin-bottom: 25px;
}
.blog-details blockquote::before,
.blog-details .blockquote::before {
  font-family: IcoFont !important;
  position: absolute;
  content: "\\efcd";
  left: 25px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 55px;
  color: #ff2d55;
}
.blog-details blockquote p,
.blog-details .blockquote p {
  color: #0d1028;
  font-style: italic;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.post-tag-media {
  background-color: #f5f7fb;
  padding: 20px;
  margin-top: 25px;
  margin-bottom: 35px;
}
.post-tag-media ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.post-tag-media ul li {
  display: inline-block;
}
.post-tag-media ul li span {
  font-weight: 600;
  margin-right: 5px;
  display: inline-block;
}
.post-tag-media ul li a {
  color: #707070;
  margin-right: 4px;
}
.post-tag-media ul li a:hover,
.post-tag-media ul li a:focus {
  color: #ff2d55;
}
.post-tag-media ul.social-share {
  text-align: right;
}
.post-tag-media ul.social-share li {
  padding-left: 5px;
}

.comments-area .comments-title,
.comments-area .comment-reply-title {
  font-size: 22px;
  margin-bottom: 25px;
}
.comments-area .comment-reply-title {
  margin-bottom: 8px;
}
.comments-area ol,
.comments-area ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.comments-area ol li ol li,
.comments-area ol li ul li,
.comments-area ul li ol li,
.comments-area ul li ul li {
  margin-top: 15px;
  margin-left: 35px;
  margin-bottom: 15px;
}
.comments-area ol li .comment-body,
.comments-area ul li .comment-body {
  background: #f7f7ff;
  padding: 25px 20px;
  position: relative;
}
.comments-area ol li .comment-body .comment-meta,
.comments-area ul li .comment-body .comment-meta {
  position: relative;
  padding-left: 85px;
  padding-top: 8px;
}
.comments-area ol li .comment-body .comment-meta .comment-author img,
.comments-area ul li .comment-body .comment-meta .comment-author img {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
  max-width: 68px;
}
.comments-area ol li .comment-body .comment-meta .comment-author .fn,
.comments-area ul li .comment-body .comment-meta .comment-author .fn {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  display: block;
}
.comments-area ol li .comment-body .comment-meta .comment-author .says,
.comments-area ul li .comment-body .comment-meta .comment-author .says {
  display: none;
}
.comments-area ol li .comment-body .comment-meta .comment-metadata a,
.comments-area ul li .comment-body .comment-meta .comment-metadata a {
  display: inline-block;
  color: #707070;
  font-size: 14px;
}
.comments-area ol li .comment-body .comment-meta .comment-metadata a:hover,
.comments-area ol li .comment-body .comment-meta .comment-metadata a:focus,
.comments-area ul li .comment-body .comment-meta .comment-metadata a:hover,
.comments-area ul li .comment-body .comment-meta .comment-metadata a:focus {
  color: #ff2d55;
}
.comments-area ol li .comment-body .comment-content,
.comments-area ul li .comment-body .comment-content {
  margin-top: 25px;
}
.comments-area ol li .comment-body .reply,
.comments-area ul li .comment-body .reply {
  position: absolute;
  right: 30px;
  top: 30px;
}
.comments-area ol li .comment-body .reply a,
.comments-area ul li .comment-body .reply a {
  display: inline-block;
  background: #0d1028;
  padding: 5px 15px;
  color: #ffffff;
}
.comments-area ol li .comment-body .reply a:hover,
.comments-area ol li .comment-body .reply a:focus,
.comments-area ul li .comment-body .reply a:hover,
.comments-area ul li .comment-body .reply a:focus {
  background: #ff2d55;
}
.comments-area .comment-respond {
  margin-top: 30px;
}
.comments-area .comment-respond .comment-notes {
  font-size: 14px;
  margin-bottom: 20px;
}
.comments-area .comment-respond .comment-form p {
  margin-bottom: 25px;
}
.comments-area .comment-respond .comment-form-comment input,
.comments-area .comment-respond .comment-form-comment textarea,
.comments-area .comment-respond .comment-form-author input,
.comments-area .comment-respond .comment-form-author textarea,
.comments-area .comment-respond .comment-form-email input,
.comments-area .comment-respond .comment-form-email textarea,
.comments-area .comment-respond .comment-form-url input,
.comments-area .comment-respond .comment-form-url textarea {
  display: block;
  width: 100%;
  height: 50px;
  background-color: #f5f5f5;
  outline: 0 !important;
  box-shadow: unset !important;
  border: 1px solid #eeeeee;
  padding: 10px 20px;
  border-radius: 6px;
  transition: 0.5s;
}
.comments-area .comment-respond .comment-form-comment input:focus,
.comments-area .comment-respond .comment-form-comment textarea:focus,
.comments-area .comment-respond .comment-form-author input:focus,
.comments-area .comment-respond .comment-form-author textarea:focus,
.comments-area .comment-respond .comment-form-email input:focus,
.comments-area .comment-respond .comment-form-email textarea:focus,
.comments-area .comment-respond .comment-form-url input:focus,
.comments-area .comment-respond .comment-form-url textarea:focus {
  border-color: #ff2d55;
}
.comments-area .comment-respond .comment-form-comment textarea,
.comments-area .comment-respond .comment-form-author textarea,
.comments-area .comment-respond .comment-form-email textarea,
.comments-area .comment-respond .comment-form-url textarea {
  height: auto;
}
.comments-area .comment-respond .form-submit {
  margin: 0 !important;
}
.comments-area .comment-respond .form-submit input {
  display: inline-block;
  background: #ff2d55;
  border: none;
  color: #ffffff;
  padding: 13px 25px;
  text-transform: uppercase;
  font-weight: 600;
  outline: 0 !important;
  margin-top: 5px;
  transition: 0.5s;
}
.comments-area .comment-respond .form-submit input:hover,
.comments-area .comment-respond .form-submit input:focus {
  background: #0d1028;
  box-shadow: 0 13px 27px 0 rgba(255, 82, 2, 0.11);
}

/*================================================
Sidebar CSS
=================================================*/
.sidebar .widget {
  margin-bottom: 40px;
}
.sidebar .widget:last-child {
  margin-bottom: 0;
}
.sidebar .widget .widget-title {
  font-size: 22px;
  margin-bottom: 25px;
  position: relative;
}
.sidebar .widget .widget-title::before {
  content: "";
  position: absolute;
  right: 0;
  top: 2px;
  width: 17px;
  height: 17px;
  background: #ff2d55;
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
  transition: 0.5s;
}
.sidebar .widget:hover .widget-title::before,
.sidebar .widget:focus .widget-title::before {
  transform: rotate(180deg);
}
.sidebar .widget.widget_search {
  background: #ffffff;
  box-shadow: 0px 0px 29px 0px rgba(102, 102, 102, 0.1);
  padding: 15px;
}
.sidebar .widget.widget_search form {
  position: relative;
}
.sidebar .widget.widget_search form .form-control {
  background: transparent;
}
.sidebar .widget.widget_search form button {
  position: absolute;
  right: 5px;
  top: 0;
  height: 100%;
  border: none;
  outline: 0;
  box-shadow: unset;
  background: transparent;
  color: #ff2d55;
  transition: 0.5s;
}
.sidebar .widget.widget_search form button:hover,
.sidebar .widget.widget_search form button:focus {
  color: #00acee;
}
.sidebar .widget.widget_categories ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.sidebar .widget.widget_categories ul li {
  position: relative;
  border-top: 1px solid #eeeeee;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 18px;
}
.sidebar .widget.widget_categories ul li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 10px;
  height: 10px;
  background: #ff2d55;
  margin-top: -5px;
  transition: 0.5s;
}
.sidebar .widget.widget_categories ul li:last-child {
  border-bottom: 1px solid #eeeeee;
}
.sidebar .widget.widget_categories ul li a {
  color: #707070;
}
.sidebar .widget.widget_categories ul li a:hover {
  color: #ff2d55;
}
.sidebar .widget.widget_categories ul li:hover::before {
  border-radius: 50%;
}
.sidebar .widget.widget_recent_entries ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.sidebar .widget.widget_recent_entries ul li {
  position: relative;
  padding-left: 100px;
  margin-bottom: 15px;
  padding-right: 20px;
}
.sidebar .widget.widget_recent_entries ul li a {
  display: block;
}
.sidebar .widget.widget_recent_entries ul li a img {
  position: absolute;
  left: 0;
  top: 3px;
  width: 85px;
  height: 65px;
}
.sidebar .widget.widget_recent_entries ul li h5 {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 2px;
  font-weight: 600;
}
.sidebar .widget.widget_recent_entries ul li h5 a {
  color: #0d1028;
  display: inline-block;
}
.sidebar .widget.widget_recent_entries ul li h5 a:hover,
.sidebar .widget.widget_recent_entries ul li h5 a:focus {
  color: #ff2d55;
}
.sidebar .widget.widget_recent_entries ul li:last-child {
  margin-bottom: 0;
}
.sidebar .widget.widget_tag_cloud .tagcloud a {
  font-size: 14px !important;
  border: 1px dashed #eeeeee;
  padding: 6px 20px;
  margin-top: 5px;
  color: #707070;
  display: inline-block;
  background: #f5f5f5;
  margin-right: 7px;
  border-radius: 30px;
  margin-bottom: 5px;
}
.sidebar .widget.widget_tag_cloud .tagcloud a:hover {
  background: #ff2d55;
  color: #ffffff;
  border-color: #ff2d55;
}
.sidebar .widget.widget_archive ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.sidebar .widget.widget_archive ul li {
  position: relative;
  border-top: 1px solid #eeeeee;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 18px;
}
.sidebar .widget.widget_archive ul li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 10px;
  height: 10px;
  background: #ff2d55;
  margin-top: -5px;
  transition: 0.5s;
}
.sidebar .widget.widget_archive ul li:last-child {
  border-bottom: 1px solid #eeeeee;
}
.sidebar .widget.widget_archive ul li a {
  color: #707070;
  display: inline-block;
}
.sidebar .widget.widget_archive ul li a:hover {
  color: #ff2d55;
}
.sidebar .widget.widget_archive ul li:hover::before {
  border-radius: 50%;
}

/*================================================
Contact Us CSS
=================================================*/
.contact-box {
  background: #ffffff;
  padding: 30px 20px 30px 90px;
  border-radius: 5px;
  position: relative;
  transition: 0.5s;
  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);
}
.contact-box .icon {
  position: absolute;
  left: 20px;
  top: 30px;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 47px;
  border: 1px dashed #ff2d55;
  border-radius: 50%;
  color: #ff2d55;
  font-size: 20px;
  transition: 0.5s;
}
.contact-box h4 {
  font-size: 20px;
  margin-bottom: 10px;
}
.contact-box .content p {
  margin-bottom: 0;
}
.contact-box .content p a {
  color: #707070;
}
.contact-box .content p a:hover,
.contact-box .content p a:focus {
  color: #ff2d55;
}
.contact-box .content p:last-child {
  margin-bottom: 0;
}
.contact-box:hover,
.contact-box:focus {
  box-shadow: 0 0 30px 0 rgba(67, 67, 67, 0.15);
  transform: translateY(-5px);
}
.contact-box:hover .icon,
.contact-box:focus .icon {
  background: #ff2d55;
  color: #ffffff;
}

#map {
  height: 400px;
  width: 100%;
}

.contact-form {
  margin-top: 50px;
}

.leave-your-message h3 {
  margin-bottom: 12px;
  font-size: 22px;
}
.leave-your-message .stay-connected {
  margin-top: 25px;
}
.leave-your-message .stay-connected h3 {
  margin-bottom: 20px;
}
.leave-your-message .stay-connected ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.leave-your-message .stay-connected ul li {
  margin-bottom: 10px;
}
.leave-your-message .stay-connected ul li:last-child {
  margin-bottom: 0;
}
.leave-your-message .stay-connected ul li a {
  font-weight: 500;
  display: inline-block;
  color: #707070;
}
.leave-your-message .stay-connected ul li a i {
  width: 40px;
  height: 40px;
  text-align: center;
  display: inline-block;
  line-height: 40px;
  border: 1px solid;
  border-radius: 50%;
  margin-right: 10px;
  font-size: 15px;
}
.leave-your-message .stay-connected ul li a:hover,
.leave-your-message .stay-connected ul li a:focus {
  color: #ff2d55;
}

#contactForm {
  background: #ffffff;
  padding: 30px;
  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);
}
#contactForm label {
  font-weight: 500;
}
#contactForm .form-control {
  background-color: #f1f1f1;
}
#contactForm ul {
  padding: 0;
  margin: 0;
}
#contactForm ul li {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}
#contactForm .text-danger,
#contactForm .text-success {
  margin-bottom: 0;
  margin-top: 20px;
}
#contactForm .h4 {
  font-size: 15px;
}

/*================================================
Footer CSS
=================================================*/
.footer-area {
  padding-top: 60px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
}

.single-footer-widget {
  z-index: 100;
  position: relative;
  text-align: center;
}

.footer-venue-logo {
  padding: 1vw;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px !important;
  width: 12vw !important;
  height: auto !important;
  margin-bottom: 16px !important;
  @media (max-width: 768px) {
    padding: 12px;
    width: 20vw !important;
  }
  @media (max-width: 600px) {
    width: 40vw !important;
  }
}

.single-footer-widget h3 {
  color: #ffffff;
  font-size: 36px;
  margin-bottom: 20px;
  @media (min-width: 1600px) {
    font-size: 2.25vw;
  }
}
.single-footer-widget span {
  color: rgba(255, 255, 255, 1);
  display: block;
  font-size: 36px;
  margin-bottom: 10px;
}
.single-footer-widget span i {
  margin-right: 5px;
}
.single-footer-widget p {
  margin-bottom: 0;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  @media (min-width: 1600px) {
    font-size: 1.25vw;
  }
  @media (max-width: 767px) {
    text-align: center;
    font-size: 16px;
  }
}
.single-footer-widget .location {
  position: relative;
  padding-left: 25px;
}
.single-footer-widget .location i {
  margin-right: 5px;
  position: absolute;
  left: 0;
  top: 6px;
}
.single-footer-widget .contact-authority {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.single-footer-widget .contact-authority:hover,
.single-footer-widget .contact-authority:focus {
  color: #ff2d55;
}
.single-footer-widget .contact-authority i {
  margin-right: 5px;
}
.single-footer-widget .social-links {
  padding: 0;
  margin: 20px 0 0;
  list-style-type: none;
  text-align: center;
  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
  }
}
.single-footer-widget .social-links li {
  display: inline-block;
  margin-right: 10px;
}
.single-footer-widget .social-links li a {
  color: #ffffff;
  border: 1px solid #525164;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px;
  text-align: center;
  border-radius: 50%;
  font-size: 14px;
  text-decoration: none;
  font-size: 24px;
  display: flex;
}
.single-footer-widget .social-links li a.facebook {
  border: none;
  background-color: #4267b2;
}
.single-footer-widget .social-links li a.twitter {
  border: none;
  background-color: #38a1f3;
}
.single-footer-widget .social-links li a.instagram {
  border: none;
  background: radial-gradient(
      circle farthest-corner at 35% 90%,
      #fec564,
      transparent 50%
    ),
    radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),
    radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),
    radial-gradient(
      ellipse farthest-corner at 20% -50%,
      #5258cf,
      transparent 50%
    ),
    radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),
    radial-gradient(
      ellipse farthest-corner at 60% -20%,
      #893dc2,
      transparent 50%
    ),
    radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),
    linear-gradient(
      #6559ca,
      #bc318f 30%,
      #e33f5f 50%,
      #f77638 70%,
      #fec66d 100%
    );
}
.single-footer-widget .social-links li a.linkedin {
  border: none;
  background-color: #0077b5;
}
.single-footer-widget .social-links li a:hover,
.single-footer-widget .social-links li a:focus {
  background-color: #ff2d55;
  color: #ffffff;
  border-color: #ff2d55;
}

.copyright-area {
  position: relative;
  z-index: 1000 !important;
  border-top: 1px solid #f5f5f5;
  padding-top: 40px;
  padding-bottom: 30px;
  margin-top: 80px;
  text-align: center;
  width: 70%;
  @media (max-width: 768px) {
    width: 90%;
  }
}
.copyright-area .logo a {
  display: inline-block;
}
.copyright-area ul {
  padding: 0;
  margin: 30px 0 20px;
  text-align: center !important;
}
.copyright-area ul li {
  position: relative;
  margin: 5px 15px;
  display: inline-block;
  font-size: 16px;
  text-decoration: none !important;
}
.copyright-area ul li::before {
  position: absolute;
  width: 6px;
  height: 6px;
  content: "";
  background: #ffffff;
  left: -18px;
  top: 50%;
  margin-top: -2px;
  border-radius: 50%;
}
.copyright-area ul li a {
  font-size: 16px;
  color: #ffffff;
  text-decoration: none !important;
  @media (min-width: 1600px) {
    font-size: 1.05vw;
  }
}
.copyright-area ul li a:hover,
.copyright-area ul li a:focus {
  color: #ffffff;
}
.copyright-area ul li:first-child {
  margin-left: 0;
}
.copyright-area ul li::before {
  display: none;
}
.copyright-area ul li:last-child {
  margin-right: 0;
}
.copyright-area p {
  font-size: 16px;
  color: #ffffff;
  @media (min-width: 1600px) {
    font-size: 1.05vw;
  }
}

/*================================================
Back To Top CSS
=================================================*/
.back-to-top {
  position: fixed;
  right: 1.5%;
  bottom: 15px;
  height: 15px;
  cursor: pointer;
  width: 40px;
  padding: 3px 5px;
  font-size: 10px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  z-index: 3;
  outline: 0 !important;
  transition: 0.5s;
  background-color: #0c3246;
  box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);
}
.back-to-top::before,
.back-to-top::after {
  content: "";
  position: absolute;
  left: 0;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-top: 0;
}
.back-to-top::before {
  top: -20px;
  z-index: 4;
  border-bottom: 20px solid #0c3246;
}
.back-to-top::after {
  bottom: 0;
  z-index: 5;
  border-bottom: 20px solid #e74860;
}
.back-to-top:hover,
.back-to-top:focus {
  opacity: 1;
  text-decoration: none;
  height: 40px;
  color: #ffffff;
}
.back-to-top.show-back-to-top {
  display: block;
  bottom: 1.25%;
  visibility: visible;
}

:invalid {
  box-shadow: none;
}

:-moz-submit-invalid {
  box-shadow: none;
}

:-moz-ui-invalid {
  box-shadow: none;
}

.modal-video {
  position: absolute !important;
}

.main-textarea h1,
.main-textarea h2,
.main-textarea h3,
.main-textarea h4,
.main-textarea h5,
.main-textarea h6 {
  margin-bottom: 15px;
}
.main-textarea ul li,
.main-textarea ol li {
  color: #707070;
  margin-bottom: 10px;
  line-height: 1.8;
} 
.ant-tabs-top > .ant-tabs-nav {
  border: none;
}

.register-area {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  padding: 120px 0 120px 0;
  position: relative;
  @media (max-width: 993px) {
    padding: 80px 0 80px 0;
  }
  @media (max-width: 767px) {
    padding: 60px 0 60px 0;

  }
}

.register-area h1 {
  font-size: 52px;
  line-height: 150%;
  margin: 60px 0;
  text-align: center;
  background: linear-gradient(180deg, #f15a2b, #e74860);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  @media (min-width: 2560px) {
    margin: 10vh 0 8vh 0;
  }

  @media (min-width: 1600px) {
    font-size: 3.25vw;
  }
  @media (max-width: 993px) {
    margin-bottom: 30px;
  }
  @media (max-width: 767px) {
    font-size: 40px;
  }
}

#hubspotForm {
  border-radius: 1.2vw;
  background: #f8f8f820 !important;
  padding: 24px !important;
  color: #fff !important;
  @media (max-width: 767px) {
    padding: 20px !important;
  }
}

.align-participants{
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/styles/style.scss","webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAyCA;;kDAAA;AAeA;EACI,UAAA;EACA,SAAA;EACA,eALQ;ECPZ,oDAAA;AACA;;AAEA;EDaI;IACA,oBAAA;ECXJ;ADYI;;ACTJ;;;;;;;;GAQA;;ADaA;EAEQ,WAAA;EACA,YAAA;ACXR;AACA;EDaA,sBAAA;ACXA;;AAEA;EACE,kBAAkB;EDYpB,oBAAA;EACI;IACA,iBAvCc;IAwCd,oBAAA;EACA;;EAEA;IACI,iBAAA;ICVR,oBAAA;EACE;;EDaE;IACA,iBApDU;IC0Cd,oBAAA;EACE;ADWF;;ACRA;;;;;;;;;;;;;GAaA;;ADQA;;;;;;;;;;;;;;GCQA;;ADQA;EACI,eAnFU;AC8Ed;;AAEA;EACA,iBAAA;ADOI;;ACJJ;EDOQ,mBAAA;ACLR;;AAEA;EDOQ,2BAAA;EACA,YAAA;ACLR;;AAEA;EACA,mBAAA;ADOI;;ACJJ,kBAAA;ADOI;EACI,2BAAA;ECLR,0BAAA;EDOI,cAAA;EACI,2DAAA;EACA,uBA7GM;ECwGd,6BAAA;EDOI,2BAAA;EACI,2BAjHM;EAkHN;IACA,4BAAA;ECLR;ADOI;;ACJJ;EDOI,cAAA;EACI,8BAzHM;EA0HN,kBAzHM;ECoHd,UAAA;ADOI;ACLJ;;EAEA,WAAA;EACE,kBAAkB;EDOpB,MAAA;EACI,UAAA;EACA,mBAnIU;EAoIV,YAAA;EACA,WAAA;ECLJ,gBAAA;ADOI;ACLJ;EDOQ,OAAA;ACLR;AACA;EDOQ,QAAA;ACLR;AACA;;;;EDUQ,QAAA;ACLR;ADOI;;ECJJ,kDAAA;EDOI,cAAA;ACLJ;AACA;;EDQQ,8BAAA;EACA,yBA3JM;ECsJd,6DAAA;ADOI;ACLJ;;EDQQ,kDAAA;ACLR;ADOI;;ECJJ,mBAAA;EDOI,cAAA;ACLJ;AACA;;EDQI,UAAA;EACI,mBAAA;ACLR;;AAEA;EDOA,cAAA;EACA,mBAAA;EACI,kBAAA;EACA,UAAA;ACLJ;AACA;;EDQQ,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;ECLR,YAAA;EDOI,WAAA;EACI,gBAAA;ACLR;AACA;EACA,OAAA;ADSQ;ACPR;EDSY,QAAA;ACPZ;AACA;;;;EDaQ,QAAA;ACRR;AACA;;EDWQ,kDAAA;EAEI,cAAA;ACTZ;AACA;;EDaQ,mBAAA;EACA,cAAA;EACA,kDAAA;ACVR;AACA;;EAEA,kDAAA;ADYI;ACVJ;;EDaQ,mBAAA;EACA,cAAA;ACVR;AACA;;EDaY,UAAA;EACA,mBAAA;ACVZ;;AAEA;EACA,WAAA;EDYQ;IACI,WAAA;EACA;EACA;ICVZ,iBAAA;EDYQ;ACVR;;AAEA,gBDWY;ACVZ;EACE,oDAAoD;ADatD;AAIY;EACI,yDAAA;EACA,2BAAA;ECdhB,sBAAA;EDoBY,4BAAA;EACI,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA;IACA,YAAA;EACA;EACA;IACA,YAAA;EClBhB;ADoBY;;ACjBZ;EACA;IDoBgB,aAAA;EACI;AClBpB;;ADuBgB;EACI,kBAAA;EACA,+BA7RP;ECyQb,gBAAA;EACE,eAAe;EDyBjB,oDAAA;EACA,iBAAA;EACI,kBAAA;EACA,UAAA;EAEI,QAAA;EACA,yBAAA;EAEJ,mBAAA;EACA,UAAA;EACA,iBArSS;EC4Qb;ID2BI,kBAAA;EACI;EACA;ICzBR,0BAAA;EACE;ED4BF;IC1BI,0BAA0B;EAC5B;AD4BF;AC1BA;ED4BI,YAAA;EACA,kBAAA;EACA;IACA,iBAAA;EACA;EACA;IACA,iBA9TU;ECoSd;ED4BI;IACI,iBAAA;EACA;AC1BR;AACA;ED4BQ,YAAA;AC1BR;AACA;ED4BQ,cAAA;EACA,eAAA;EACA,kBAAA;EACA;IACA,gBAAA;EC1BR;ED4BQ;IACI,eAAA;EACA;AC1BZ;;AAEA;ED4BY,cAAA;EACA,eAAA;EACA,kBAAA;EACA;IACA,gBAAA;EC1BZ;ED4BQ;IACI,eAAA;EACA;AC1BZ;AACA;ED4BY,cAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EC1BZ;IACI,iBAAiB;ED6BrB;AC3BA;;AAEA;ED6BI,yBAAA;EC3BF,mBD4BM;EC3BN,0BAAA;EACF,oCAAA;ED6BA,cAAA;EACI,4BAAA;EC3BF;IACA,2BAAA;ED6BE;AC3BJ;AACA;EACA,cAAA;ED8BA,eAAA;EC5BE,iBAAiB;EACjB;ID8BF,gBAAA;EACI;AC5BJ;AACA;ED8BI,cAAA;EACA,eAAA;EACA,iBAAA;EACA;IACA,gBAAA;EC5BJ;AD+BQ;AC7BR;ED+BY,yEAAA;EACA,kBAAA;EC7BZ,wCAAA;ADgCY;AC9BZ;EDgCgB,kBAAA;EC9BhB,QAAA;EDgCgB,QAAA;EAEQ,iBAAA;AC/BxB;;AAEA,mBDrXc;ACsXd;EDmCwB,aAAA;EACA,iBAAA;ACjCxB;AACA;EDqCwB,WAAA;ECnCxB,YAAA;EDsCoB,aAAA;EACI,uBAtaX;ECkYb,yBAAA;EDwCoB,cAAA;EACI,gBA3aX;ECqYb,kBAAA;EDyCgB,kBAAA;ACvChB;AACA;;ED0CoB,UAAA;EACA,4BAAA;ACvCpB;AACA;;ED2CwB,mBAAA;EACA,qBAAA;ACxCxB;AACA;ED2CoB,mBAAA;EACA,qBAAA;ACzCpB;;AD4CoB,eAAA;ACzCpB;ED2CwB,YAAA;ECzCxB,aAAA;ED2CwB,eAAA;EAEQ,gBAAA;EACA,yBAAA;EAEJ,gBAAA;EACA,gBAAA;AC3C5B;AACA;;;ED+C4B,iBAAA;EACI,qBAjdnB;ACsab;;AAEA;;kDD+C4B;AC5C5B;ED8C4B,eAAA;EC5C5B,MAAA;ED+CgC,OAAA;EACI,WAAA;EACA,YAAA;EC7CpC,eAAA;ED+CoC,gBAAA;EACI,mBAje3B;ACobb;ADmD4B;EACI,cAAA;EACA,kBAAA;EACA,SAAA;ECjDhC,QAAA;EDmD4B,YAAA;EACI,aAAA;ECjDhC,uBAAA;EDuDoB,kBAAA;EACI,6BAAA;EACA,yBAAA;EACA,oCAAA;ECrDxB,WAAA;AD0DQ;ACxDR;EACA,WAAA;ED2DI,kBAAA;EACI,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,4CAAA;ACzDR;AACA;EACE,WAAW;ED4Db,kBAAA;EACI,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EC1DJ,kBAAA;ED4DI,6BAAA;EACI,yBAAA;EC1DR,kCAAA;AD6DI;;AC1DJ;ED6DQ;IACA,uBAAA;EACA;EC3DR;ID6DI,yBAAA;EACI;AC3DR;AACA;ED6DQ;IC3DR,uBAAA;ED6DI;EACI;IACA,0BAAA;EC3DR;AD6DI;AC3DJ;;kDD8DQ;AC3DR;EACA,uBAAA;ED8DQ,kBAAA;EACI,MAAA;EACA,OAAA;EC5DZ,iBAAA;ED8DQ,WAAA;EACI,YAAA;EC5DZ,YAAA;AD8DQ;AC5DR;ED8DY,UAAA;EC5DZ,SAAA;EACE,qBAAqB;ADgEvB;AC9DA;EACE,kBAAkB;EDgEpB,eAAA;AC9DA;AACA;EDgEI,gBAAA;EAEI,eAAA;EACA,yBAAA;EACA,yBAAA;EC/DR,eAAA;EDkEI,gBAAA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA;IACA,iBAAA;EACA;AChER;AACA;;;EDqEI,cAAA;ACjEJ;AACA;EDmEI,cAAA;ACjEJ;AACA;EDkEQ,0CAAA;EACI,mBAAA;EChEZ,kBAAA;EDmEI,SAAA;EACI,QAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;ECjER,iBAAA;EDoEY,iBAAA;EACI,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;AClEhB;AACA;EDqEoB,kBAAA;EACA,UAAA;ACnEpB;AACA;EDsEgB,eAAA;EACA,gBAAA;ECpEhB,0BAAA;EDuEY,iBAAA;EACI,SAAA;ECrEhB,cAAA;EDuEY,cAAA;ACrEZ;AACA;;;EAGA,cAAA;ADyEI;ACvEJ;EDyEQ,kBAAA;EACA,YAAA;EACA,MAAA;ECvER,qBAAA;EDyEQ,6BAAA;ACvER;AACA;EACE,cAAc;ED0EhB,0BAAA;ACxEA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2BE,cAAc;ADsEhB;ACpEA;EACA,qBAAA;EACE,8BAA8B;EDqEhC,qBAAA;ACnEA;AACA;EDqEI,cAAA;ACnEJ;ADqEI;EACI,UAAA;EACA,mBAAA;EACA,SAAA;ACnER;AACA;EDqEQ,iBAAA;ACnER;AACA;EDqEQ,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;ECnER,YAAA;EDqEI,4CAAA;EACI,oCA7rBM;EA8rBN,gEAAA;ACnER;;AAEA;EDsEQ,YAAA;EACI,iCAAA;EACA,aAAA;ECpEZ,gBAAA;EDuEY,uBAAA;ACrEZ;AACA;EDuEY,2BAAA;ACrEZ;AACA;EDuEY,WAAA;EACI,oBA/sBF;EAgtBE,mBAAA;ECrEhB,WAAA;EDuEY,cAAA;ACrEZ;AACA;EDyEI,wBAAA;EACI,yBAAA;EACA,SAAA;EACA,kBAAA;ACvER;ADyEQ;EACI,UAAA;EACA,aAAA;ACvEZ;AACA;EACA,yBAAA;EDyEY,yBAAA;EACI,SAAA;EACA,kBAvuBH;ACgqBb;ADyEY;EACI,oBAAA;ECvEhB,OAAA;AD2EI;ACzEJ;ED4EY,UAAA;AC1EZ;AACA;EACA,oBAAA;ED6EQ,OAAA;AC3ER;;ADgFQ;;kDC5ER;AD+EQ;EACI,gBAAA;EACA;IACA,gBAAA;EACA;AC7EZ;AD+EY;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAzwBC;EA0wBD;IACA,uBAAA;EACA;AC7EhB;;AAEA;EACA,kBAAA;ED+EgB,MAAA;EACI,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AC7EpB;;AAEA;ED+EoB,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EC7EpB,YAAA;EDgFY,qCAAA;EACI,WAAA;AC9EhB;;AAEA;EDgFoB;IC9EpB;yBDmFI;EACI;;EChFR;IACI,aAAa;EDmFjB;ACjFA;;AAEA;EDmFI,WAAA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;ECjFR,WAAA;EDoFY,YAAA;EACI,mBAAA;EClFhB,aAAA;ADoFgB;;ACjFhB;EACE,UAAU;ADuFZ;ACrFA;EDuFI,gBAAA;ACrFJ;AACA;EACA,aAAA;ADwFQ;ACtFR;EDyFgB,WAAA;EACA,qBAAA;EAEJ,UAAA;EACA,SAAA;ACxFZ;AACA;ED0FY,WAAA;EACI,YAAA;ECxFhB,kBAAA;ED0FY,MAAA;EACI,OAAA;ECxFhB,kBAAA;ED0FgB,sBAAA;EACI,kCAAA;EACA,4BAAA;ECxFpB,UAAA;ED2FY,UAAA;EACI,2BA/1BF;ECswBd,gDAAA;AD2FgB;ACzFhB;ED2FoB,mBAAA;ACzFpB;AD4FY;EACI,oBAt2BD;AC4wBf;AD4FgB;EACI,oBAAA;AC1FpB;AACA;ED8FQ,kBAAA;EACI,QAAA;EACA,SAAA;EACA,gBAAA;AC5FZ;AACA;EDgGY,cAAA;AC9FZ;;AAEA;EDgGY,gBAAA;AC9FZ;AACA;EACA,kBAAA;EACE,OAAO;EDiGT,MAAA;EACI,WAAA;EC/FJ,YAAA;EDiGQ,gBAAA;EACI,eAAA;EC/FZ,WAAA;ADiGQ;;AC9FR;;;;;;;;;;;;;;;;;;GAkBA;;AAEA;EDkGI,sBAAA;EACA,kBAAA;EACA,UAAA;AChGJ;AACA;;;;;;;;;;;;;;GD6GI;AC9FJ;EDgGI,cAAA;EC9FJ,kBAAA;EACE,gBAAgB;ED+FlB,eAAA;EACI;IACA,cAAA;EACA;AC7FJ;AACA;ED+FI,qDAAA;EC7FJ,6BAAA;EACE,0BAA0B;ED8F5B,qBAAA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EC5FJ,iBAAA;EACE;ID6FF,yBAAA;EACI;EC3FF;IACA,0BAAA;ID6FE,mBAAA;EC3FF;EACA;IACF,0BAAA;ED6FA;AC3FA;AACA;EACE,cAAA;ED6FE,gBAAA;EC3FF,eD4FM;EC3FN,aAAA;ED6FE,uBAAA;EC3FF,uBD4FM;EC3FN,SAAA;EACF;ID6FA,iBAAA;EACI;EC3FF;IACA,0BAAA;ID6FE,SAAA;EC3FF;EACA;ID6FE,QAAA;EC3FF;AACF;;AAEA;EACE,qBAAA;ED6FE,uBAAA;EC3FF,wBDr4Ba;ECs4Bb;IACF,sBAAA;ID8FI,uBAAA;EACI;EACA;IACA,sBAAA;IACA,uBA5+BS;EA6+BT;AC5FR;;AAEA;ED8FQ,iBAAA;EAEQ;IC7FhB,gBAAA;IDgGQ,WAAA;EACI;AC9FZ;;AAEA;EDkGA,yEAAA;EChGE,uCAAuC;AACzC;ADkGA;EACI,cAAA;AChGJ;AACA;EACA,cAAA;ADkGI;AChGJ;EDmGY,cAAA;EACA,0BAAA;ACjGZ;AACA;EACE,cAAc;ADqGZ;ACnGJ;EDqGQ,UAAA;EACA,mBAAA;EACA,qBAAA;ACnGR;AACA;EDqGI,WAAA;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;ACnGR;ADqGQ;EACI,iBAAA;EACA,cAAA;ACnGZ;AACA;EDsGI,eAAA;ACpGJ;AACA;EACA,cAAA;EDwGI,eAAA;EACI,mBAAA;ECtGR,mBAAA;AACA;ADwGA;EACI,cAAA;ACtGJ;ADuGI;EACI,qBAAA;ACrGR;AACA;EACA,iBAAA;EDuGI,WAAA;EACI,gBAAA;EACA,eAAA;ACrGR;AACA;EDuGI,WAAA;EACI,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ECrGR,yBAAA;EDuGI,kBAAA;EACI,eAAA;EACA,iBAAA;EACA,UAAA;ECrGR,kBAAA;EACE,gBAAgB;ADuGlB;AACA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;ECrGJ,OAAA;EDuGI,MAAA;EAEQ,WAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;ECtGZ,UAAA;ED0GQ,kBAAA;EACI,mCAAA;ACxGZ;AACA;;ED2GQ,cAAA;ACxGR;AACA;;ED6GY,yBAAA;EC1GZ,cAAA;AACA;AD6GA;EACA,kBAAA;AC3GA;;AAEA;EACA,eAAA;ED6GI,mBAAA;AC3GJ;AACA;ED8GY,kBAAA;EACA,QAAA;EC5GZ,SAAA;EDgHQ,kBAAA;AC9GR;AACA;EDgHY,cAAA;AC9GZ;ADgHQ;EACI,cAAA;AC9GZ;;AAEA;EDkHQ,kBAAA;EACI,SAAA;EChHZ,2BAAA;EDkHQ,YAAA;EACI,kBAAA;EACA,WAAA;AChHZ;AACA;EDkHQ,qBAAA;EACI,eAAA;EChHZ,gBAAA;EDkHQ,cAAA;EACI,cAAA;EACA,kBAAA;AChHZ;AACA;EDkHY,cAAA;AChHZ;AACA;EDkHgB,cAAA;AChHhB;AACA;EDkHgB,YAAA;EACI,iBAppCP;ACoiCb;AACA;EDkHoB,cAAA;AChHpB;AACA;EDkHgB,YAAA;EACI,iBAAA;AChHpB;AACA;EDsHA,cAAA;ACpHA;AACA;EDsHA,YAAA;EACI,iBAAA;ACpHJ;AACA;EDsHI,cAAA;EACI,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,yBA/qCM;EAgrCN,yBAAA;ECpHR,iBAAA;EDsHI,mBAAA;ACpHJ;;AAEA;EDsHQ,uBAAA;ACpHR;ADuHY;EACI,eAAA;ACrHhB;AACA;EDuHgB,qBAAA;EACA,eAAA;EACA,iBAAA;EAEI,uBAAA;ACtHpB;;AAEA;EDyHgB;;IAEA,mBAAA;ICvHhB,UAAA;EDyHY;EACI;ICvHhB,qBAAA;IDyHY,YAAA;EACI;ECvHhB;IDyHY,UAAA;IACI,mBAAA;ECvHhB;AACA;AD6HQ;EACI,kBAAA;EC3HZ,UAAA;EACE,YAAY;ED8Hd,WAAA;EACI,wCAAA;EACA,YAAA;AC5HJ;;AAEA;EACA,kBAAA;ED8HI,WAAA;EACI,YAAA;EC5HR,WAAA;ED8HI,YAAA;AC5HJ;;AAEA;EDgIQ,kBAAA;EACA,UAAA;EACA,SAAA;EC9HR,WAAA;EDgIQ,YAAA;AC9HR;;AAEA;EDgIY,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;AC9HZ;;AAEA;EDgIQ,wBAAA;EACI,uBAAA;EACA,mCAlwCC;ECooCb,iCAAA;ADgIQ;;AC7HR;EDiIgB;IACA,uBAAA;EC/HhB;EDkIQ;IACI,yBA1wCE;EA2wCF;AChIZ;AACA;EDkIQ;IACI,0BAAA;EACA;EChIZ;IDoIQ,2BAAA;EACI;EClIZ;IDoIY,0BAAA;EACI;AClIhB;ADoIY;EACI;IACA,cAAA;EClIhB;EACE;IDsIF,cAAA;EACI;ECpIF;IDsIM,UAAA;ECpIN;EDsIE;IACI,cAAA;ECpIN;EACA;IDsIE,cAAA;ECpIF;AACF;AACA;;EAEE,WAAA;EDsIE,YAAA;ECpIF,iBDqIM;ECpIN,yBAAA;EACF,cAAA;EDyIY,gBAAA;EACI,YAAA;ACvIhB;AACA;;ED4IA,eAAA;ACzIA;AACA;;ED4II,yBAAA;ECzIJ,cAAA;AACA;;AAEA;;kDD2II;ACxIJ;EACA,kBAAA;ED0II,UAAA;EACI,gBAAA;ACxIR;AACA;ED0II,yDAAA;EACI,kCAAA;ECxIR,sBAAA;ED0II,4BAAA;ACxIJ;;AAEA;ED0IQ,cAAA;EACI,mBAAA;ECxIZ,eAAA;ED2II,yBAAA;EAEQ,cAAA;EACA;IAEJ,4BAAA;EACA;AC3IR;AACA;ED6IQ,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EC3IR;IACI,yBAAyB;ED8I7B;EC5IE;IACE,0BAA0B;ED8I9B;AC5IA;AACA;ED+IQ,+EAAA;EC7IR,kBAAA;ED+II,wCAAA;AC7IJ;AACA;ED+IQ,gBAAA;EC7IR,mBAAA;AD+II;AC7IJ;ED+IQ,kBAAA;AC7IR;;AAEA;EDkJA,kBAAA;EChJE,iBAAiB;AACnB;ADkJA;EACI,WAAA;EACA,YAAA;AChJJ;ADkJI;EACI,kBAAA;EACA,UAAA;EACA,aAAA;AChJR;AACA;EDkJQ,kBAAA;EACA,UAAA;EChJR,SAAA;EDkJI,wCAAA;AChJJ;AACA;EDkJQ,kBAAA;EACA,aAAA;EChJR,QAAA;ADkJQ;;AC/IR,kBDiJY;AChJZ;EACA,gBAAA;EDkJY,kBAAA;EACI,UAAA;AChJhB;ADmJQ;EACI,6CAAA;EACA,kCAAA;EACA,sBAl6CE;EAm6CF,4BA95CC;AC6wCb;ADoJI;EACI,kBAAA;EACA,QAAA;EACA,MAAA;AClJR;AACA;EDoJQ,SAAA;AClJR;AACA;EDoJQ,gBAAA;AClJR;;ADqJQ,oBAAA;AClJR;EDoJY,kBAAA;EClJZ,gBAAA;EDmJY,UAAA;ACjJZ;AACA;EDoJY,6CAAA;EACI,kCAAA;EACA,sBAAA;EACA,4BAAA;AClJhB;AACA;EDoJgB,kBA/7CF;EAg8CE,QAAA;EACA,MAAA;AClJhB;ADoJgB;EACI,SAAA;EClJpB,UAAA;EDoJgB,WAAA;AClJhB;AACA;EDoJgB,gBAAA;AClJhB;AACA;EDoJgB,gBAAA;EACI,iBAAA;EClJpB,mBAAA;ADoJgB;AClJhB;EDoJoB,gBAj9CN;AC+zCd;ADwJQ;EACI,UAAA;ECtJZ,gBAAA;EDwJQ,qBAAA;ACtJR;AACA;EDwJY,qBAAA;ECtJZ,mBAAA;EACE,cAAc;EDyJhB,iBAAA;EACA,kBAAA;ACvJA;AACA;EACA,cAAA;EDyJI,kBAAA;EACI,OAAA;EACA,QAAA;EACA,gBAAA;ACvJR;AACA;EDyJQ,gBAAA;ACvJR;;AAEA;EDyJQ,yBA3+CK;ECo1Cb,0BAAA;EDyJQ;IACI,4BAAA;EACA;ECvJZ;;KD0JgB;ACvJhB;;AAEA;EACA,aAAA;AD2JQ;;ACxJR;ED2JY,qBApgDC;AC22Cb;;AD6JI;EACI,8BAAA;AC1JR;;AAEA;ED4JQ,yBAAA;EACA,eAAA;EACA;IACA,4BAAA;EACA;AC1JR;;AD6JQ;EACI,yBAAA;AC1JZ;;AD6JY;EACI,yBAAA;AC1JhB;;AAEA;ED4JgB,yBA7hDH;ACm4Cb;;AAEA;EACA,8BAAA;ED4JgB,sBAAA;EACI,kBAAA;AC1JpB;;AAEA;;kDD6JgB;AC1JhB;EACA,kBAAA;ED4JgB,UAAA;AC1JhB;AACA;ED4JgB,WAAA;EACI,kBAAA;EACA,OAAA;EC1JpB,MAAA;ED+JI,UAAA;EACI,WAAA;EC7JR,YAAA;EDgKQ,mBAAA;EACI,YAAA;AC9JZ;AACA;EACA,WAAA;EDgKQ,qBAAA;EACI,UAAA;EACA,SAAA;AC9JZ;AACA;EDgKQ,WAAA;EACI,YAAA;EACA,kBAAA;EC9JZ,MAAA;EACE,OAAO;EDiKT,kBAAA;EACA,sBAAA;EACI,kCAAA;EACA,4BAAA;EACA,UAAA;EACA,UAAA;EC/JJ,2BAAA;EACE,gDAAgD;ADgKlD;AC9JA;EACA,mBAAA;AACA;AD+JA;EACI,oBAAA;AC7JJ;AACA;ED+JI,oBAAA;AC7JJ;;AAEA;ED+JQ,iBAAA;AC7JR;;AAEA;ED+JQ,kBAAA;EACI,UAAA;EACA,+CAAA;EACA,kBAAA;EACA,aAAA;AC7JZ;AACA;ED+JY,sBAAA;AC7JZ;AACA;EACA,kBAAA;ED+JQ,kBAAA;EACI,mBAAA;EACA,SAAA;EACA,OAAA;EC7JZ,gBAAA;AD+JQ;AC7JR;ED+JY,WAAA;EACA,kBA1mDC;EA2mDD,WAAA;EC7JZ,WAAA;ED+JQ,gBAAA;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;AC7JZ;AACA;ED+JY,eAAA;EACA,cAAA;AC7JZ;AD+JY;EACI,eAAA;EC7JhB,cAAA;ED+JgB,gBAAA;EACI,mBAAA;AC7JpB;AACA;ED+JoB,cAAA;EACA,gBAAA;EACA,gBAAA;AC7JpB;AACA;ED+JoB,UAAA;EC7JpB,kBAAA;AD+JoB;AC7JpB;;EDgKwB,YAAA;AC7JxB;AACA;;EAEA,mBAAA;ADgKoB;AC9JpB;;EDiKwB,UAAA;EACA,mBAAA;AC9JxB;;AAEA;EDgKwB;IACA,UAAA;IACA,kCA1pDX;EC4/Cb;EDoKI;IACI,UAAA;IClKR,mCAAA;EDoKQ;EACI;IACA,UAAA;EClKZ;EDoKQ;IACI,UAAA;EClKZ;EDoKY;IACI,UAAA;EClKhB;ADoKY;AClKZ;EACA,UAAA;ADoKY;;ACjKZ,uBAAA;AACA;EDuKA,iBAAA;ECrKE,WAAW;EACX,iBAAiB;EDuKnB,kBAAA;ACrKA;;AAEA;EDuKI,kBAAA;EAEQ,kBAAA;EACA,kBAAA;EACA,UAAA;ACtKZ;AACA;EACA,eAAA;EACE,mBAAmB;ADyKrB;ACvKA;EDyKI,gBAAA;ACvKJ;ADyKI;EACI,cAAA;EACA,gBAAA;ACvKR;AACA;;EAEA,mBAAA;ADyKQ;ACvKR;EDyKY,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EAkBI,OAAA;EAGJ,QAAA;EACA,oBAAA;EACA,WAAA;EACA,MAAA;AC1LZ;;AAEA;;kDDqKgB;AClKhB;EDoKgB,yBAAA;EACA,iBAAA;EACA,oBAAA;AClKhB;AACA;EDoKgB,cAAA;EACA,cAAA;EACA,eAAA;AClKhB;AACA;ED6KY,cAAA;EACI,eAAA;EAEI,mBAAA;AC5KpB;;AAEA;;kDDiLgB;AC9KhB;EDgLY,gBAAA;EACI,kBAAA;AC9KhB;ADgLY;EACI,WAAA;EC9KhB,kBAAA;EDgLY,MAAA;EACI,QAAA;EC9KhB;;;;;;GDqLoB;EC9KpB,WAAA;EDmLI,YAAA;ACjLJ;AACA;EACA,kBAAA;EDmLQ,YAAA;EACI,UAAA;EACA,gBAAA;ACjLZ;;AAEA;EDmLY,eAAA;EACI,gBAAA;EACA,cAAA;ACjLhB;AACA;EACA;IDmLgB,8BAAA;EACI;ACjLpB;ADmLgB;EACI,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EClLxB,YAAA;EDqLoB,WAAA;EACI,YAAA;ECnLxB;IDsLoB,YAAA;IACI,8BAAA;EACA;ACpLxB;;AAEA;EACA,iBAAA;EDuL4B,cAAA;EACI,gBAAA;ECrL9B,0BDqL8B;ECrLhC,iBAAA;EDuL4B;IACI,yBAAA;ECpL9B;EADF;IDuL4B,0BAAA;IACI,mBAAA;ECnL9B;EAFF;IDuL4B,0BAAA;EACI;ACrLhC;;AAKA;EACE,qDDkL8B;ECrLhC,6BAAA;EDuL4B,0BAAA;EACI,qBAAA;ECjL9B,kBDiL8B;ECrLhC,iBAAA;ADuL4B;;AC/K5B;EALA,kBAAA;EDuL4B,UAAA;EACI,yDAAA;EC/K9B,kCD+K8B;ECrLhC,sBAAA;EDuL4B,4BAAA;EACI,4BAAA;EC9K9B,YD8K8B;ECrLhC,aAAA;EDuL4B,uBAAA;EACI,mBAAA;EC7K9B,kBD6K8B;ECrLhC;IDyLoB,YAAA;EACI;ACvLxB;ADyLwB;;;;;;;;;GAaA;AClLxB;EDoL4B,sBAAA;EACA,eAAA;EC3L5B,gBAAA;ED6LwB;IACI,yBAAA;EACA;;EC1L5B;ID6L4B,0BAAA;EACI;AClLhC;AACA;EDoLgC,eAAA;EC3LhC,gBAAA;ED6LgC,yBAAA;EACI;IC3LpC,yBAAA;ED8LgC;EACI;IACA,0BA34DvB;EC+sDb;AD+LgC;;AC5LhC;;EDsMoB,cAAA;AC1LpB;AACA;ED4LoB,cAAA;ECnMpB,eAAA;EDqMgB,cAAA;EACI,gBAAA;AC1LpB;AARA;EDsMoB,aAAA;EACI,aAAA;ECpMxB,UAAA;EDsMoB,kBAAA;EACI,qBAr6DP;ECiuDjB,gBAAA;EAUE,kBAAkB;EDkMpB,YAAA;EACI,MAAA;EACA,yBAAA;ACzMJ;AD2MI;EACI,cAAA;ECzMR,mBAAA;AAUA;ADkMA;EAEI,gBAAA;ACjMJ;AACA;EDmMQ,WAAA;EACA,YAAA;EC1MR,iBAAA;ED4MQ,kBAAA;EAEQ,yBAAA;EAEJ,cA/7DE;EAg8DF,kBAAA;EACA,eAAA;ACnMZ;AACA;EDqMY,yBAAA;ACnMZ;AACA;EDqMY,yBAAA;AC5MZ;AD8MY;EACI;;;;;;;;;;;;;;;;;;;;;;;;;KA+BQ;ACzMxB;AAPA;EDkNoB,yBAAA;ACxMpB;AAPA;;EDmNwB,yBAAA;ECxMtB,cDwMsB;AChNxB;ADkNoB;;ECtMlB,YDuMsB;AChNxB;ADkNoB;;ECrMlB,QDsMsB;EChNxB,UAAA;EDkNoB,mBAAA;ACrMpB;;AAVA,qBAAA;ADkNoB;EACI,gBAAA;ECpMtB,kBDoMsB;EChNxB,YAAA;EDkNoB,mBAAA;EACI;ICnMpB,yBDmMoB;EChNxB;ADoNY;ACpMZ;EAbA,kBAAA;EDoNgB,aAAA;EACI,OAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EClNpB,UAAA;EDsNgB,kBAAA;EACI,gBAAA;EACA;ICpNpB,gBAAA;IDsNoB,qBAAA;IACI,qBAphEV;ICg0Dd,8BAAA;EDsNwB;ACtMxB;AAbA;EDwNgB,eAAA;EACI,2BAAA;EACA,cAAA;EACA,gBAAA;ECtNpB,kBAAA;EDwNoB;IACI,gBAAA;EACA;ACxMxB;AACA;EAbA,cAAA;ADwNwB;ACxMxB;;ED4MwB,cAAA;ACzMxB;AACA;EAbA,kBAAA;EDyNwB,cAAA;EACI,eAAA;ECvN5B,eAAA;EDyNwB,cAAA;EACI,gBAAA;EACA;ICvN5B,iBAAA;EDyN4B;ACzM5B;AAbA;EDgOY,uBAAA;EACI,aAAA;EC9NhB,UAAA;EDkOY,kBAAA;EACI,qBAnkED;ECm2Df,gBAAA;EDoOY,kBAAA;EACI,YAAA;EClOhB,MAAA;EDsOY,yBAAA;ACtNZ;AAbA;EDwOY,cAAA;EACI,kBAAA;ACtOhB;AD0OY;EACI,WAAA;ECxOhB,YAAA;EAeE,iBAAiB;ED+Nf,kBAAA;EACI,yBAhmEM;EAimEN,cAAA;EC3OR,kBAAA;ED6OQ,eAAA;AC7NR;AAbA;ED6OQ,yBAAA;AC7NR;AAbA;EAeE,yBAAyB;ADgO3B;AACA;EACI;;;;;;;;;;;;;;;;;;;;;;;;;KAmDA;ACtQJ;ADwQI;EAEQ,yBAAA;ACzPZ;AACA;;ED6PQ,yBAAA;ECxQR,cAAA;AD0QQ;AC1PR;ED6PgB,gBAAA;EAEJ,kBAAA;AC5PZ;AAbA;;EDiRY,SAAA;EAGA,UAAA;EACA,mBAAA;AClQZ;AACA;;EDqQY,QAAA;EACI,UAAA;EACA,mBAAA;AC5QhB;AD+QoB;;EClQlB,qBDmQsB;EC7QxB,oEAAA;ED+QoB,iDAAA;AClQpB;;AAVA,uBAAA;AD+QoB;EACI,iBAAA;ECjQtB,kBDiQsB;EC7QxB,WAAA;AD+QoB;;AC5QpB;ED+QoB,oBAAA;AChQpB;;AAZA;ED+QoB,mBAAA;EACI,kBAAA;EC/PtB,gBD+PsB;EC7QxB,6CAAA;AD+QoB;AC9PpB;EACE,mBD8PsB;EC7QxB,eAAA;ED+QoB,kBAAA;EACI,gBAAA;AC7PxB;AAhBA;ED+QoB,WAAA;EACI,QAAA;EC5PtB,YD4PsB;EC7QxB,cAAA;ED+QoB,mBAAA;EACI,kBAAA;EC3PtB,UD2PsB;EC7QxB,QAAA;EDiRY,gBAAA;AC5PZ;AAlBA;EDiRgB,eAAA;EACI,mBAAA;EACA,cAAA;AC5PpB;AACA;ED8PoB,cAAA;EC/QpB,0BAAA;EDmRgB,gBAAA;EACI,cAAA;AC9PpB;AAlBA;EDmRoB,UAAA;EACI,SAAA;ECjRxB,qBAAA;EDmRwB,kBAAA;EACI,UAAA;ECjR5B,OAAA;EDqRgB,QAAA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;ACnRpB;ADqRoB;EACI,qBAAA;AChQxB;AACA;EDkQwB,cAAA;EAEA,WAAA;ECpRxB,YAAA;EDsRwB,iBAAA;EACI,eAAA;EACA,cA9wEf;EC0/Db,kBAAA;EDsRwB,kBAAA;EACI,UAAA;ACpR5B;ADsRwB;EACI,cAAA;ACpR5B;ADsRwB;EACI,mBAAA;EACA,cAvxEX;ECmgEjB,yBAAA;ADsR4B;ACjQ5B;EAlBA,WAAA;ED0RY,WAAA;EACI,YAAA;ECxRhB,kBAAA;EAoBE,MAAM;EDyQR,OAAA;EAEI,mBAAA;EACI,wBAAA;EACA,WAAA;EC3RR,gBAAA;AD6RI;ACxQJ;EAlBA,6CAAA;AD8RY;ACzQZ;;ED4QgB,qBAAA;EACA,mBAAA;AC5RhB;ADgSI;EACI,mBAAA;AC9RR;AAoBA;ED8QA,WAAA;AC5QA;AACA;ED8QA,mBAAA;AC5QA;AACA;;EDgRQ,cAAA;AC7QR;;AAEA;;kDDgRI;AC7QJ;ED+QQ,yDAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EChSR,OAAA;EAoBE,UAAU;ED+QZ;IACI,uBAAA;EChSJ;ADkSI;AC7QJ;ED+QQ,eAAA;EChSR,gBAAA;EDkSI,yBAAA;AC7QJ;;AAEA;EDgRY,kBAAA;ACjSZ;ADoSI;EACI,yDAp2EM;EAq2EN,kCAAA;EACA,sBAAA;EACA,4BAAA;AC/QR;;AAEA;EDiRA,gBAAA;AACA;;AC9QA;EAlBA,kBAAA;EDoSI;IACI,mBAj3EM;EAk3EN;AC/QR;;AAEA;EAlBA,gDAAA;EDoSI,sBAAA;EACI;IACA,qBAAA;EAEI;AChRZ;AAlBA;EDsSI,YAAA;EACI,SAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;ACjRR;AAlBA;EAoBE,cAAc;EDsRJ,SAAA;EACI,yBA94EH;ECumEb,gBAAA;ED6SY,kBAAA;EACI,YAAA;EC3ShB,eAAA;EDiTY,gBAAA;EACI,cAx5ED;ECymEf,yBAAA;EDqTY,kBAAA;EACI,0BA75EI;EC0mEpB;IAoBI,gBAAgB;EDqSpB;ACnSA;AACA;EDqSA,WAAA;EACI,YAAA;EACA,OAAA;ECtTJ,aAAA;EDwTI,kBAAA;EAEQ,mBAAA;EACA,cAAA;EACA,WAAA;EACA,wBAAA;EACA,QAAA;ECvTZ,cAAA;EAoBE,UAAU;EDuSZ,kBAAA;EACC,gBAAA;ACrSD;AACA;EDuSC,cAAA;EACA,eAAA;EACA,0BAAA;EAEO,eAAA;EACA;IAEP,iBAAA;IACA,iBAAA;EACG;AC1TJ;AD4TI;EACI,6BAAA;ACvSR;AACA;;;;;;;;GD+SY;ACtSZ;EDwSY,yBAAA;EACA,cAAA;ACtSZ;AACA;EAnBA,UAAA;ED6TI,mBAAA;ACvSJ;AACA;ED2SQ,aAAA;EACA,2BAAA;ACzSR;AAnBA;ED+TI,qBAAA;EACI,UAAA;EAEI,SAAA;EACA,YAAA;AC1SZ;AACA;EAnBA,cAAA;EDiUQ,mBAAA;EACI,sCAAA;EACA,yBAAA;EC/TZ,mBAAA;EDkUI,uDAAA;AC5SJ;;AAEA;EAnBA,yBAAA;ADkUQ;;AC3SR;ED8SY,gBAAA;AC5SZ;AACA;;;;;EDkTY,6BAAA;EACI,aAAA;EACA,kBAAA;EChUhB,8BAAA;EDoUI,kBAAA;EACI,oBAAA;EClUR,iBAAA;EDqUY;IACI,4BAAA;ECnUhB;AAqBA;ADmTA;;;;;EAKI,aAAA;ACjTJ;AACA;;;;;;ED0TQ,gBAAA;EACA,kBA9hFM;EA+hFN,WAAA;ECvUR,QAAA;EDyUQ,2BAAA;ACnTR;;AAEA;;;;;;ED0TY,gBAAA;ACnTZ;AACA;;;;;;;ED4TQ,UAAA;EACA,kBAAA;ECxUR,qBAAA;ED0UQ,kBAAA;EACI,iBAtjFM;EAujFN,kBAAA;EACA,WAAA;ACpTZ;AACA;;;;;;;ED4TgB,eAAA;ECxUhB,mBAAA;ED4UI,0BAAA;EACI,cAAA;EC1UR,gBAAA;EAqBE;ID2TU,iBAAA;EACI;EC7UhB;IDgVgB,0BAAA;EACI;AC9UpB;ADmVY;;;;;;;EASQ,cAAA;ACnVpB;AD0VY;;;;;;;EAWI,cAAA;EC5VhB,eAAA;ED8VgB,gBAAA;EACI,mBAnnFA;ECuxEpB,0BAAA;EDgWgB,iBAAA;EACI;IC9VpB,iBAAA;EAqBE;EDgVF;IC9UI,0BAA0B;EAC5B;ADgVF;;ACjWA;;;;;;;ED2WgB,cAAA;AC/UhB;AACA;;;;;;EAdA,yBAAA;EDyWI,2BAAA;EACI,0BAAA;ECvWR,aAAA;EDyWQ,sBAAA;EACI;ICvWZ,4BAAA;EDyWY;EACI;IACA,uBAAA;ICvWhB,0BAAA;EDyWgB;ACnVhB;;AAEA;;;;;;EAdA,yBAAA;AD8WoB;;ACvVpB;;;;;;;EAbA,UAAA;EAqBE,qBAAqB;EDiWvB,SAAA;AC/VA;AACA;;;;;;;;EDyWY,qBAAA;EACA,cAAA;EACA,kBAAA;ECpXZ,eAAA;AAqBA;ADmWA;;;;;;;;EC9WA,eAAA;ADuXQ;ACjWR;;;;;;;;;ED4WY,iBAvuFC;ECi3Eb,cAAA;ADwXY;AClWZ;;;;;;;;;ED8WY,cAAA;ACpWZ;AACA;;;;;;ED+WY,yBAAA;EAEI,eAAA;EC7XhB;IDgYY,iBAAA;EACI;EC9XhB;IDgYgB,eAAA;IACI,gBAlxFP;ECo5Eb;EDkYQ;IACI,aAAA;EChYZ;ADmYI;;AC5WJ;;;;;;EAdA,yBAAA;ADuYgB;;ACpYhB;;;;;;ED6YoB,yBA7yFN;ECu6Ed,eAAA;AAqBA;;AAEA;;;;;;ED6XY,yBAAA;ACtXZ;;AAEA;ED0XA,kBAAA;EACA,gBAAA;ACxXA;AAnBA;EAqBE,cAAc;ADyXhB;;ACtXA,qBDwXI;AC3YJ;ED6YI,kBAAA;EACI,mBAAA;EC3YR,kBAAA;ED4YQ,oBAAA;ACtXR;AAnBA;ED8YI,eAAA;EACI,cAAA;EACA,mBAn1FM;EAo1FN,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;ACxXR;AAnBA;ED8YI,cAAA;EACI,eAAA;EACA,0BAAA;EACA,eAAA;ACxXR;AACA;EAnBA,aAAA;ED8YQ,8BAAA;EACI,gCAv2FC;EAw2FD,aAAA;EACA,gBAAA;AC5YZ;AD+YI;EACI,gBAAA;EACA,kBAAA;ACzXR;AACA;;;;;ED+ZY;;;;;;;;;;;;;;;;;;;;;;;;;;GA+BJ;ACnYR;AACA;;;;;ED0YI,gEAAA;ACnYJ;AAnBA;;;;;EDuaQ,wEAAA;ACzZR;AAqBA;;;;;ED4YI,kBAAA;ACtYJ;AACA;;;;;EDqZQ;;;;;;;;GAWQ;ACzYhB;AACA;;;;;ED4ZgB;;;;;;;;;GASA;AChahB;ADkagB;;;;;ECjZhB;;;;;;;;;;GDkbQ;ACvaR;ADyaI;;;;;EAmBI;;;;;;;;;;;GAWY;ACzapB;AD4aY;;;;;EAMI,iCAAA;ACtZhB;AACA;;;;;EAcE;;;;;;;;GDoaM;AC/aR;ADibI;EACI,gBAAA;AC3ZR;AACA;ED6ZQ,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AC3ZR;AAnBA;EDibI,eAAA;EACI,mBAAA;EACA;IACA,iBAAA;EC/aR;ADibQ;AC3ZR;ED6ZY,cAAA;AC3ZZ;AACA;;;;;;;;;;;;ED0agB,cAAA;AC7ZhB;AAnBA;EDobQ,UAAA;EACI,qBAAA;EACA,SAAA;AC9ZZ;AAnBA;EDobQ,qBAAA;EACI,cAAA;EAEI,kBAAA;EACA,eAAA;ACnbhB;ADqbY;;;;;;EC9aZ,eAAA;ADsbgB;AChahB;;;;;;;EAOE,iBAAiB;EACjB,cAAc;ADsahB;ACpaA;;;;;;EAdA,eAAA;AD2bI;ACraJ;;;;;;;ED6aQ,qBAhtGK;EAitGL,cAAA;ACzbR;AD2bI;;;;;;;;;;;;;;EAcI,cAAA;ACraR;AAnBA;ED2bY,mBAAA;ACraZ;AAnBA;ED6bY,mBAAA;ACvaZ;AACA;EAnBA,mBAAA;AD8bQ;ACxaR;ED0aY,mBAAA;ACxaZ;AAnBA;ED8bQ,mBAAA;ACxaR;AACA;ED2agB,mBAAA;ACzahB;;AD4aY;;EAEI,cAAA;EAEI,gBAAA;AC9bpB;ADgcgB;;EC7bhB,eAAA;AAqBA;ADgbA;;;;EAII,cAAA;AC9aJ;;AAEA,uBD+aI;AC9aJ;EDgbI,oBAAA;AClcJ;ADocI;;;;EAMI,yBAAA;AChbR;AAnBA;;;;EDycQ,yBAAA;AChbR;AACA;;;;EAhBA,yBAAA;ADucI;ACjbJ;;;;EAIE,yBAAyB;AAC3B;ADobA;;;;EAII,yBAAA;ACtcJ;ADwcI;;;;EAIA,yBAAA;AClbJ;;ADqbQ;EACI,kBAAA;EACA,mBAAA;EACA,yBA7zGE;EA8zGF,6CAAA;AClbZ;AACA;EAnBA,eAAA;EDwcQ,cAAA;EACI,mBAAA;ECtcZ,yBAAA;EDycI,aAAA;ACnbJ;AAnBA;EAqBE,cAAc;EDqbhB,eAAA;EACI,0BAAA;EACA,eAAA;ACnbJ;AACA;EDqbI,aAAA;ECvcJ,8BAAA;EDycI,gCAAA;EAEQ,kBAAA;EAEJ,gBAAA;ACzcR;AD4cI;EACI,eAAA;EC1cR,kBAAA;AD4cI;ACtbJ;;;;;EDydQ;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BQ;AC5bhB;AAnBA;;;;;EDqdgB,gEAAA;AC1bhB;AACA;;;;;EDwcgB,wEAAA;AC1bhB;AAtBA;;;;;EDydgB,kBAAA;AC5bhB;AACA;;;;;EATA;;;;;;;;GDmeI;ACncJ;AACA;;;;;EDsdgB;;;;;;;;;GAahB;AC1cA;AACA;;;;;ED+dgB;;;;;;;;;;GAaA;ACjdhB;AACA;;;;;EDoeoB;;;;;;;;;;;GC/dpB;ADgfQ;ACvdR;;;;;EDgeY,iCAAA;ACzdZ;AAtBA;;;;;EDggBgB;;;;;;;;GAWR;AC7dR;AAtBA;EDsfI,gBAAA;AC7dJ;AACA;;;;;EAlBA,UAAA;EDsfY,kBAAA;EAEQ,qBAAA;EAEJ,gBAAA;EACA,WAAA;ACtfhB;ADwfY;;;;;EAKQ,eAhoHP;EC0oGb,mBAAA;AD0fQ;ACjeR;;;;;;ED0eI,cAAA;ACneJ;AACA;;;;;;;;;;;;EDmfwB,cAAA;ACtexB;AAtBA;;;;;EAKA,UAAA;EDigBgB,qBAAA;EACI,SAAA;ACxepB;AACA;;;;;;EDif4B,qBAAA;EACA,cAAA;ECjgB5B,kBAAA;EDmgBwB,gBAAA;EAEQ,eAAA;AC3ehC;AACA;;;;;;;EDsf4B,iBAAA;EACA,cAhsHV;ACktGlB;AAtBA;;;;;;;EDkhBgB,iBAAA;ACnfhB;AACA;;;;;;ED0fwB,eAAA;ACnfxB;AAtBA;;;;;;;EDuhBQ,qBAAA;EACI,cAAA;ACxfZ;AAtBA;;;;;;;;;;;;;;EDiiBgB,cAAA;AClhBhB;ADohBgB;EACI,mBAAA;AClhBpB;;AAyBA,sBD6fgB;ACnhBhB;EDshBQ,6BAAA;EACI,iBAAA;ACphBZ;ADqhBY;EACI,cAAA;AC5fhB;AACA;ED8fgB,WAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;AC5fhB;AACA;ED8fgB,gDA3wHH;ACwvGb;;AAyBA;;kDArBA;AAwBA;EDkgBA,kBAAA;EChgBE,UAAU;EACV,sED+fF;EAII,kCAAA;EACI,sBAAA;ECxhBR,4BAAA;ED0hBQ,4BAAA;ACjgBR;AAtBA;ED0hBQ,WAAA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;ECxhBZ,WAAA;ED0hBY,WAAA;EACI,YAAA;EACA,mBAAA;EACA,aAAA;ACjgBhB;;AAEA;EDmgBgB,kBAAA;ACjgBhB;AACA;EDkgBgB,cAAA;ECxhBhB,eAAA;AD6hBgB;ACngBhB;EAvBA,cAAA;ED+hBQ,eAAA;EACI,gBAAA;EACA,kBAAA;ACrgBZ;AAvBA;ED+hBY,cAAA;EACI,mBAAA;EC7hBhB,eAAA;ED+hBgB,gBAAA;EACI,cAAA;AC7hBpB;;AA0BA,oBDsgBoB;ACrgBpB;EDugBoB,kBAAA;EACA,kBAAA;ACrgBpB;AACA;EDugBoB,cAAA;EACA,eAAA;EACA,kBAp1HP;EAq1HO,OAAA;EC7hBpB,MAAA;AD+hBoB;ACrgBpB;EAvBA,cAAA;EDmiBY,eAAA;EACI,aAAA;EACA,kBAAA;ACzgBhB;AAvBA;EDmiBgB,cAAA;EACI,mBAAA;EACA,eAAA;EAEI,gBAAA;EACA,cAAA;AC1gBxB;;AD6gBoB;;EAEI,cAAA;AC1gBxB;AACA;;ED6gBwB,cAAA;AC1gBxB;AACA;;EAtBA,cAAA;ADoiBoB;AC1gBpB;;ED6gBoB,cAAA;AC1gBpB;;AD6gBwB;;kDCjiBxB;ADsiBwB;EACI,kBAAA;ECpiB5B,UAAA;AD2iBY;ACjhBZ;EDmhBgB,yDAAA;EACA,kCAAA;ECziBhB,sBAAA;ED2iBgB,4BAAA;EACI,4BAAA;ACjhBpB;;AAEA;EAvBA,oBAAA;ED2iBoB,mBAAA;EACI,kBAAA;ECziBxB,UAAA;ED2iBwB,kBAAA;EACI,kBAAA;EACA,+CAAA;EACA,kCAAA;EACA,gBAAA;EACA,kDAAA;ECziB5B,gBAAA;AD4iBoB;AClhBpB;EDohBwB,uBAAA;EACA,mBAAA;ECziBxB,0DAAA;ED4iBwB,kBAAA;AClhBxB;AACA;EAvBA,WAAA;ED4iB4B,YAAA;EACI,aAAA;EC1iBhC,kBAAA;ED8iBoB,kBAAA;EACI,WAAA;EC5iBxB,UAAA;EDmjBgB;;;GAGI;EACA,gBAAA;ACzhBpB;AACA;ED2hBoB,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;ECjjBpB,mBAAA;ADmjBoB;ACzhBpB;ED2hBwB,cAj8HV;EAk8HU,eAAA;ECjjBxB,gBAAA;EDujBY,cAAA;EACI,mBAAA;AC7hBhB;AACA;EAvBA,eAAA;EDujBgB,UAAA;AC7hBhB;AACA;EDgiBwB,eAAA;EACA,gBAAA;EACA,qBAAA;ACtjBxB;ADwjBoB;EACI,cAAA;EACA,0BAAA;EACA,gCAAA;EACA,mBAAA;EACA,oBAAA;AC9hBxB;AACA;EDgiBwB,gBAAA;AC9hBxB;AAvBA;EDwjBoB,6BAAA;EACI,iBAAA;ACtjBxB;ADwjBoB;;;ECpjBpB,4BAAA;ADwjBwB;AC9hBxB;;;EDoiB4B,UAAA;ACxjB5B;;ADikBA,oBAAA;ACtiBA;EACE,kBAAkB;EDwiBpB,kDAAA;EACC,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;ACtiBD;AACA;EAvBA,eAAA;EDgkBI,kBAAA;EACI,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;ACtiBR;AACA;EDwiBQ,cAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAxgIK;EC08Gb,eAAA;EDgkBI,kDAAA;EACI,uBAAA;EACA,kBAAA;EC9jBR,gBAAA;ADikBQ;ACviBR;EAvBA,gBAAA;ADikBY;ACviBZ;EAvBA,iBAAA;EDikBgB,gBAAA;EACI,qBA9hIP;AC+9Gb;ADkkBY;EACI,cAAA;EChkBhB,0BAAA;EDokBI,gCAAA;EACI,mBAAA;EACA,oBAAA;AClkBR;ADokBQ;EACI,gBAAA;AC1iBZ;AAvBA;EAyBE,6BAA6B;ED6iB/B,iBAAA;AC3iBA;AACA;;EAEE,2BAA2B;AD4iB7B;;ACjkBA;EAyBE,mBAAmB;AD4iBjB;AC1iBJ;;EAtBA,mBAAA;ADokBI;AC1iBJ;EAvBA,mBAAA;ADokBQ;AC1iBR;EAvBA,cAAA;ADokBQ;AC1iBR;;ED6iBY,mBAAA;AClkBZ;ADokBY;EACI,mBAAA;AClkBhB;ADokBgB;;ECjkBhB,mBAAA;ADokBgB;AC1iBhB;ED4iBoB,mBAAA;AC1iBpB;AAvBA;EDokBoB,cAAA;AC1iBpB;AACA;;ED6iBwB,mBAAA;AC1iBxB;;AAEA;;kDD6iBwB;AClkBxB;EDokBoB,gBAAA;EACI,yBA9lIX;AC4hHb;AAyBA;EDgjBA,cAAA;EACC,eAAA;EACA,gBAAA;EACG,mBAAA;ECtkBJ,kBAAA;EDwkBI,yBAAA;EACI;ICtkBR,iBAAA;EDwkBI;EACI;ICtkBR,eAAA;EDwkBI;AC9iBJ;AACA;EAvBA,eAAA;EDukBQ,oBAAA;EACI,kBAAA;EACA,qDAAA;EACA,6BAAA;ECrkBZ,0BAAA;EDwkBI,qBAAA;EAEQ,kBAAA;EACA,SAAA;ECvkBZ,gCAAA;ED0kBI;IACI,iBAAA;ECxkBR;;ED4kBA;ICjjBI,eAAe;EACjB;ADmjBF;;AChjBA;EAvBA,qDAAA;EAyBE,6BAA6B;EDqjB3B,0BAAA;EACI,qBA5oIM;EA6oIN,kBAAA;EACA,eAAA;EC3kBR,gBAAA;ED6kBI,SAAA;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EC3kBR;ID6kBQ,iBAAA;EACI;EC3kBZ;ID8kBI,eAAA;EACI;ACpjBR;;ADujBI;EACI,qDAAA;EACA,6BAAA;EC5kBR,0BAAA;ED6kBQ,qBAAA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EC3kBZ,eAAA;ED8kBI,kBAAA;EACI,sCAAA;EACA,yBAAA;EC5kBR;ID8kBQ,iBAAA;EACI;EC5kBZ;ID8kBQ,eAAA;EACI;AC5kBZ;;AA0BA;EDujBQ,cAAA;EACA,eAAA;EC7kBR,gBAAA;ED+kBQ,SAAA;EACI,kBAAA;EACA,0BAAA;EC7kBZ;ID+kBY,gBAAA;EACI;EACA;IACA,eAAA;EACA;ACrjBhB;;AAEA;EDujBgB,qDAAA;EC7kBhB,6BAAA;ED+kBgB,0BAAA;EACI,qBAAA;EACA,kBAAA;EC7kBpB,qBAAA;ED+kBgB,sCAAA;EACI,eAAA;EACA,gBAAA;EC7kBpB,kBAAA;ED+kBgB,yBAAA;EACI;IACA,iBAAA;EC7kBpB;ED+kBgB;IACI,eAAA;EACA;AC7kBpB;;AA0BA;EDujBoB,qDAvtIN;EAwtIM,6BA3tIP;EC8oHb,0BAAA;EAyBE,qBAAqB;ED0jBvB,kBAAA;EACI,eAAA;EAEI,gBAAA;EACA,kBAAA;EAEJ,kBAAA;EACA,yBAAA;ECllBJ;IDqlBQ,iBAAA;EACI;ECnlBZ;IDslBI,eAAA;EACI;AC5jBR;;AAtBA;EDslBQ,cAAA;EACI,eAAA;EACA,gBAAA;EACA,SAAA;ECplBZ,kBAAA;EDslBY,0BAAA;EACI;IACA,gBAAA;EACA;EACA;IACA,eAAA;EACA;AC5jBhB;;AAEA;EAvBA,aAAA;EDslBY,uBAAA;EACI,mBAAA;ECplBhB,UAAA;EDslBgB,YAAA;EACI;ICplBpB,UAAA;EDulBY;EACI;;KAEA;AC7jBhB;;ADikBY;EACI,WAAA;ECtlBhB,kBAAA;ED0lBI,uCAAA;AChkBJ;;AAEA;EDmkBA,mCAAA;ACjkBA;;ADokBA;EACI,kBAAA;EACA,mBAAA;ACjkBJ;AACA;EDmkBI,eAAA;EACA,gBAAA;EACA,gBAAA;EAEI,cAAA;EACA,yBAAA;EAEJ,mCAAA;ACnkBJ;AACA;EDskBI,cAAA;ACpkBJ;AACA;EAvBA,kBAAA;AD8lBI;ACpkBJ;EDskBQ,kBAAA;ACpkBR;AACA;EDskBQ,uBAAA;EACA,gCAAA;ACpkBR;AAvBA;ED8lBI,kBAAA;EACI,OAAA;EACA,SAAA;EACA,QAAA;EC5lBR,cAAA;ED8lBI,UAAA;EACI,kBAAA;EACA,gBAAA;ACpkBR;AAvBA;ED8lBI,UAAA;EACI,mBAAA;EACA,MAAA;ACpkBR;AACA;EAvBA,sCAAA;ED8lBI,gBAAA;EACI,mBAAA;ACpkBR;;AAtBA;;kDDgmBA;ACrkBA;EAvBA,kBAAA;EAyBE,UAAU;ADukBZ;ACrkBA;EAvBA,yDAAA;EAyBE,kCAAkC;EDukBpC,sBAAA;EACI,4BAAA;EC7lBJ,4BAAA;AAyBA;;AAEA;EAvBA,mBAAA;EAyBE,yBAAyB;EDwkBvB,6CAAA;ACtkBJ;AAvBA;EDimBQ,kBAAA;EACI,gBAp2IM;AC6xHlB;AACA;EAvBA,cAAA;AAyBA;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;;EAIE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,OAAO;EACP,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;kDAEkD;AAClD;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;;AAEA;;kDAEkD;AAClD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oDAAoD;EACpD,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B;IACE,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,mBAAmB;AACrB;;AAEA;;kDAEkD;AAClD;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;;AAEA;;kDAEkD;AAClD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;kDAEkD;AAClD;EACE,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gDAAgD;EAChD,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;kDAEkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mEAAmE;EACnE,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;AACvB;AAIA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,MAAM;EACN,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;kDAEkD;AAClD;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;AACd;AACA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;kDAEkD;AAClD;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;;;;EAIE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;;;EAQE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;;;;;;EAQE,qBAAqB;AACvB;AACA;;;;EAIE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;;kDAEkD;AAClD;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EAEnB,sDAAsD;EACtD,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;;kDAEkD;AAClD;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;;kDAEkD;AAClD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yDAAqE;EACrE,+BAA+B;EAC/B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB;IACE,iBAAiB;EACnB;AACF;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ;;;;;;;;;;;;;;;;;;;;;;;;;KAyBG;AACL;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV;IACE,UAAU;EACZ;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd;IACE,iBAAiB;EACnB;AACF;;AAEA;;kDAEkD;AAClD;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,gDAAgD;AAClD;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,UAAU;EACV,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;AACA;;EAEE,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;EAME,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yDAAiE;EACjE,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;;EAExB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qDAAqD;EACrD,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,wBAAwB;EACxB,sBAAsB;EACtB;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/*\n@File: Evnia Template Styles\n\n* This file contains the styling for the actual tepmlate, this\nis the file you need to edit to change the look of the\ntepmlate.\n\nThis files table contents are outlined below>>>>>\n\n*******************************************\n*******************************************\n\n** - Default CSS\n** - Preloader CSS\n** - Navbar CSS\n** - Main Banner CSS\n** - About CSS\n** - Why Choose Us CSS\n** - CTA CSS\n** - Speakers CSS\n** - Schedule CSS\n** - FunFacts CSS\n** - Pricing CSS\n** - Partner CSS\n** - Blog CSS\n** - Buy Tickets CSS\n** - Subscribe CSS\n** - Page Title CSS\n** - Login CSS\n** - Signup CSS\n** - 404 Error CSS\n** - FAQ CSS\n** - Coming Soon CSS\n** - Pagination CSS\n** - Blog Details CSS\n** - Sidebar CSS\n** - Contact Us CSS\n** - Footer CSS\n** - Back To Top CSS\n*/\n\n/*================================================\nDefault CSS\n=================================================*/\n\n$main-color: #ff2d55;\n$sub-main-color: #00acee;\n$black-color: #0d1028;\n$white-color: #ffffff;\n$yellow-color: #efa506;\n$paragraph-color: #707070;\n$green-light-color: #8dc63f;\n$gradient-color: linear-gradient(\n  to bottom,\n  rgba(0, 0, 0, 0) 80%,\n  $main-color 80%\n);\n$transition: 0.5s;\n$font-size: 15px;\n\nbody {\n  padding: 0;\n  margin: 0;\n  font-size: $font-size;\n}\na {\n  display: inline-block;\n  transition: $transition;\n  text-decoration: none;\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n}\n.d-table {\n  width: 100%;\n  height: 100%;\n\n  &-cell {\n    vertical-align: middle;\n  }\n}\n.ptb-120 {\n  padding: {\n    top: 120px;\n    bottom: 120px;\n  }\n}\nimg {\n  max-width: 100%;\n  height: auto;\n}\np {\n  line-height: 1.9;\n  color: $paragraph-color;\n  margin-bottom: 15px;\n  font-size: $font-size;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 700;\n  color: $black-color;\n}\n.text-right {\n  text-align: end;\n}\n.text-left {\n  text-align: start;\n}\n.form-group {\n  margin-bottom: 30px;\n}\ntextarea.form-control {\n  min-height: auto !important;\n  height: auto;\n}\nlabel {\n  margin-bottom: 10px;\n}\n/*btn btn-primary*/\n.btn {\n  font: {\n    weight: 600;\n    size: $font-size;\n  }\n  color: $white-color;\n  box-shadow: 0 8px 6px -6px rgba(50, 51, 51, 0.4);\n  border: none;\n  padding: 15px 30px;\n  border-radius: 0;\n  transition: $transition;\n}\n.btn-primary {\n  color: $white-color;\n  background: $black-color;\n  position: relative;\n  z-index: 1;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    width: 51%;\n    background: $main-color;\n    height: 100%;\n    z-index: -1;\n    transition: $transition;\n  }\n  &::before {\n    left: 0;\n  }\n  &::after {\n    right: 0;\n  }\n  &:hover::before,\n  &:hover::after,\n  &:focus::before,\n  &:focus::after {\n    width: 0;\n  }\n  &.focus,\n  &:focus {\n    box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n    color: $white-color;\n  }\n  &:hover,\n  &:focus {\n    background: $black-color;\n    color: $white-color;\n    box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n  }\n  &:not(:disabled):not(.disabled).active:focus,\n  &:not(:disabled):not(.disabled):active:focus {\n    box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n  }\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active {\n    background: $black-color;\n    color: $white-color;\n  }\n  &.disabled,\n  &:disabled {\n    opacity: 1;\n    background: $black-color;\n  }\n}\n.btn-secondary {\n  color: $white-color;\n  background: $black-color;\n  position: relative;\n  z-index: 1;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    width: 51%;\n    background: $sub-main-color;\n    height: 100%;\n    z-index: -1;\n    transition: $transition;\n  }\n  &::before {\n    left: 0;\n  }\n  &::after {\n    right: 0;\n  }\n  &:hover::before,\n  &:hover::after,\n  &:focus::before,\n  &:focus::after {\n    width: 0;\n  }\n  &.focus,\n  &:focus {\n    box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n    color: $white-color;\n  }\n  &:hover,\n  &:focus {\n    background: $black-color;\n    color: $white-color;\n    box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n  }\n  &:not(:disabled):not(.disabled).active:focus,\n  &:not(:disabled):not(.disabled):active:focus {\n    box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n  }\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active {\n    background: $black-color;\n    color: $white-color;\n  }\n  &.disabled,\n  &:disabled {\n    opacity: 1;\n    background: $black-color;\n  }\n}\n/*section-title*/\n.section-title {\n  position: relative;\n  margin-bottom: 60px;\n  z-index: 1;\n\n  span {\n    color: $main-color;\n    letter-spacing: 1px;\n    font-size: 16px;\n    text-transform: uppercase;\n    display: block;\n  }\n  h2 {\n    font-size: 40px;\n    margin: {\n      top: 10px;\n      bottom: 10px;\n    }\n\n    b {\n      background: $gradient-color;\n      font-weight: unset;\n      background-size: 100px 1.07em !important;\n    }\n  }\n  .btn {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    margin-top: -18px;\n  }\n  .bg-title {\n    color: rgba(73, 57, 231, 0.05);\n    font: {\n      weight: 700;\n      size: 140px;\n    }\n    line-height: 120px;\n    position: absolute;\n    top: 0;\n    right: 35%;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    z-index: -1;\n    margin-top: -25px;\n  }\n  .bar {\n    position: relative;\n    width: 20px;\n    height: 4px;\n    background: $main-color;\n    display: block;\n\n    &::after,\n    &::before {\n      position: absolute;\n      height: 100%;\n      top: 0;\n      right: 0;\n      content: \"\";\n    }\n    &::after {\n      width: 25px;\n      background: $sub-main-color;\n      right: -29px;\n    }\n    &::before {\n      background: $yellow-color;\n      width: 30px;\n      right: -63px;\n    }\n  }\n}\n/*owl-carousel-btn*/\n.owl-theme {\n  .owl-nav {\n    &.disabled {\n      + .owl-dots {\n        margin-top: 0;\n        line-height: 0.01;\n      }\n    }\n  }\n  .owl-dots {\n    .owl-dot {\n      span {\n        width: 15px;\n        height: 15px;\n        margin: 0 4px;\n        background: transparent;\n        border: 1px solid #dfdfdf;\n        display: block;\n        transition: $transition;\n        border-radius: 50%;\n        position: relative;\n      }\n      &:hover,\n      &:focus {\n        outline: 0;\n        box-shadow: unset !important;\n\n        span {\n          background: $sub-main-color;\n          border-color: $sub-main-color;\n        }\n      }\n      &.active {\n        span {\n          background: $main-color;\n          border-color: $main-color;\n        }\n      }\n    }\n  }\n}\n/*form-control*/\n.form-control {\n  height: 50px;\n  padding: 15px;\n  font: {\n    size: 14px;\n    weight: 500;\n  }\n  border: 1px solid #eeeeee;\n  border-radius: 0;\n  transition: $transition;\n\n  &:hover,\n  &:focus,\n  &.active {\n    box-shadow: unset;\n    border-color: $main-color;\n  }\n}\n\n/*================================================\nPreloader CSS\n=================================================*/\n.preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999999;\n  overflow: hidden;\n  background: $black-color;\n\n  .loader {\n    display: block;\n    position: relative;\n    left: 50%;\n    top: 50%;\n    width: 110px;\n    height: 110px;\n    margin: -80px 0 0 -75px;\n    border-radius: 50%;\n    border: 7px solid transparent;\n    border-top-color: $main-color;\n    animation: spin 1.7s linear infinite;\n    z-index: 11;\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      top: 5px;\n      left: 5px;\n      right: 5px;\n      bottom: 5px;\n      border-radius: 50%;\n      border: 7px solid transparent;\n      border-top-color: $yellow-color;\n      animation: spin-reverse 0.6s linear infinite;\n    }\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 15px;\n      left: 15px;\n      right: 15px;\n      bottom: 15px;\n      border-radius: 50%;\n      border: 7px solid transparent;\n      border-top-color: $sub-main-color;\n      animation: spin 1s linear infinite;\n    }\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-reverse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n/*================================================\nNavbar CSS\n=================================================*/\n.elkevent-nav {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding-top: 20px;\n  width: 100%;\n  z-index: 999;\n  height: auto;\n\n  nav {\n    ul {\n      padding: 0;\n      margin: 0;\n      list-style-type: none;\n    }\n    .navbar-nav {\n      .nav-item {\n        position: relative;\n        padding: 15px 0;\n\n        a {\n          font: {\n            weight: 500;\n            size: 16px;\n          }\n          text-transform: uppercase;\n          color: $white-color;\n          padding: {\n            left: 0;\n            right: 0;\n            top: 0;\n            bottom: 0;\n          }\n          margin: {\n            left: 15px;\n            right: 15px;\n          }\n\n          &:hover,\n          &:focus,\n          &.active {\n            color: $main-color;\n          }\n        }\n        &:hover {\n          a {\n            color: $main-color;\n          }\n        }\n        .dropdown-menu {\n          box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.05);\n          background: $black-color;\n          position: absolute;\n          top: 80px;\n          right: 0 !important;\n          width: 250px;\n          z-index: 99;\n          display: block;\n          padding: {\n            top: 20px;\n            left: 5px;\n            right: 5px;\n            bottom: 20px;\n          }\n          opacity: 0;\n          visibility: hidden;\n          transition: all 0.3s ease-in-out;\n\n          li {\n            position: relative;\n            padding: 0;\n\n            a {\n              font: {\n                size: 15px;\n                weight: 500;\n              }\n              text-transform: capitalize;\n              padding: 9px 15px;\n              margin: 0;\n              display: block;\n              color: $white-color;\n\n              &:hover,\n              &:focus,\n              &.active {\n                color: $main-color;\n              }\n            }\n            .dropdown-menu {\n              position: absolute;\n              //   left: 220px;\n              top: 0;\n              opacity: 0 !important;\n              visibility: hidden !important;\n\n              li {\n                a {\n                  color: $white-color;\n                  text-transform: capitalize;\n\n                  &:hover,\n                  &:focus,\n                  &.active {\n                    color: $main-color;\n                  }\n                }\n              }\n            }\n            &:hover {\n              .dropdown-menu {\n                opacity: 1 !important;\n                visibility: visible !important;\n                top: -20px !important;\n              }\n              a {\n                color: $main-color;\n              }\n            }\n          }\n        }\n        &:hover {\n          ul {\n            opacity: 1;\n            visibility: visible;\n            top: 100%;\n          }\n        }\n      }\n    }\n    .others-option {\n      margin-left: 13px;\n    }\n  }\n  &.is-sticky {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    padding: 5px 0;\n    z-index: 999;\n    box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);\n    background-color: $black-color !important;\n    animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;\n  }\n}\n// Navbar toggler\n.navbar-toggler {\n  border: none;\n  background: #eee !important;\n  padding: 10px;\n  border-radius: 0;\n\n  &:focus {\n    box-shadow: none;\n  }\n\n  .icon-bar {\n    width: 28px;\n    transition: all 0.3s;\n    background: $main-color;\n    height: 2px;\n    display: block;\n  }\n  .top-bar {\n    transform: rotate(45deg);\n    transform-origin: 10% 10%;\n    left: 4px;\n    position: relative;\n  }\n  .middle-bar {\n    opacity: 0;\n    margin: 6px 0;\n  }\n  .bottom-bar {\n    transform: rotate(-45deg);\n    transform-origin: 10% 90%;\n    left: 4px;\n    position: relative;\n  }\n  &.collapsed {\n    .top-bar {\n      transform: rotate(0);\n      left: 0;\n    }\n    .middle-bar {\n      opacity: 1;\n    }\n    .bottom-bar {\n      transform: rotate(0);\n      left: 0;\n    }\n  }\n}\n\n/*================================================\nMain Banner CSS\n=================================================*/\n.main-banner {\n  height: 100vh;\n  position: relative;\n  z-index: 1;\n  background: {\n    position: center center;\n    size: cover;\n    repeat: no-repeat;\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    background: $black-color;\n    opacity: 0.77;\n  }\n}\n.slideshow-banner {\n  &::before {\n    z-index: 1;\n  }\n  .main-banner-content {\n    margin-top: 50px;\n    &::before {\n      display: none;\n    }\n  }\n  .slideshow {\n    z-index: -1;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      span {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        color: transparent;\n        background: {\n          size: cover;\n          position: center center;\n          repeat: no-repeat;\n        }\n        opacity: 0;\n        z-index: 0;\n        backface-visibility: hidden;\n        animation: imageAnimation 24s linear infinite 0s;\n      }\n\n      &:nth-child(2) span {\n        animation-delay: 6s;\n      }\n      &:nth-child(3) span {\n        animation-delay: 12s;\n      }\n      &:nth-child(4) span {\n        animation-delay: 18s;\n      }\n    }\n  }\n  .event-countdown {\n    position: relative;\n    right: 0;\n    bottom: 0;\n    text-align: left;\n\n    #days {\n      margin-left: 0;\n    }\n  }\n}\n.video-banner {\n  overflow: hidden;\n\n  .video-background {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: auto;\n    height: auto;\n    min-height: 100%;\n    min-width: 100%;\n    z-index: -2;\n  }\n}\n.item-bg1 {\n  background-image: url(\"/images/main-bg1.jpg\");\n}\n.item-bg2 {\n  background-image: url(\"/images/main-bg2.jpg\");\n}\n.item-bg3 {\n  background-image: url(\"/images/slider-bg1.jpg\");\n}\n.item-bg4 {\n  background-image: url(\"/images/slider-bg2.jpg\");\n}\n.item-bg5 {\n  background-image: url(\"/images/slider-bg3.jpg\");\n}\n.main-banner-content {\n  position: relative;\n  z-index: 1;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: -75px;\n    width: 100%;\n    max-width: 380px;\n    text-align: center;\n    height: 500px;\n    left: 18%;\n    margin-left: -190px;\n    z-index: -1;\n    border: 18px solid rgba(104, 89, 222, 0.24);\n    box-sizing: border-box;\n    box-shadow: 0 60px 40px -40px rgba(0, 0, 0, 0.3);\n  }\n  h1 {\n    color: $white-color;\n    margin: 0;\n    font: {\n      weight: 900;\n      size: 65px;\n    }\n    span {\n      background: $gradient-color;\n      background-size: 100px 1.2em !important;\n    }\n    b {\n      &:nth-of-type(1) {\n        color: $yellow-color;\n      }\n      &:nth-of-type(2) {\n        color: $main-color;\n      }\n      &:nth-of-type(3) {\n        color: $white-color;\n        animation: colorchange 20s;\n      }\n      &:nth-of-type(4) {\n        color: $sub-main-color;\n      }\n    }\n  }\n  ul {\n    padding: 0;\n    margin: 25px 0 40px;\n    list-style-type: none;\n\n    li {\n      color: #fff;\n      margin-right: 20px;\n      font-size: 17px;\n      display: inline-block;\n\n      i {\n        margin-right: 3px;\n        color: $main-color;\n      }\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n  p {\n    color: $yellow-color;\n    font: {\n      size: 22px;\n    }\n    letter-spacing: 1px;\n    margin-bottom: 10px;\n\n    span {\n      color: $sub-main-color;\n    }\n  }\n  .button-box {\n    a {\n      display: inline-block;\n    }\n    .video-btn {\n      margin-left: 30px;\n      color: #fff;\n      font-weight: 500;\n      cursor: pointer;\n\n      i {\n        width: 50px;\n        display: inline-block;\n        height: 50px;\n        line-height: 51px;\n        text-align: center;\n        background-color: $sub-main-color;\n        border-radius: 50%;\n        font-size: 17px;\n        margin-right: 8px;\n        z-index: 1;\n        position: relative;\n        transition: $transition;\n\n        &::after {\n          z-index: -1;\n          content: \"\";\n          position: absolute;\n          left: 0;\n          top: 0;\n          width: 50px;\n          height: 50px;\n          animation: ripple 1.6s ease-out infinite;\n          animation-delay: 3s;\n          opacity: 0;\n          border-radius: 50%;\n          background: rgba(51, 102, 204, 0.5);\n        }\n      }\n      &:hover,\n      &:focus {\n        color: $sub-main-color;\n\n        i {\n          background-color: $main-color;\n          color: $white-color;\n        }\n      }\n    }\n  }\n  &.banner-content-center {\n    margin: 50px auto 0;\n    text-align: center;\n  }\n}\n.countdown-area {\n  padding: 50px 0;\n  background: $green-light-color;\n\n  .event-countdown {\n    position: relative;\n    right: 0;\n    bottom: 0;\n    text-align: center;\n\n    #timer {\n      div {\n        margin: 0 55px;\n\n        &#seconds {\n          color: $main-color;\n        }\n      }\n    }\n  }\n}\n.event-countdown {\n  position: absolute;\n  right: 10%;\n  bottom: 20px;\n  text-align: right;\n\n  #timer {\n    div {\n      display: inline-block;\n      font: {\n        size: 55px;\n        weight: 700;\n      }\n      color: $white-color;\n      margin: 0 35px;\n      position: relative;\n\n      &#days {\n        color: $main-color;\n      }\n      &#hours {\n        color: $sub-main-color;\n\n        span {\n          right: -50px;\n          margin-top: -12px;\n        }\n      }\n      &#minutes {\n        color: $white-color;\n\n        span {\n          right: -55px;\n          margin-top: -12px;\n        }\n      }\n      &#seconds {\n        color: $yellow-color;\n\n        span {\n          right: -60px;\n          margin-top: -12px;\n        }\n      }\n    }\n    span {\n      display: block;\n      color: $white-color;\n      margin-top: 0;\n      font: {\n        size: 14px;\n        weight: 500;\n      }\n      position: absolute;\n      right: -40px;\n      top: 50%;\n      text-transform: uppercase;\n      transform: rotate(-90deg);\n      margin-top: -10px;\n      letter-spacing: 2px;\n    }\n  }\n}\n.countdown1 {\n  bottom: 15px !important;\n  #timer {\n    div {\n      font-size: 60px;\n    }\n    span {\n      display: inline-block;\n      font-size: 14px;\n      position: initial;\n      transform: rotate(0deg);\n    }\n  }\n}\n@keyframes ripple {\n  0%,\n  35% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.5);\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(2);\n  }\n}\n.shape1 {\n  position: absolute;\n  left: 70px;\n  bottom: 70px;\n  z-index: -1;\n  animation: movebounce 5s linear infinite;\n  opacity: 0.6;\n}\n.shape2 {\n  position: absolute;\n  right: 70px;\n  bottom: 70px;\n  z-index: -1;\n  opacity: 0.6;\n}\n.shape3 {\n  position: absolute;\n  left: 70px;\n  top: 70px;\n  z-index: -1;\n  opacity: 0.6;\n}\n.shape4 {\n  position: absolute;\n  right: 100px;\n  top: 100px;\n  z-index: -1;\n  opacity: 0.6;\n  animation: movebounce 5s linear infinite;\n}\n.rotateme {\n  animation-name: rotateme;\n  animation-duration: 40s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n@keyframes rotateme {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes movebounce {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(20px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes colorchange {\n  0% {\n    color: $main-color;\n  }\n  25% {\n    color: $white-color;\n  }\n  50% {\n    color: red;\n  }\n  75% {\n    color: $sub-main-color;\n  }\n  0% {\n    color: $yellow-color;\n  }\n}\n.home-slides {\n  .swiper-button-next,\n  .swiper-button-prev {\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    background-color: $sub-main-color;\n    color: $white-color;\n    transition: $transition;\n    opacity: 0.7;\n\n    &::after {\n      font: {\n        size: 25px;\n      }\n    }\n    &:hover {\n      background-color: $main-color;\n      color: $white-color;\n    }\n  }\n}\n\n/*================================================\nAbout CSS\n=================================================*/\n.about-area {\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n\n  &.bg-image {\n    background: {\n      image: url(\"/images/bg.jpg\");\n      position: center center;\n      size: cover;\n      repeat: no-repeat;\n    }\n  }\n}\n.about-content {\n  span {\n    color: $main-color;\n    letter-spacing: 1px;\n    font-size: 16px;\n    text-transform: uppercase;\n    display: block;\n  }\n  h2 {\n    font-size: 40px;\n    margin-top: 10px;\n    margin-bottom: 25px;\n\n    b {\n      background: $gradient-color;\n      font-weight: unset;\n      background-size: 100px 1.05em !important;\n    }\n  }\n  .signature {\n    margin: {\n      top: 35px;\n      bottom: 35px;\n    }\n  }\n  .btn-primary {\n    margin-right: 20px;\n  }\n}\n.about-image {\n  position: relative;\n  .about-img1 {\n    position: relative;\n    right: -100px;\n    top: -80px;\n  }\n  .about-img2 {\n    position: absolute;\n    left: 20px;\n    bottom: -80px;\n  }\n  .shape-img {\n    position: absolute;\n    top: -28px;\n    left: 48%;\n    animation: movebounce 5s linear infinite;\n  }\n  .btn {\n    position: absolute;\n    bottom: -20px;\n    right: 0;\n  }\n}\n/*about-style-two*/\n.about-area-two {\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n\n  &.bg-image {\n    background: {\n      image: url(\"/images/bg.jpg\");\n      position: center center;\n      size: cover;\n      repeat: no-repeat;\n    }\n  }\n  .about-image {\n    .about-img1 {\n      position: relative;\n      right: 0;\n      top: 0;\n    }\n    .btn {\n      bottom: 0;\n    }\n  }\n  .about-content {\n    .signature {\n      margin-bottom: 0;\n    }\n  }\n}\n/*about-style-three*/\n.about-area-three {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n\n  &.bg-image {\n    background: {\n      image: url(\"/images/bg.jpg\");\n      position: center center;\n      size: cover;\n      repeat: no-repeat;\n    }\n  }\n  .about-image {\n    .about-img1 {\n      position: relative;\n      right: 0;\n      top: 0;\n    }\n    .btn {\n      bottom: 0;\n      left: 70px;\n      right: auto;\n    }\n  }\n  .about-content {\n    .signature {\n      margin-bottom: 0;\n    }\n    h6 {\n      font-weight: 600;\n      line-height: 24px;\n      margin-bottom: 20px;\n    }\n    p {\n      margin-bottom: 0;\n    }\n    ul {\n      padding: 0;\n      margin: 20px 0 0;\n      list-style-type: none;\n\n      li {\n        margin-bottom: 10px;\n        color: $paragraph-color;\n        padding-left: 20px;\n        position: relative;\n\n        i {\n          color: $main-color;\n          position: absolute;\n          left: 0;\n          top: 50%;\n          margin-top: -7px;\n        }\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nWhy Choose Us CSS\n=================================================*/\n.why-choose-us {\n  position: relative;\n  z-index: 1;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    background: $black-color;\n    opacity: 0.7;\n  }\n  .slideshow {\n    z-index: -1;\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n\n    li {\n      span {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        color: transparent;\n        background: {\n          size: cover;\n          position: center center;\n          repeat: no-repeat;\n        }\n        opacity: 0;\n        z-index: 0;\n        backface-visibility: hidden;\n        animation: imageAnimation 24s linear infinite 0s;\n      }\n      &:nth-child(2) span {\n        animation-delay: 6s;\n      }\n      &:nth-child(3) span {\n        animation-delay: 12s;\n      }\n      &:nth-child(4) span {\n        animation-delay: 18s;\n      }\n    }\n  }\n}\n.col-lg-3 {\n  &:first-child {\n    .single-box {\n      border-left: none;\n    }\n  }\n}\n.single-box {\n  position: relative;\n  z-index: 1;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  text-align: center;\n  height: 450px;\n\n  .d-table-cell {\n    vertical-align: bottom;\n  }\n  .content {\n    position: absolute;\n    padding: {\n      left: 25px;\n      right: 25px;\n    }\n    bottom: 0;\n    left: 0;\n    transition: $transition;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      bottom: 5px;\n      width: 100%;\n      max-width: 280px;\n      text-align: center;\n      height: 260px;\n      left: 50%;\n      margin-left: -155px;\n      z-index: -1;\n      border: 10px solid rgba(104, 89, 222, 0.03);\n    }\n    .icon {\n      font-size: 45px;\n      color: $main-color;\n    }\n    h3 {\n      font-size: 26px;\n      color: $white-color;\n      margin: {\n        top: 15px;\n        bottom: 15px;\n      }\n    }\n    p {\n      color: $white-color;\n      margin-bottom: 0;\n      transition: $transition;\n    }\n    .btn {\n      opacity: 0;\n      visibility: hidden;\n    }\n  }\n  &:hover,\n  &:focus {\n    .content {\n      bottom: 35px;\n\n      p {\n        margin-bottom: 25px;\n      }\n      .btn {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n  }\n}\n@keyframes imageAnimation {\n  0% {\n    opacity: 0;\n    animation-timing-function: ease-in;\n  }\n  12.5% {\n    opacity: 1;\n    animation-timing-function: ease-out;\n  }\n  25% {\n    opacity: 1;\n  }\n  37.5% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.no-cssanimations {\n  .slideshow {\n    li {\n      span {\n        opacity: 1;\n      }\n    }\n  }\n}\n/*why-choose-style-two*/\n.why-choose-us-two {\n  max-width: 1920px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.why-choose-content {\n  text-align: center;\n  padding: 20px 25px;\n  position: relative;\n  z-index: 1;\n\n  h3 {\n    font-size: 24px;\n    margin-bottom: 15px;\n  }\n  p {\n    margin-bottom: 0;\n  }\n  a {\n    color: $main-color;\n    margin-top: 15px;\n\n    &:hover,\n    &:focus {\n      letter-spacing: 1px;\n    }\n  }\n  span {\n    font: {\n      size: 100px;\n      weight: 700;\n    }\n    color: #f2f2f2;\n    line-height: 90px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: -10px auto 0;\n    z-index: -1;\n    top: 0;\n  }\n}\n\n/*================================================\nCTA CSS\n=================================================*/\n.cta-area {\n  background-color: $main-color;\n  padding: {\n    top: 50px;\n    bottom: 50px;\n  }\n  span {\n    display: block;\n    color: $white-color;\n    font-size: 20px;\n  }\n  h3 {\n    color: $white-color;\n    font-size: 35px;\n    margin: {\n      bottom: 10px;\n    }\n  }\n}\n\n/*================================================\nSpeakers CSS\n=================================================*/\n.single-speakers {\n  overflow: hidden;\n  position: relative;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    background: linear-gradient(\n      transparent 0%,\n      transparent 40%,\n      rgba(0, 0, 0, 0.3) 58%,\n      rgba(0, 0, 0, 0.8) 89%,\n      rgba(0, 0, 0, 0.63) 100%\n    );\n    width: 100%;\n    height: 100%;\n  }\n  .speakers-content {\n    position: absolute;\n    bottom: 35px;\n    left: 35px;\n    transition: $transition;\n\n    h3 {\n      font-size: 24px;\n      margin-bottom: 0;\n      color: $main-color;\n\n      &:hover,\n      &:focus {\n        color: $green-light-color;\n      }\n    }\n    span {\n      display: block;\n      margin-top: 6px;\n      color: $white-color;\n      transition: $transition;\n    }\n  }\n  ul {\n    padding: 15px;\n    margin: 0 0 0;\n    opacity: 0;\n    visibility: hidden;\n    list-style-type: none;\n    transition: $transition;\n    position: absolute;\n    right: -15px;\n    top: 0;\n    background-color: $white-color;\n\n    li {\n      display: block;\n      margin-bottom: 10px;\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      a {\n        width: 35px;\n        height: 35px;\n        line-height: 35px;\n        text-align: center;\n        background-color: $main-color;\n        color: $white-color;\n        border-radius: 50%;\n        font-size: 14px;\n\n        &.facebook {\n          background-color: #4267b2;\n        }\n        &.twitter {\n          background-color: #38a1f3;\n        }\n        &.instagram {\n          background: radial-gradient(\n              circle farthest-corner at 35% 90%,\n              #fec564,\n              transparent 50%\n            ),\n            radial-gradient(\n              circle farthest-corner at 0 140%,\n              #fec564,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 0 -25%,\n              #5258cf,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 20% -50%,\n              #5258cf,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 100% 0,\n              #893dc2,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 60% -20%,\n              #893dc2,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 100% 100%,\n              #d9317a,\n              transparent\n            ),\n            linear-gradient(\n              #6559ca,\n              #bc318f 30%,\n              #e33f5f 50%,\n              #f77638 70%,\n              #fec66d 100%\n            );\n        }\n        &.linkedin {\n          background-color: #0077b5;\n        }\n        &:hover,\n        &:focus {\n          background-color: $main-color;\n          color: $white-color;\n        }\n      }\n    }\n  }\n  &:hover,\n  &:focus {\n    .speakers-content {\n      bottom: 45px;\n    }\n    ul {\n      right: 0;\n      opacity: 1;\n      visibility: visible;\n    }\n  }\n}\n/*Speakers-Style-Two*/\n.elkevent-single-speakers {\n  overflow: hidden;\n  position: relative;\n\n  .speakers-content {\n    position: absolute;\n    bottom: -25px;\n    left: 0;\n    background-color: $white-color;\n    width: 100%;\n    height: auto;\n    padding: 25px;\n    opacity: 0;\n    visibility: hidden;\n    transition: $transition;\n\n    h3 {\n      font-size: 24px;\n      margin-bottom: 0;\n\n      a {\n        color: $black-color;\n\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n      }\n    }\n    span {\n      display: block;\n      margin-top: 8px;\n      color: $main-color;\n      transition: $transition;\n    }\n  }\n  ul {\n    padding: 15px 20px 10px;\n    margin: 0 0 0;\n    opacity: 0;\n    visibility: hidden;\n    list-style-type: none;\n    transition: $transition;\n    position: absolute;\n    right: -15px;\n    top: 0;\n    background-color: $white-color;\n\n    li {\n      display: block;\n      margin-bottom: 5px;\n\n      a {\n        width: 35px;\n        height: 35px;\n        line-height: 35px;\n        text-align: center;\n        background-color: $main-color;\n        color: $white-color;\n        border-radius: 50%;\n        font-size: 14px;\n\n        &.facebook {\n          background-color: #4267b2;\n        }\n        &.twitter {\n          background-color: #38a1f3;\n        }\n        &.instagram {\n          background: radial-gradient(\n              circle farthest-corner at 35% 90%,\n              #fec564,\n              transparent 50%\n            ),\n            radial-gradient(\n              circle farthest-corner at 0 140%,\n              #fec564,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 0 -25%,\n              #5258cf,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 20% -50%,\n              #5258cf,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 100% 0,\n              #893dc2,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 60% -20%,\n              #893dc2,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 100% 100%,\n              #d9317a,\n              transparent\n            ),\n            linear-gradient(\n              #6559ca,\n              #bc318f 30%,\n              #e33f5f 50%,\n              #f77638 70%,\n              #fec66d 100%\n            );\n        }\n        &.linkedin {\n          background-color: #0077b5;\n        }\n        &:hover,\n        &:focus {\n          background-color: $main-color;\n          color: $white-color;\n        }\n      }\n    }\n  }\n  img {\n    transition: $transition;\n  }\n  &:hover,\n  &:focus {\n    .speakers-content {\n      bottom: 0;\n      opacity: 1;\n      visibility: visible;\n    }\n    ul {\n      right: 0;\n      opacity: 1;\n      visibility: visible;\n    }\n    img {\n      transform: scale(1.2);\n      filter: grayscale(100%);\n    }\n  }\n}\n/*Speakers-style-three*/\n.speakers-area {\n  max-width: 1920px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n.speakers-area-two {\n  padding-bottom: 90px;\n}\n.single-speakers-box {\n  margin-bottom: 30px;\n  text-align: center;\n  transition: $transition;\n  box-shadow: 0 15px 20px 0 rgba(0, 0, 0, 0.06);\n\n  .speakers-content {\n    background: $white-color;\n    padding: 30px 0;\n    position: relative;\n    transition: $transition;\n\n    &::before {\n      content: \"\";\n      width: 0;\n      height: 20px;\n      color: $white-color;\n      background: $main-color;\n      position: absolute;\n      top: -20px;\n      right: 0;\n      transition: $transition;\n    }\n    h3 {\n      font-size: 20px;\n      margin-bottom: 10px;\n      color: $black-color;\n    }\n    span {\n      display: block;\n      text-transform: capitalize;\n      transition: $transition;\n      color: $main-color;\n    }\n    .social {\n      padding: 0;\n      margin: 0;\n      list-style-type: none;\n      position: absolute;\n      top: -37px;\n      left: 0;\n      right: 0;\n      margin: 0 auto;\n      transform: scale(0);\n      transition: $transition;\n\n      li {\n        display: inline-block;\n\n        a {\n          display: block;\n          width: 35px;\n          height: 35px;\n          line-height: 35px;\n          font-size: 16px;\n          color: #a0a0a0;\n          margin-right: 10px;\n          position: relative;\n          z-index: 1;\n\n          &:hover {\n            color: $white-color;\n\n            &::before {\n              background: $sub-main-color;\n              color: $white-color;\n              transform: rotate(-45deg);\n            }\n          }\n          &::before {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            top: 0;\n            left: 0;\n            background: $white-color;\n            transform: rotate(45deg);\n            z-index: -1;\n            transition: $transition;\n          }\n        }\n      }\n    }\n  }\n  &:hover {\n    box-shadow: 0 0 28px 0 rgba(6, 74, 255, 0.22);\n\n    &::before,\n    &::after {\n      border-color: $main-color;\n      transform: scale(1);\n    }\n    .speakers-content {\n      background: $main-color;\n\n      &::before {\n        width: 100%;\n      }\n      .social {\n        transform: scale(1);\n      }\n      h3,\n      span {\n        color: $white-color;\n      }\n    }\n  }\n}\n\n/*================================================\nSchedule CSS\n=================================================*/\n.schedule-area {\n  position: relative;\n  z-index: 1;\n\n  &.bg-image {\n    background: {\n      image: url(\"/images/bg.jpg\");\n      position: center center;\n      size: cover;\n      repeat: no-repeat;\n      attachment: fixed;\n    }\n  }\n}\n.event-tabs {\n  box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);\n  background-color: $white-color;\n\n  .react-tabs__tab-list {\n    border: none;\n    margin: 0;\n    display: flex;\n    width: 100%;\n    text-align: center;\n\n    li {\n      display: block;\n      flex: 1;\n      background-color: $yellow-color;\n      transition: $transition;\n      position: relative;\n      border: none;\n\n      &::before {\n        width: 30px;\n        height: 30px;\n        left: 0;\n        bottom: -15px;\n        position: absolute;\n        background: $main-color;\n        content: \"\";\n        transform: rotate(45deg);\n        right: 0;\n        margin: 0 auto;\n        opacity: 0;\n        visibility: hidden;\n        transition: $transition;\n      }\n      font: {\n        size: 24px;\n      }\n\n      color: $white-color;\n      text-transform: uppercase;\n      padding: 25px 10px;\n      font-weight: 600;\n\n      span {\n        display: block;\n        font: {\n          size: 14px;\n        }\n        text-transform: capitalize;\n        margin-top: 5px;\n      }\n\n      &:focus::after {\n        background-color: transparent;\n      }\n      &:nth-child(2) {\n        background-color: $sub-main-color;\n      }\n      &:nth-child(3) {\n        background-color: $green-light-color;\n      }\n      &:nth-child(4) {\n        background-color: $yellow-color;\n      }\n      &.react-tabs__tab--selected {\n        background-color: $main-color;\n\n        &::before {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    }\n  }\n  .react-tabs__tab-panel {\n    padding: 30px;\n    background-color: #f9f9ff;\n\n    .accordion {\n      list-style-type: none;\n      padding: 0;\n      margin: 0;\n      border: none;\n\n      .accordion__item {\n        display: block;\n        margin-bottom: 15px;\n        border: 1px solid rgba(0, 0, 0, 0.125);\n        background-color: $white-color;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n        .accordion__button {\n          background-color: transparent;\n          display: flex;\n          position: relative;\n          align-items: center !important;\n          padding: {\n            left: 25px;\n            right: 140px;\n            bottom: 35px;\n            top: 35px;\n          }\n\n          &::before {\n            display: none;\n          }\n\n          .author {\n            max-width: 100px;\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            img {\n              &:nth-child(1) {\n                clip-path: polygon(\n                  50% 0%,\n                  38.11% 6.7%,\n                  24.99% 6.72%,\n                  18.06% 18.44%,\n                  6.7% 25%,\n                  6.56% 38.64%,\n                  0% 50%,\n                  6.7% 61.89%,\n                  6.7% 75%,\n                  18.44% 81.94%,\n                  25% 93.3%,\n                  38.64% 93.44%,\n                  50% 100%,\n                  61.88% 93.3%,\n                  75% 93.3%,\n                  81.94% 81.56%,\n                  93.3% 74.9%,\n                  93.44% 61.36%,\n                  100% 50%,\n                  93.3% 38.11%,\n                  93.3% 25%,\n                  81.56% 18.06%,\n                  74.96% 6.7%,\n                  61.36% 6.56%,\n                  50% 0%\n                );\n              }\n              &:nth-child(2) {\n                clip-path: polygon(\n                  50% 0%,\n                  100% 38%,\n                  82% 100%,\n                  18% 100%,\n                  0% 38%\n                );\n              }\n              &:nth-child(3) {\n                clip-path: polygon(\n                  50% 0%,\n                  100% 25%,\n                  100% 75%,\n                  50% 100%,\n                  0% 75%,\n                  0% 25%\n                );\n              }\n              &:nth-child(4) {\n                border-radius: 50%;\n              }\n              &:nth-child(5) {\n                clip-path: polygon(\n                  50% 0%,\n                  90% 20%,\n                  100% 60%,\n                  75% 100%,\n                  25% 100%,\n                  0% 60%,\n                  10% 20%\n                );\n              }\n              &:nth-child(6) {\n                clip-path: polygon(\n                  30% 0%,\n                  70% 0%,\n                  100% 30%,\n                  100% 70%,\n                  70% 100%,\n                  30% 100%,\n                  0% 70%,\n                  0% 30%\n                );\n              }\n              &:nth-child(7) {\n                clip-path: polygon(\n                  50% 0%,\n                  83% 12%,\n                  100% 43%,\n                  94% 78%,\n                  68% 100%,\n                  32% 100%,\n                  6% 78%,\n                  0% 43%,\n                  17% 12%\n                );\n              }\n              &:nth-child(8) {\n                clip-path: polygon(\n                  50% 0%,\n                  80% 10%,\n                  100% 35%,\n                  100% 70%,\n                  80% 90%,\n                  50% 100%,\n                  20% 90%,\n                  0% 70%,\n                  0% 35%,\n                  20% 10%\n                );\n              }\n              &:nth-child(9) {\n                clip-path: circle(50% at 50% 50%);\n              }\n              &:nth-child(10) {\n                clip-path: polygon(\n                  50% 0%,\n                  90% 20%,\n                  100% 60%,\n                  75% 100%,\n                  25% 100%,\n                  0% 60%,\n                  10% 20%\n                );\n              }\n            }\n          }\n          .author-multi {\n            overflow: hidden;\n\n            img {\n              width: 47%;\n              border-radius: 50%;\n              margin: {\n                bottom: 0.2rem;\n                right: 1.5%;\n                left: 1.5%;\n                top: 0.2rem;\n              }\n              float: left;\n            }\n          }\n          .schedule-info {\n            h3 {\n              font-size: 20px;\n              margin-bottom: 15px;\n              text-transform: capitalize;\n            }\n            ul {\n              padding: 0;\n              list-style-type: none;\n              margin: 0;\n\n              li {\n                display: inline-block;\n                color: $paragraph-color;\n                margin-right: 20px;\n                font-size: 14px;\n\n                &:last-child {\n                  margin-right: 0;\n                }\n\n                i {\n                  margin-right: 5px;\n                  color: $main-color;\n                }\n\n                span {\n                  color: $sub-main-color;\n                }\n              }\n            }\n          }\n        }\n      }\n      .accordion__panel {\n        padding: {\n          left: 25px;\n          right: 25px;\n          bottom: 35px;\n          top: 0;\n        }\n        p {\n          font-size: 16px;\n          margin-bottom: 20px;\n        }\n        .location {\n          b {\n            color: $main-color;\n          }\n          span {\n            color: $sub-main-color;\n          }\n        }\n      }\n    }\n  }\n}\n\n.btn-box {\n  text-align: center;\n  margin-top: 50px;\n\n  .btn {\n    margin: 0 15px;\n  }\n}\n/*schedule-style-two*/\n.schedule-slides-item {\n  .single-schedule {\n    position: relative;\n    background: $white-color;\n    text-align: center;\n    padding: 0 0 0 200px;\n\n    .schedule-date {\n      font: {\n        size: 24px;\n      }\n      color: $white-color;\n      background: $main-color;\n      text-transform: uppercase;\n      padding: 25px 40px;\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      width: 200px;\n\n      span {\n        display: block;\n        font: {\n          size: 15px;\n        }\n        text-transform: capitalize;\n        margin-top: 5px;\n      }\n    }\n    .schedule-content {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n      align-items: center !important;\n      border-bottom: 1px solid #eeeeee;\n      padding: 20px;\n      text-align: left;\n\n      .author {\n        max-width: 100px;\n        margin-right: 25px;\n\n        img {\n          &:nth-child(1) {\n            clip-path: polygon(\n              50% 0%,\n              38.11% 6.7%,\n              24.99% 6.72%,\n              18.06% 18.44%,\n              6.7% 25%,\n              6.56% 38.64%,\n              0% 50%,\n              6.7% 61.89%,\n              6.7% 75%,\n              18.44% 81.94%,\n              25% 93.3%,\n              38.64% 93.44%,\n              50% 100%,\n              61.88% 93.3%,\n              75% 93.3%,\n              81.94% 81.56%,\n              93.3% 74.9%,\n              93.44% 61.36%,\n              100% 50%,\n              93.3% 38.11%,\n              93.3% 25%,\n              81.56% 18.06%,\n              74.96% 6.7%,\n              61.36% 6.56%,\n              50% 0%\n            );\n          }\n          &:nth-child(2) {\n            clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);\n          }\n          &:nth-child(3) {\n            clip-path: polygon(\n              50% 0%,\n              100% 25%,\n              100% 75%,\n              50% 100%,\n              0% 75%,\n              0% 25%\n            );\n          }\n          &:nth-child(4) {\n            border-radius: 50%;\n          }\n          &:nth-child(5) {\n            clip-path: polygon(\n              50% 0%,\n              90% 20%,\n              100% 60%,\n              75% 100%,\n              25% 100%,\n              0% 60%,\n              10% 20%\n            );\n          }\n          &:nth-child(6) {\n            clip-path: polygon(\n              30% 0%,\n              70% 0%,\n              100% 30%,\n              100% 70%,\n              70% 100%,\n              30% 100%,\n              0% 70%,\n              0% 30%\n            );\n          }\n          &:nth-child(7) {\n            clip-path: polygon(\n              50% 0%,\n              83% 12%,\n              100% 43%,\n              94% 78%,\n              68% 100%,\n              32% 100%,\n              6% 78%,\n              0% 43%,\n              17% 12%\n            );\n          }\n          &:nth-child(8) {\n            clip-path: polygon(\n              50% 0%,\n              80% 10%,\n              100% 35%,\n              100% 70%,\n              80% 90%,\n              50% 100%,\n              20% 90%,\n              0% 70%,\n              0% 35%,\n              20% 10%\n            );\n          }\n          &:nth-child(9) {\n            clip-path: circle(50% at 50% 50%);\n          }\n          &:nth-child(10) {\n            clip-path: polygon(\n              50% 0%,\n              90% 20%,\n              100% 60%,\n              75% 100%,\n              25% 100%,\n              0% 60%,\n              10% 20%\n            );\n          }\n        }\n      }\n      .author-multi {\n        overflow: hidden;\n\n        img {\n          width: 47%;\n          border-radius: 50%;\n          margin-bottom: 0.4rem;\n          margin-right: 3%;\n          float: left;\n        }\n      }\n      .schedule-info {\n        h3 {\n          font-size: 18px;\n          margin-bottom: 12px;\n\n          a {\n            color: $black-color;\n\n            &:hover,\n            &:focus {\n              color: $main-color;\n            }\n          }\n        }\n        ul {\n          padding: 0;\n          list-style-type: none;\n          margin: 0;\n\n          li {\n            display: inline-block;\n            color: $paragraph-color;\n            margin-right: 20px;\n            font-size: 14px;\n\n            &:last-child {\n              margin-right: 0;\n            }\n\n            i {\n              margin-right: 6px;\n              color: $main-color;\n            }\n            &:last-child {\n              margin-right: 0;\n            }\n            a {\n              display: inline-block;\n              color: $sub-main-color;\n\n              &:hover,\n              &:focus {\n                color: $main-color;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &:nth-child(2) {\n      .schedule-date {\n        background: $sub-main-color;\n      }\n    }\n    &:nth-child(3) {\n      .schedule-date {\n        background: $yellow-color;\n      }\n    }\n    &:nth-child(4) {\n      .schedule-date {\n        background: $green-light-color;\n      }\n    }\n    &:nth-child(5) {\n      .schedule-date {\n        background: $sub-main-color;\n      }\n    }\n    &:nth-child(6) {\n      .schedule-date {\n        background: $yellow-color;\n      }\n    }\n    &:nth-child(7) {\n      .schedule-date {\n        background: $green-light-color;\n      }\n    }\n  }\n}\n.schedule-slides {\n  .swiper-button-next,\n  .swiper-button-prev {\n    color: $black-color;\n    transition: $transition;\n\n    &::after {\n      font-size: 25px;\n    }\n    &:hover,\n    &:focus {\n      color: $main-color;\n    }\n  }\n}\n/*schedule-style-three*/\n.schedule-style-three {\n  padding-bottom: 90px;\n\n  .col-lg-6 {\n    &:nth-child(2) {\n      .single-schedule-item {\n        .schedule-date {\n          background-color: $sub-main-color;\n        }\n      }\n    }\n    &:nth-child(3) {\n      .single-schedule-item {\n        .schedule-date {\n          background-color: $yellow-color;\n        }\n      }\n    }\n    &:nth-child(4) {\n      .single-schedule-item {\n        .schedule-date {\n          background-color: $green-light-color;\n        }\n      }\n    }\n    &:nth-child(5) {\n      .single-schedule-item {\n        .schedule-date {\n          background-color: $sub-main-color;\n        }\n      }\n    }\n    &:nth-child(6) {\n      .single-schedule-item {\n        .schedule-date {\n          background-color: $yellow-color;\n        }\n      }\n    }\n    &:nth-child(7) {\n      .single-schedule-item {\n        .schedule-date {\n          background-color: $green-light-color;\n        }\n      }\n    }\n  }\n}\n.single-schedule-item {\n  text-align: center;\n  margin-bottom: 30px;\n  background-color: $white-color;\n  box-shadow: 0 15px 20px 0 rgba(0, 0, 0, 0.06);\n\n  .schedule-date {\n    font: {\n      size: 24px;\n    }\n    color: $white-color;\n    background: $main-color;\n    text-transform: uppercase;\n    padding: 20px;\n\n    span {\n      display: block;\n      font: {\n        size: 14px;\n      }\n      text-transform: capitalize;\n      margin-top: 5px;\n    }\n  }\n  .schedule-item-wrapper {\n    .schedule-content {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n      align-items: center !important;\n      border-bottom: 1px solid #eeeeee;\n      padding: 25px 20px;\n      text-align: left;\n\n      .author {\n        max-width: 90px;\n        margin-right: 20px;\n\n        img {\n          &:nth-child(1) {\n            clip-path: polygon(\n              50% 0%,\n              38.11% 6.7%,\n              24.99% 6.72%,\n              18.06% 18.44%,\n              6.7% 25%,\n              6.56% 38.64%,\n              0% 50%,\n              6.7% 61.89%,\n              6.7% 75%,\n              18.44% 81.94%,\n              25% 93.3%,\n              38.64% 93.44%,\n              50% 100%,\n              61.88% 93.3%,\n              75% 93.3%,\n              81.94% 81.56%,\n              93.3% 74.9%,\n              93.44% 61.36%,\n              100% 50%,\n              93.3% 38.11%,\n              93.3% 25%,\n              81.56% 18.06%,\n              74.96% 6.7%,\n              61.36% 6.56%,\n              50% 0%\n            );\n          }\n          &:nth-child(2) {\n            clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);\n          }\n          &:nth-child(3) {\n            clip-path: polygon(\n              50% 0%,\n              100% 25%,\n              100% 75%,\n              50% 100%,\n              0% 75%,\n              0% 25%\n            );\n          }\n          &:nth-child(4) {\n            border-radius: 50%;\n          }\n          &:nth-child(5) {\n            clip-path: polygon(\n              50% 0%,\n              90% 20%,\n              100% 60%,\n              75% 100%,\n              25% 100%,\n              0% 60%,\n              10% 20%\n            );\n          }\n          &:nth-child(6) {\n            clip-path: polygon(\n              30% 0%,\n              70% 0%,\n              100% 30%,\n              100% 70%,\n              70% 100%,\n              30% 100%,\n              0% 70%,\n              0% 30%\n            );\n          }\n          &:nth-child(7) {\n            clip-path: polygon(\n              50% 0%,\n              83% 12%,\n              100% 43%,\n              94% 78%,\n              68% 100%,\n              32% 100%,\n              6% 78%,\n              0% 43%,\n              17% 12%\n            );\n          }\n          &:nth-child(8) {\n            clip-path: polygon(\n              50% 0%,\n              80% 10%,\n              100% 35%,\n              100% 70%,\n              80% 90%,\n              50% 100%,\n              20% 90%,\n              0% 70%,\n              0% 35%,\n              20% 10%\n            );\n          }\n          &:nth-child(9) {\n            clip-path: circle(50% at 50% 50%);\n          }\n          &:nth-child(10) {\n            clip-path: polygon(\n              50% 0%,\n              90% 20%,\n              100% 60%,\n              75% 100%,\n              25% 100%,\n              0% 60%,\n              10% 20%\n            );\n          }\n        }\n      }\n      .author-multi {\n        overflow: hidden;\n\n        img {\n          width: 47%;\n          border-radius: 50%;\n          margin-bottom: 0.4rem;\n          margin-right: 3%;\n          float: left;\n        }\n      }\n      .schedule-info {\n        h3 {\n          font-size: 18px;\n          margin-bottom: 12px;\n\n          a {\n            color: $black-color;\n\n            &:hover,\n            &:focus {\n              color: $main-color;\n            }\n          }\n        }\n        ul {\n          padding: 0;\n          list-style-type: none;\n          margin: 0;\n\n          li {\n            display: inline-block;\n            color: $paragraph-color;\n            margin-right: 20px;\n            line-height: 1.9;\n\n            font-size: 14px;\n\n            i {\n              margin-right: 5px;\n              color: $main-color;\n            }\n            .icofont-user-suited {\n              margin-right: 8px;\n            }\n            &:last-child {\n              margin-right: 0;\n            }\n            a {\n              display: inline-block;\n              color: $sub-main-color;\n\n              &:hover,\n              &:focus {\n                color: $main-color;\n              }\n            }\n          }\n        }\n      }\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n  }\n}\n/*schedule-style-four*/\n.schedule-style-four {\n  .event-tabs {\n    background-color: transparent;\n    box-shadow: unset;\n  }\n  .react-tabs__tab-list {\n    display: block;\n\n    li {\n      &::before {\n        left: -15px;\n        bottom: 37%;\n        margin: 0 0 0;\n        right: auto;\n      }\n    }\n  }\n  .tab_content {\n    box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);\n  }\n}\n\n/*================================================\nFunFacts CSS\n=================================================*/\n.funfacts-area {\n  position: relative;\n  z-index: 1;\n  background: {\n    image: url(\"/images/funfacts-bg.jpg\");\n    position: center center;\n    size: cover;\n    repeat: no-repeat;\n    attachment: fixed;\n  }\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    background: $black-color;\n    opacity: 0.88;\n  }\n}\n.single-funfact {\n  text-align: center;\n\n  .icon {\n    color: $white-color;\n    font-size: 40px;\n  }\n  h3 {\n    color: $white-color;\n    font-size: 55px;\n    margin: {\n      top: 10px;\n      bottom: 8px;\n    }\n  }\n  p {\n    color: $white-color;\n    letter-spacing: 1px;\n    font-size: 16px;\n    margin-bottom: 0;\n    line-height: 1;\n  }\n}\n/*funfact-style-two*/\n.funFact {\n  position: relative;\n  padding-left: 60px;\n\n  .icon {\n    color: $white-color;\n    font-size: 40px;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n  h3 {\n    color: $white-color;\n    font-size: 55px;\n    margin: {\n      top: 0;\n      bottom: 8px;\n    }\n  }\n  p {\n    color: $white-color;\n    letter-spacing: 1px;\n    font-size: 16px;\n    margin-bottom: 0;\n    line-height: 1;\n  }\n}\n.col-lg-3 {\n  &:nth-child(1) {\n    .single-funfact,\n    .funFact {\n      h3 {\n        color: $main-color;\n      }\n    }\n  }\n  &:nth-child(2) {\n    .single-funfact,\n    .funFact {\n      h3 {\n        color: $sub-main-color;\n      }\n    }\n  }\n  &:nth-child(3) {\n    .single-funfact,\n    .funFact {\n      h3 {\n        color: $yellow-color;\n      }\n    }\n  }\n  &:nth-child(4) {\n    .single-funfact,\n    .funFact {\n      h3 {\n        color: $green-light-color;\n      }\n    }\n  }\n}\n\n/*================================================\nPricing CSS\n=================================================*/\n.pricing-area {\n  position: relative;\n  z-index: 1;\n\n  &.bg-image {\n    background: {\n      image: url(\"/images/bg.jpg\");\n      position: center center;\n      size: cover;\n      repeat: no-repeat;\n      attachment: fixed;\n    }\n  }\n}\n.pricing-table-box {\n  padding-bottom: 30px;\n  background: $white-color;\n  text-align: center;\n  z-index: 1;\n  position: relative;\n  border-radius: 5px;\n  background: {\n    image: url(\"/images/patt.png\");\n    position: center center;\n  }\n  overflow: hidden;\n  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);\n  transition: $transition;\n\n  .pricingTable-header {\n    padding: 30px 15px 10px;\n    background: $main-color;\n    clip-path: polygon(50% 100%, 100% 60%, 100% 0, 0 0, 0 60%);\n    position: relative;\n\n    &::before {\n      content: \"\";\n      width: 400px;\n      height: 400px;\n      border-radius: 50%;\n      position: absolute;\n      right: -50%;\n      top: -130%;\n      background: repeating-radial-gradient(\n        rgba(255, 255, 255, 0.04),\n        rgba(255, 255, 255, 0.17) 20%\n      );\n      transition: $transition;\n    }\n  }\n  .title {\n    font: {\n      size: 24px;\n      weight: 700;\n    }\n    color: $white-color;\n    text-transform: uppercase;\n    margin-bottom: 15px;\n  }\n  .price-value {\n    display: block;\n    font: {\n      size: 55px;\n      weight: 700;\n    }\n    color: $white-color;\n    margin-bottom: 30px;\n\n    sup {\n      font-size: 23px;\n      top: -25px;\n    }\n  }\n  .pricing-content {\n    padding: 35px 0;\n    margin-bottom: 0;\n    list-style-type: none;\n\n    li {\n      color: $paragraph-color;\n      text-transform: capitalize;\n      border-bottom: 1px solid #eeeeee;\n      margin-bottom: 12px;\n      padding-bottom: 12px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n      &:first-child {\n        border-top: 1px solid #eeeeee;\n        padding-top: 12px;\n      }\n    }\n  }\n  &:hover,\n  &:focus,\n  &.active {\n    transform: translateY(-10px);\n\n    .pricingTable-header {\n      &::before {\n        right: 50%;\n      }\n    }\n  }\n}\n/*pricing-style-two*/\n.pricing-plan {\n  position: relative;\n  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);\n  text-align: center;\n  padding-bottom: 30px;\n  transition: $transition;\n  background-color: $white-color;\n\n  h3 {\n    font: {\n      size: 24px;\n    }\n    padding: 30px 15px;\n    margin-bottom: 100px;\n    background-color: $main-color;\n    color: $white-color;\n    transition: $transition;\n\n    span {\n      display: block;\n      color: $main-color;\n      background: $white-color;\n      height: 150px;\n      width: 150px;\n      line-height: 155px;\n      font-size: 35px;\n      box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);\n      margin: 30px auto -95px;\n      border-radius: 50%;\n      transition: $transition;\n      sup {\n        font-weight: 500;\n      }\n    }\n  }\n  .pricing-content {\n    padding: 0 0 35px;\n    margin-bottom: 0;\n    list-style-type: none;\n\n    li {\n      color: $paragraph-color;\n      text-transform: capitalize;\n      border-bottom: 1px solid #eeeeee;\n      margin-bottom: 12px;\n      padding-bottom: 12px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n      &:first-child {\n        border-top: 1px solid #eeeeee;\n        padding-top: 12px;\n      }\n    }\n  }\n  &:hover,\n  &:focus {\n    transform: translateY(-8px);\n  }\n}\n.col-lg-4 {\n  &:nth-child(2) {\n    .pricing-table-box {\n      .pricingTable-header {\n        background: $sub-main-color;\n      }\n      .btn-primary {\n        &::before,\n        &::after {\n          background: $sub-main-color;\n        }\n      }\n    }\n    .pricing-plan {\n      h3 {\n        background: $sub-main-color;\n\n        span {\n          color: $sub-main-color;\n        }\n      }\n      .btn-primary {\n        &::before,\n        &::after {\n          background: $sub-main-color;\n        }\n      }\n    }\n  }\n  &:nth-child(3) {\n    .pricing-table-box {\n      .pricingTable-header {\n        background: $green-light-color;\n      }\n      .btn-primary {\n        &::before,\n        &::after {\n          background: $green-light-color;\n        }\n      }\n    }\n    .pricing-plan {\n      h3 {\n        background: $green-light-color;\n\n        span {\n          color: $green-light-color;\n        }\n      }\n      .btn-primary {\n        &::before,\n        &::after {\n          background: $green-light-color;\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nPartner CSS\n=================================================*/\n.partner-area {\n  overflow: hidden;\n\n  .partner-title {\n    text-align: center;\n    margin-bottom: 50px;\n\n    h3 {\n      font: {\n        size: 24px;\n        weight: 900;\n      }\n      margin-bottom: 0;\n      color: $main-color;\n      text-transform: uppercase;\n      transform: translateX(0) !important;\n    }\n    &.gold-sponsor {\n      h3 {\n        color: $green-light-color;\n      }\n    }\n  }\n  .partner-item {\n    text-align: center;\n\n    a {\n      position: relative;\n\n      img {\n        width: unset !important;\n        display: inline-block !important;\n\n        &:last-child {\n          position: absolute;\n          left: 0;\n          top: 30px;\n          right: 0;\n          margin: 0 auto;\n          opacity: 0;\n          visibility: hidden;\n          transition: $transition;\n        }\n      }\n    }\n    &:hover {\n      a {\n        img {\n          &:last-child {\n            opacity: 1;\n            visibility: visible;\n            top: 0;\n          }\n        }\n      }\n    }\n  }\n  .border {\n    border: 0.3px solid #eeeeee !important;\n    margin: {\n      top: 40px;\n      bottom: 40px;\n    }\n  }\n}\n\n/*================================================\nBlog CSS\n=================================================*/\n.blog-area {\n  position: relative;\n  z-index: 1;\n\n  &.bg-image {\n    background: {\n      image: url(\"/images/bg.jpg\");\n      position: center center;\n      size: cover;\n      repeat: no-repeat;\n      attachment: fixed;\n    }\n  }\n}\n.single-blog-post {\n  margin-bottom: 30px;\n  background-color: $white-color;\n  box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.06);\n\n  .blog-image {\n    position: relative;\n    overflow: hidden;\n\n    a {\n      display: block;\n\n      img {\n        transition: $transition;\n      }\n    }\n    .post-tag {\n      position: absolute;\n      right: 0;\n      top: 60px;\n      transition: $transition;\n\n      a {\n        background: $main-color;\n        color: $white-color;\n        padding: 9px 28px;\n      }\n    }\n  }\n  .blog-post-content {\n    padding: 25px;\n\n    .date {\n      color: $green-light-color;\n      display: block;\n      text-transform: uppercase;\n      font: {\n        size: 14px;\n      }\n      transition: $transition;\n    }\n    h3 {\n      margin: {\n        top: 13px;\n        bottom: 15px;\n      }\n      line-height: 30px;\n      font: {\n        size: 22px;\n      }\n\n      a {\n        color: $black-color;\n\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n      }\n    }\n    p {\n      margin-bottom: 15px;\n    }\n  }\n  .read-more-btn {\n    position: relative;\n    font-weight: 500;\n    color: $main-color;\n\n    &:hover {\n      color: $sub-main-color;\n      letter-spacing: 1px;\n    }\n  }\n  &:hover,\n  &:focus {\n    .blog-image {\n      a {\n        img {\n          transform: scale(1.2);\n        }\n      }\n      .post-tag {\n        top: 70px;\n\n        a {\n          background: $green-light-color;\n          color: $white-color;\n        }\n      }\n    }\n  }\n}\n.blog-slides {\n  .swiper-pagination {\n    position: sticky;\n\n    .swiper-pagination-bullet {\n      width: 10px;\n      height: 10px;\n\n      &.swiper-pagination-bullet-active,\n      &:hover {\n        background-color: $main-color;\n      }\n    }\n  }\n}\n/*blog-style-two*/\n.blog-section {\n  padding-bottom: 90px;\n}\n.single-blog-card {\n  position: relative;\n  margin-bottom: 30px;\n\n  > a {\n    display: block;\n    img {\n      width: 100%;\n    }\n  }\n\n  &::before {\n    opacity: 0.6;\n    background: $black-color;\n    content: \"\";\n    height: 100%;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    right: 0;\n    position: absolute;\n    width: 100%;\n  }\n  .post-tag {\n    position: absolute;\n    right: 0;\n    top: 30px;\n    transition: $transition;\n    z-index: 2;\n\n    a {\n      background: $main-color;\n      color: $white-color;\n      padding: 9px 28px;\n    }\n  }\n  .blog-post-content {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    padding: 20px 30px 0;\n    transition: $transition;\n    z-index: 2;\n\n    h3 {\n      font-size: 22px;\n      margin-bottom: 15px;\n      line-height: 1.5;\n\n      a {\n        color: $white-color;\n\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n      }\n    }\n    p {\n      color: $white-color;\n    }\n    .read-more-btn {\n      position: relative;\n      font-weight: 500;\n      opacity: 0;\n      visibility: hidden;\n      color: $main-color;\n\n      &:hover {\n        color: $sub-main-color;\n        letter-spacing: 1px;\n      }\n    }\n  }\n  &:hover,\n  &:focus {\n    .post-tag {\n      top: 40px;\n\n      a {\n        background: $green-light-color;\n        color: $white-color;\n      }\n    }\n    .blog-post-content {\n      padding-bottom: 30px;\n\n      .read-more-btn {\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n  }\n}\n\n/*================================================\nBuy Tickets CSS\n=================================================*/\n.buy-tickets-area {\n  position: relative;\n  z-index: 1;\n  background: {\n    position: center center;\n    size: cover;\n    repeat: no-repeat;\n    attachment: fixed;\n  }\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    background: $black-color;\n    opacity: 0.88;\n  }\n  &.ptb-120 {\n    padding-bottom: 200px;\n  }\n}\n.buy-tickets {\n  .section-title {\n    margin-bottom: 0;\n\n    h2 {\n      color: $white-color;\n    }\n    p {\n      color: $white-color;\n      margin: 0;\n    }\n  }\n  .buy-ticket-btn {\n    text-align: right;\n  }\n}\n\n/*================================================\nSubscribe CSS\n=================================================*/\n.subscribe-area {\n  text-align: center;\n  position: relative;\n  margin-top: -80px;\n  z-index: 2;\n\n  &::before {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 72%;\n    background: $black-color;\n    content: \"\";\n    z-index: -1;\n  }\n  .subscribe-inner {\n    padding: 50px;\n    transform: unset !important;\n    background: {\n      image: url(\"/images/color-bg.jpg\");\n      repeat: no-repeat;\n    }\n\n    span {\n      color: $white-color;\n      font: {\n        family: \"Oswald\", sans-serif;\n        size: 16px;\n      }\n      letter-spacing: 1px;\n      text-transform: uppercase;\n      display: block;\n    }\n    h2 {\n      font-size: 40px;\n      margin: {\n        top: 10px;\n        bottom: 0;\n      }\n      color: $white-color;\n    }\n    .newsletter-form {\n      max-width: 650px;\n      position: relative;\n      margin: 35px auto 0;\n\n      .form-control {\n        border: none;\n        height: 60px;\n        box-shadow: 0 8px 6px -6px rgba(50, 51, 51, 0.4);\n      }\n      .btn {\n        position: absolute;\n        right: 0;\n        top: 0;\n        text-transform: uppercase;\n        height: 60px;\n\n        &:after,\n        &::before {\n          background: $sub-main-color;\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nPage Title CSS\n=================================================*/\n.page-title-area {\n  position: relative;\n  z-index: 1;\n  background: {\n    position: center center;\n    size: cover;\n    repeat: no-repeat;\n  }\n  text-align: center;\n  padding: {\n    top: 250px;\n    bottom: 180px;\n  }\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    background: $black-color;\n    opacity: 0.88;\n  }\n  h1 {\n    color: $white-color;\n    margin-bottom: 0;\n    text-transform: uppercase;\n    font-size: 40px;\n  }\n  span {\n    display: block;\n    color: $white-color;\n    margin-top: 10px;\n    font: {\n      size: 17px;\n    }\n  }\n  ul {\n    padding: 0;\n    margin: 12px 0 0;\n    list-style-type: none;\n\n    li {\n      display: inline-block;\n      position: relative;\n      color: $main-color;\n      font-size: 16px;\n      margin: 0 13px;\n\n      a {\n        color: $white-color;\n\n        &:hover,\n        &:focus {\n          color: $sub-main-color;\n        }\n      }\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: -15px;\n        top: 50%;\n        width: 2px;\n        height: 15px;\n        background: $yellow-color;\n        margin-top: -9px;\n        transform: rotate(10deg);\n      }\n      &:first-child {\n        margin-left: 0;\n\n        &::before {\n          display: none;\n        }\n      }\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n}\n\n/*================================================\nLogin CSS\n=================================================*/\n.login-area {\n  height: 100vh;\n  position: relative;\n  z-index: 100000;\n  background: {\n    position: center center;\n    size: cover;\n    repeat: no-repeat;\n  }\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    background: $main-color;\n    opacity: 0.77;\n  }\n  .login-form {\n    max-width: 540px;\n    background: $white-color;\n    margin: 0 auto;\n\n    h3 {\n      background: $sub-main-color;\n      padding: 30px 0 25px;\n      font-size: 24px;\n      margin-bottom: 0;\n      color: $white-color;\n      text-align: center;\n      text-transform: uppercase;\n    }\n    form {\n      padding: 35px;\n\n      label {\n        font: {\n          weight: 500;\n        }\n      }\n      .form-control {\n        background: transparent;\n        font-size: 13px;\n      }\n    }\n    .btn {\n      display: block;\n      width: 100%;\n      margin-top: 20px;\n    }\n    p {\n      overflow: hidden;\n      margin: {\n        bottom: 0;\n        top: 20px;\n      }\n      a {\n        color: $black-color;\n        font: {\n          weight: 600;\n        }\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n        &.pull-left {\n          float: left;\n        }\n        &.pull-right {\n          float: right;\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nSignup CSS\n=================================================*/\n.signup-area {\n  height: 100vh;\n  position: relative;\n  z-index: 10000;\n  background: {\n    position: center center;\n    size: cover;\n    repeat: no-repeat;\n  }\n  &::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    background: $main-color;\n    opacity: 0.77;\n  }\n  .signup-form {\n    max-width: 540px;\n    background: $white-color;\n    margin: 0 auto;\n\n    h3 {\n      background: $sub-main-color;\n      padding: 30px 0 25px;\n      font-size: 24px;\n      margin-bottom: 0;\n      color: $white-color;\n      text-align: center;\n      text-transform: uppercase;\n    }\n    form {\n      padding: 35px;\n\n      label {\n        font: {\n          weight: 500;\n        }\n      }\n      .form-control {\n        background: transparent;\n        font-size: 13px;\n      }\n    }\n    .btn {\n      display: block;\n      width: 100%;\n      margin-top: 20px;\n    }\n    p {\n      text-align: center;\n      color: $black-color;\n      margin: {\n        bottom: 0;\n        top: 20px;\n      }\n      a {\n        color: $black-color;\n        display: inline-block;\n        font: {\n          weight: 600;\n        }\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n      }\n    }\n  }\n}\n\n/*================================================\n404 Error CSS\n=================================================*/\n.error-area {\n  background-color: #f1f1f1;\n  padding: 30px 15px;\n  height: 100vh;\n  text-align: center;\n  z-index: 10000;\n  position: relative;\n\n  h1 {\n    font: {\n      size: 150px;\n      weight: bold;\n    }\n    line-height: 110px;\n    margin: 0;\n    color: $main-color;\n\n    span {\n      color: $yellow-color;\n    }\n    b {\n      font-weight: unset;\n      color: $green-light-color;\n    }\n  }\n  h3 {\n    margin: 35px 0 15px;\n  }\n  p {\n    margin: 10px 0 20px;\n  }\n}\n\n/*================================================\nFAQ CSS\n=================================================*/\n.faq-accordion {\n  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);\n  padding: 60px;\n  background: $white-color;\n  border-radius: 10px;\n\n  .accordion {\n    border: none;\n    border-radius: 0;\n  }\n  .accordion__item {\n    margin-bottom: 15px;\n\n    .accordion__button {\n      background-color: $white-color;\n      box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);\n      color: $black-color;\n      outline: 0;\n      font-weight: 600;\n      font-size: 18px;\n    }\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  .accordion__item + .accordion__item {\n    border: none;\n  }\n}\n.faq-contact {\n  margin-top: 45px;\n  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);\n  padding: 60px;\n  text-align: center;\n  border-radius: 4px;\n\n  h3 {\n    font: {\n      size: 25px;\n    }\n    margin-bottom: 35px;\n  }\n\n  .form-group {\n    margin-bottom: 25px;\n  }\n  .form-control {\n    background-color: #f5f5f5;\n  }\n}\n\n/*================================================\nComing Soon CSS\n=================================================*/\n.coming-soon {\n  position: relative;\n  z-index: 1000;\n  height: 100vh;\n  text-align: center;\n  background: {\n    image: url(\"/images/main-bg3.jpg\");\n    position: center center;\n    size: cover;\n    attachment: fixed;\n    repeat: no-repeat;\n  }\n  &::before {\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background: $black-color;\n    opacity: 0.66;\n    position: absolute;\n    content: \"\";\n  }\n  .coming-soon-content {\n    max-width: 650px;\n    margin: 0 auto;\n\n    h1 {\n      color: $white-color;\n      font: {\n        size: 45px;\n      }\n      text-transform: uppercase;\n      margin-bottom: 0;\n      line-height: 57px;\n    }\n    p {\n      color: #c7c3c7;\n      margin: {\n        top: 20px;\n        bottom: 35px;\n      }\n    }\n    form {\n      position: relative;\n\n      .form-control {\n        background: transparent;\n        border: 1px solid $white-color;\n        border-radius: 50px;\n        color: $white-color;\n        height: 55px;\n        padding-left: 20px;\n\n        &:focus,\n        &:hover {\n          border-color: $main-color;\n        }\n        &::placeholder {\n          color: #c7c3c7;\n        }\n      }\n      button {\n        position: absolute;\n        right: -1px;\n        height: 100%;\n        background: $main-color;\n        top: 0;\n        color: $white-color;\n        border: none;\n        width: 130px;\n        cursor: pointer;\n        text-transform: uppercase;\n        font-weight: 500;\n        border-radius: 0 50px 50px 0;\n        transition: $transition;\n        outline: 0 !important;\n        border: none;\n\n        &:hover,\n        &:focus {\n          background: $sub-main-color;\n        }\n      }\n    }\n    #timer {\n      margin-bottom: 35px;\n\n      div {\n        display: inline-block;\n        font: {\n          size: 45px;\n          weight: 700;\n        }\n        color: $white-color;\n        width: 135px;\n        height: 135px;\n        border: 1px solid #eeeeee;\n        border-radius: 50%;\n        padding-top: 34px;\n        line-height: 40px;\n        margin: 0 10px;\n      }\n      span {\n        display: block;\n        font: {\n          size: 16px;\n          weight: 400;\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nPagination CSS\n=================================================*/\n.pagination-area {\n  margin-top: 30px;\n\n  ul {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n\n    li {\n      a {\n        width: 40px;\n        height: 40px;\n        padding: 0;\n        margin: 0 5px;\n        background-color: $white-color;\n        border-radius: 0 !important;\n        text-align: center;\n        line-height: 40px;\n        color: $black-color;\n        font: {\n          size: 17px;\n          weight: 500;\n        }\n        box-shadow: 0 2px 10px 0 #d8dde6;\n        border: none;\n\n        &.active,\n        &:hover,\n        &:focus {\n          background: $main-color;\n          color: $white-color;\n          box-shadow: unset;\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nBlog Details CSS\n=================================================*/\n.blog-details {\n  .post-image {\n    margin-bottom: 35px;\n  }\n  h3 {\n    font-size: 25px;\n    margin: {\n      top: 5px;\n      bottom: 15px;\n    }\n  }\n  .blog-meta {\n    ul {\n      padding: 0;\n      margin: 15px 0;\n      list-style-type: none;\n\n      li {\n        display: inline-block;\n        position: relative;\n        color: $paragraph-color;\n        font: {\n          size: 14px;\n        }\n        margin: {\n          left: 9px;\n          right: 9px;\n        }\n        i {\n          margin-right: 4px;\n          color: $main-color;\n        }\n        &::before {\n          width: 2px;\n          height: 14px;\n          background: $paragraph-color;\n          left: -10px;\n          top: 50%;\n          position: absolute;\n          content: \"\";\n          margin-top: -6px;\n          transform: rotate(11deg);\n        }\n        a {\n          display: inline-block;\n          color: $paragraph-color;\n\n          &:hover,\n          &:focus {\n            color: $sub-main-color;\n          }\n        }\n        &:last-child {\n          margin-right: 0;\n        }\n        &:first-child {\n          margin-left: 0;\n\n          &::before {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n  p {\n    margin: {\n      top: 15px;\n      bottom: 0;\n    }\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  blockquote,\n  .blockquote {\n    background: #f6f6f6 none repeat scroll 0 0;\n    padding: 35px 20px 35px 100px;\n    position: relative;\n    margin: {\n      top: 25px;\n      bottom: 25px;\n    }\n    &::before {\n      font-family: IcoFont !important;\n      position: absolute;\n      content: \"\\efcd\";\n      left: 25px;\n      top: 50%;\n      transform: translateY(-50%);\n      font-size: 55px;\n      color: $main-color;\n    }\n    p {\n      color: $black-color;\n      font-style: italic;\n      font: {\n        size: 18px;\n        weight: 600;\n      }\n      margin: 0;\n    }\n  }\n}\n.post-tag-media {\n  background-color: #f5f7fb;\n  padding: 20px;\n  margin: {\n    top: 25px;\n    bottom: 35px;\n  }\n  ul {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n\n    li {\n      display: inline-block;\n\n      span {\n        font: {\n          weight: 600;\n        }\n        margin-right: 5px;\n        display: inline-block;\n      }\n      a {\n        color: $paragraph-color;\n        margin-right: 4px;\n\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n      }\n    }\n    &.social-share {\n      text-align: right;\n      li {\n        padding-left: 5px;\n      }\n    }\n  }\n}\n.comments-area {\n  .comments-title,\n  .comment-reply-title {\n    font-size: 22px;\n    margin-bottom: 25px;\n  }\n  .comment-reply-title {\n    margin-bottom: 8px;\n  }\n  ol,\n  ul {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n\n    li {\n      ol,\n      ul {\n        li {\n          margin: {\n            top: 15px;\n            left: 35px;\n            bottom: 15px;\n          }\n        }\n      }\n      .comment-body {\n        background: #f7f7ff;\n        padding: 25px 20px;\n        position: relative;\n\n        .comment-meta {\n          position: relative;\n          padding: {\n            left: 85px;\n            top: 8px;\n          }\n          .comment-author {\n            img {\n              position: absolute;\n              left: 0;\n              top: 0;\n              border-radius: 50%;\n              max-width: 68px;\n            }\n            .fn {\n              font: {\n                size: 16px;\n                weight: 600;\n              }\n              margin-bottom: 5px;\n              display: block;\n            }\n            .says {\n              display: none;\n            }\n          }\n          .comment-metadata {\n            a {\n              display: inline-block;\n              color: $paragraph-color;\n              font-size: 14px;\n\n              &:hover,\n              &:focus {\n                color: $main-color;\n              }\n            }\n          }\n        }\n        .comment-content {\n          margin: {\n            top: 25px;\n          }\n        }\n        .reply {\n          position: absolute;\n          right: 30px;\n          top: 30px;\n\n          a {\n            display: inline-block;\n            background: $black-color;\n            padding: 5px 15px;\n            color: $white-color;\n\n            &:hover,\n            &:focus {\n              background: $main-color;\n            }\n          }\n        }\n      }\n    }\n  }\n  .comment-respond {\n    margin-top: 30px;\n\n    .comment-notes {\n      font-size: 14px;\n      margin-bottom: 20px;\n    }\n    .comment-form {\n      p {\n        margin-bottom: 25px;\n      }\n    }\n    .comment-form-comment,\n    .comment-form-author,\n    .comment-form-email,\n    .comment-form-url {\n      input,\n      textarea {\n        display: block;\n        width: 100%;\n        height: 50px;\n        background-color: #f5f5f5;\n        outline: 0 !important;\n        box-shadow: unset !important;\n        border: 1px solid #eeeeee;\n        padding: 10px 20px;\n        border-radius: 6px;\n        transition: $transition;\n\n        &:focus {\n          border-color: $main-color;\n        }\n      }\n      textarea {\n        height: auto;\n      }\n    }\n    .form-submit {\n      margin: 0 !important;\n      input {\n        display: inline-block;\n        background: $main-color;\n        border: none;\n        color: $white-color;\n        padding: 13px 25px;\n        text-transform: uppercase;\n        font-weight: 600;\n        outline: 0 !important;\n        margin-top: 5px;\n        transition: $transition;\n\n        &:hover,\n        &:focus {\n          background: $black-color;\n          box-shadow: 0 13px 27px 0 rgba(255, 82, 2, 0.11);\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nSidebar CSS\n=================================================*/\n.sidebar {\n  .widget {\n    margin-bottom: 40px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n    .widget-title {\n      font-size: 22px;\n      margin-bottom: 25px;\n      position: relative;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        right: 0;\n        top: 2px;\n        width: 17px;\n        height: 17px;\n        background: $main-color;\n        clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);\n        transition: $transition;\n      }\n    }\n    &:hover,\n    &:focus {\n      .widget-title {\n        &::before {\n          transform: rotate(180deg);\n        }\n      }\n    }\n    &.widget_search {\n      background: $white-color;\n      box-shadow: 0px 0px 29px 0px rgba(102, 102, 102, 0.1);\n      padding: 15px;\n\n      form {\n        position: relative;\n\n        .form-control {\n          background: transparent;\n        }\n        button {\n          position: absolute;\n          right: 5px;\n          top: 0;\n          height: 100%;\n          border: none;\n          outline: 0;\n          box-shadow: unset;\n          background: transparent;\n          color: $main-color;\n          transition: $transition;\n\n          &:hover,\n          &:focus {\n            color: $sub-main-color;\n          }\n        }\n      }\n    }\n    &.widget_categories {\n      ul {\n        padding: 0;\n        margin: 0;\n        list-style-type: none;\n\n        li {\n          position: relative;\n          border-top: 1px solid #eeeeee;\n          padding: {\n            top: 10px;\n            bottom: 10px;\n            left: 18px;\n          }\n          &::before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 50%;\n            width: 10px;\n            height: 10px;\n            background: $main-color;\n            margin-top: -5px;\n            transition: $transition;\n          }\n          &:last-child {\n            border-bottom: 1px solid #eeeeee;\n          }\n          a {\n            color: $paragraph-color;\n\n            &:hover {\n              color: $main-color;\n            }\n          }\n          &:hover {\n            &::before {\n              border-radius: 50%;\n            }\n          }\n        }\n      }\n    }\n    &.widget_recent_entries {\n      ul {\n        padding: 0;\n        margin: 0;\n        list-style-type: none;\n\n        li {\n          position: relative;\n          padding-left: 100px;\n          margin-bottom: 15px;\n          padding-right: 20px;\n\n          a {\n            display: block;\n\n            img {\n              position: absolute;\n              left: 0;\n              top: 3px;\n              width: 85px;\n              height: 65px;\n            }\n          }\n          h5 {\n            font-size: 15px;\n            line-height: 22px;\n            margin-bottom: 2px;\n            font-weight: 600;\n\n            a {\n              color: $black-color;\n              display: inline-block;\n\n              &:hover,\n              &:focus {\n                color: $main-color;\n              }\n            }\n          }\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n    &.widget_tag_cloud {\n      .tagcloud {\n        a {\n          font-size: 14px !important;\n          border: 1px dashed #eeeeee;\n          padding: 6px 20px;\n          margin-top: 5px;\n          color: #707070;\n          display: inline-block;\n          background: #f5f5f5;\n          margin-right: 7px;\n          border-radius: 30px;\n          margin-bottom: 5px;\n\n          &:hover {\n            background: $main-color;\n            color: $white-color;\n            border-color: $main-color;\n          }\n        }\n      }\n    }\n    &.widget_archive {\n      ul {\n        padding: 0;\n        margin: 0;\n        list-style-type: none;\n\n        li {\n          position: relative;\n          border-top: 1px solid #eeeeee;\n          padding: {\n            top: 10px;\n            bottom: 10px;\n            left: 18px;\n          }\n          &::before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 50%;\n            width: 10px;\n            height: 10px;\n            background: $main-color;\n            margin-top: -5px;\n            transition: $transition;\n          }\n          &:last-child {\n            border-bottom: 1px solid #eeeeee;\n          }\n          a {\n            color: $paragraph-color;\n            display: inline-block;\n\n            &:hover {\n              color: $main-color;\n            }\n          }\n          &:hover {\n            &::before {\n              border-radius: 50%;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n/*================================================\nContact Us CSS\n=================================================*/\n.contact-box {\n  background: $white-color;\n  padding: 30px 20px 30px 90px;\n  border-radius: 5px;\n  position: relative;\n  transition: $transition;\n  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);\n\n  .icon {\n    position: absolute;\n    left: 20px;\n    top: 30px;\n    width: 50px;\n    height: 50px;\n    text-align: center;\n    line-height: 47px;\n    border: 1px dashed $main-color;\n    border-radius: 50%;\n    color: $main-color;\n    font-size: 20px;\n    transition: $transition;\n  }\n  h4 {\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n  .content {\n    p {\n      margin-bottom: 0;\n\n      a {\n        color: $paragraph-color;\n\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n      }\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n  &:hover,\n  &:focus {\n    box-shadow: 0 0 30px 0 rgba(67, 67, 67, 0.15);\n    transform: translateY(-5px);\n\n    .icon {\n      background: $main-color;\n      color: $white-color;\n    }\n  }\n}\n#map {\n  height: 400px;\n  width: 100%;\n}\n.contact-form {\n  margin-top: 50px;\n}\n.leave-your-message {\n  h3 {\n    margin-bottom: 12px;\n    font-size: 22px;\n  }\n  .stay-connected {\n    margin-top: 25px;\n\n    h3 {\n      margin-bottom: 20px;\n    }\n    ul {\n      padding: 0;\n      margin: 0;\n      list-style-type: none;\n\n      li {\n        margin-bottom: 10px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n        a {\n          font-weight: 500;\n          display: inline-block;\n          color: $paragraph-color;\n\n          i {\n            width: 40px;\n            height: 40px;\n            text-align: center;\n            display: inline-block;\n            line-height: 40px;\n            border: 1px solid;\n            border-radius: 50%;\n            margin-right: 10px;\n            font-size: 15px;\n          }\n          &:hover,\n          &:focus {\n            color: $main-color;\n          }\n        }\n      }\n    }\n  }\n}\n#contactForm {\n  background: $white-color;\n  padding: 30px;\n  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);\n\n  label {\n    font-weight: 500;\n  }\n  .form-control {\n    background-color: #f1f1f1;\n  }\n  ul {\n    padding: 0;\n    margin: 0;\n    li {\n      color: red;\n      margin-top: 10px;\n      font-size: 14px;\n    }\n  }\n  .text-danger,\n  .text-success {\n    margin: {\n      bottom: 0;\n      top: 20px;\n    }\n  }\n  .h4 {\n    font-size: 15px;\n  }\n}\n\n/*================================================\nFooter CSS\n=================================================*/\n.footer-area {\n  background-color: $black-color;\n  padding: {\n    top: 120px;\n  }\n}\n.single-footer-widget {\n  h3 {\n    color: $white-color;\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  span {\n    color: rgba(255, 255, 255, 0.6);\n    display: block;\n    margin-bottom: 10px;\n\n    i {\n      margin-right: 5px;\n    }\n  }\n  p {\n    margin-bottom: 0;\n    color: rgba(255, 255, 255, 0.6);\n  }\n  .location {\n    position: relative;\n    padding-left: 25px;\n    i {\n      margin-right: 5px;\n      position: absolute;\n      left: 0;\n      top: 6px;\n    }\n  }\n  .contact-authority {\n    margin-top: 8px;\n    color: rgba(255, 255, 255, 0.6);\n\n    &:hover,\n    &:focus {\n      color: $main-color;\n    }\n    i {\n      margin-right: 5px;\n    }\n  }\n  .social-links {\n    padding: 0;\n    margin: 20px 0 0;\n    list-style-type: none;\n\n    li {\n      display: inline-block;\n      margin-right: 10px;\n\n      a {\n        color: $white-color;\n        border: 1px solid #525164;\n        width: 35px;\n        height: 35px;\n        line-height: 35px;\n        text-align: center;\n        border-radius: 50%;\n        font-size: 14px;\n\n        &.facebook {\n          border: none;\n          background-color: #4267b2;\n        }\n        &.twitter {\n          border: none;\n          background-color: #38a1f3;\n        }\n        &.instagram {\n          border: none;\n          background: radial-gradient(\n              circle farthest-corner at 35% 90%,\n              #fec564,\n              transparent 50%\n            ),\n            radial-gradient(\n              circle farthest-corner at 0 140%,\n              #fec564,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 0 -25%,\n              #5258cf,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 20% -50%,\n              #5258cf,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 100% 0,\n              #893dc2,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 60% -20%,\n              #893dc2,\n              transparent 50%\n            ),\n            radial-gradient(\n              ellipse farthest-corner at 100% 100%,\n              #d9317a,\n              transparent\n            ),\n            linear-gradient(\n              #6559ca,\n              #bc318f 30%,\n              #e33f5f 50%,\n              #f77638 70%,\n              #fec66d 100%\n            );\n        }\n        &.linkedin {\n          border: none;\n          background-color: #0077b5;\n        }\n        &:hover,\n        &:focus {\n          background-color: $main-color;\n          color: $white-color;\n          border-color: $main-color;\n        }\n      }\n    }\n  }\n}\n.copyright-area {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding: {\n    top: 40px;\n    bottom: 30px;\n  }\n  margin-top: 100px;\n  text-align: center;\n\n  .logo {\n    a {\n      display: inline-block;\n    }\n  }\n  ul {\n    padding: 0;\n    margin: 30px 0 20px;\n    list-style-type: none;\n\n    li {\n      position: relative;\n      margin: 5px 15px;\n      display: inline-block;\n\n      &::before {\n        position: absolute;\n        width: 6px;\n        height: 6px;\n        content: \"\";\n        background: #a8a8ad;\n        left: -18px;\n        top: 50%;\n        margin-top: -2px;\n        border-radius: 50%;\n      }\n      a {\n        color: #a8a8ad;\n\n        &:hover,\n        &:focus {\n          color: $main-color;\n        }\n      }\n      &:first-child {\n        margin-left: 0;\n\n        &::before {\n          display: none;\n        }\n      }\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n  p {\n    color: #a8a8ad;\n  }\n}\n\n/*================================================\nBack To Top CSS\n=================================================*/\n.back-to-top {\n  position: fixed;\n  right: 1.5%;\n  bottom: 15px;\n  height: 15px;\n  cursor: pointer;\n  width: 40px;\n  padding: 3px 5px;\n  font: {\n    size: 10px;\n    weight: bold;\n  }\n  color: transparent;\n  text-align: center;\n  z-index: 3;\n  // visibility: hidden;\n  outline: 0 !important;\n  transition: $transition;\n  background-color: $sub-main-color;\n\n  &::before,\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    width: 0;\n    height: 0;\n    border: 20px solid transparent;\n    border-top: 0;\n  }\n  &::before {\n    top: -20px;\n    z-index: 4;\n    border-bottom: 20px solid $sub-main-color;\n  }\n  &::after {\n    bottom: 0;\n    z-index: 5;\n    border-bottom: 20px solid $main-color;\n  }\n  &:hover,\n  &:focus {\n    opacity: 1;\n    text-decoration: none;\n    height: 40px;\n    color: $white-color;\n  }\n  &.show-back-to-top {\n    display: block;\n    bottom: 1.25%;\n    visibility: visible;\n  }\n}\n\n:invalid {\n  box-shadow: none;\n}\n\n:-moz-submit-invalid {\n  box-shadow: none;\n}\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n.modal-video {\n  position: absolute !important;\n}\n\n.main-textarea {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-bottom: 15px;\n  }\n  ul,\n  ol {\n    li {\n      color: $paragraph-color;\n      margin-bottom: 10px;\n      line-height: 1.8;\n    }\n  }\n}\n","/*\n@File: Evnia Template Styles\n\n* This file contains the styling for the actual tepmlate, this\nis the file you need to edit to change the look of the\ntepmlate.\n\nThis files table contents are outlined below>>>>>\n\n*******************************************\n*******************************************\n\n** - Default CSS\n** - Preloader CSS\n** - Navbar CSS\n** - Main Banner CSS\n** - About CSS\n** - Why Choose Us CSS\n** - CTA CSS\n** - Speakers CSS\n** - Schedule CSS\n** - FunFacts CSS\n** - Pricing CSS\n** - Partner CSS\n** - Blog CSS\n** - Buy Tickets CSS\n** - Subscribe CSS\n** - Page Title CSS\n** - Login CSS\n** - Signup CSS\n** - 404 Error CSS\n** - FAQ CSS\n** - Coming Soon CSS\n** - Pagination CSS\n** - Blog Details CSS\n** - Sidebar CSS\n** - Contact Us CSS\n** - Footer CSS\n** - Back To Top CSS\n*/\n/*================================================\nDefault CSS\n=================================================*/\nbody {\n  padding: 0;\n  margin: 0;\n  font-size: 15px;\n  background: linear-gradient(90deg, #18284d, #101a33);\n}\n\n.row {\n  @media (max-width: 767px) {\n    margin: 0 !important;\n  }\n}\n\n/* a {\n  display: inline-block;\n  transition: 0.5s;\n  text-decoration: none;\n}\na:hover,\na:focus {\n  text-decoration: none;\n} */\n\n.d-table {\n  width: 100%;\n  height: 100%;\n}\n.d-table-cell {\n  vertical-align: middle;\n}\n\n.ptb-120 {\n  padding-top: 120px;\n  padding-bottom: 60px;\n  @media (min-width: 2560px) {\n    padding-top: 10vh;\n    padding-bottom: 10vh;\n  }\n\n  @media only screen and (min-width: 768px) and (max-width: 993px) {\n    padding-top: 80px;\n    padding-bottom: 80px;\n  }\n\n  @media (max-width: 767px) {\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n}\n\n/* img {\n  max-width: 100%;\n  height: auto;\n}\n\np {\n  line-height: 1.9;\n  color: #ffffff;\n  margin-bottom: 15px;\n  font-size: 15px;\n}\np:last-child {\n  margin-bottom: 0;\n} */\n\n/* .h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 700;\n  color: #ffffff;\n} */\n\n.text-right {\n  text-align: end;\n}\n\n.text-left {\n  text-align: start;\n}\n\n.form-group {\n  margin-bottom: 30px;\n}\n\ntextarea.form-control {\n  min-height: auto !important;\n  height: auto;\n}\n\nlabel {\n  margin-bottom: 10px;\n}\n\n/*btn btn-primary*/\n.btn {\n  font-weight: 600 !important;\n  font-size: 20px !important;\n  color: #ffffff;\n  box-shadow: 0 8px 6px -6px rgba(50, 51, 51, 0.4) !important;\n  border: none !important;\n  padding: 10px 16px !important;\n  border-radius: 0 !important;\n  transition: 0.5s !important;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw !important;\n  }\n}\n\n.btn-primary {\n  color: #ffffff;\n  background: #0d1028 !important;\n  position: relative;\n  z-index: 1;\n}\n.btn-primary::before,\n.btn-primary::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 51%;\n  background: #fe4614;\n  height: 100%;\n  z-index: -1;\n  transition: 0.5s;\n}\n.btn-primary::before {\n  left: 0;\n}\n.btn-primary::after {\n  right: 0;\n}\n.btn-primary:hover::before,\n.btn-primary:hover::after,\n.btn-primary:focus::before,\n.btn-primary:focus::after {\n  width: 0;\n}\n.btn-primary.focus,\n.btn-primary:focus {\n  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n  color: #ffffff;\n}\n.btn-primary:hover,\n.btn-primary:focus {\n  background: #ffffff !important;\n  color: #253d77 !important;\n  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25) !important;\n}\n.btn-primary:not(:disabled):not(.disabled).active:focus,\n.btn-primary:not(:disabled):not(.disabled):active:focus {\n  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n}\n.btn-primary:not(:disabled):not(.disabled).active,\n.btn-primary:not(:disabled):not(.disabled):active {\n  background: #0d1028;\n  color: #ffffff;\n}\n.btn-primary.disabled,\n.btn-primary:disabled {\n  opacity: 1;\n  background: #0d1028;\n}\n\n.btn-secondary {\n  color: #ffffff;\n  background: #0d1028;\n  position: relative;\n  z-index: 1;\n}\n.btn-secondary::before,\n.btn-secondary::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 51%;\n  background: #00acee;\n  height: 100%;\n  z-index: -1;\n  transition: 0.5s;\n}\n.btn-secondary::before {\n  left: 0;\n}\n.btn-secondary::after {\n  right: 0;\n}\n.btn-secondary:hover::before,\n.btn-secondary:hover::after,\n.btn-secondary:focus::before,\n.btn-secondary:focus::after {\n  width: 0;\n}\n.btn-secondary.focus,\n.btn-secondary:focus {\n  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n  color: #ffffff;\n}\n.btn-secondary:hover,\n.btn-secondary:focus {\n  background: #0d1028;\n  color: #ffffff;\n  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n}\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\n.btn-secondary:not(:disabled):not(.disabled):active:focus {\n  box-shadow: 0 13px 27px 0 rgba(245, 78, 162, 0.25);\n}\n.btn-secondary:not(:disabled):not(.disabled).active,\n.btn-secondary:not(:disabled):not(.disabled):active {\n  background: #0d1028;\n  color: #ffffff;\n}\n.btn-secondary.disabled,\n.btn-secondary:disabled {\n  opacity: 1;\n  background: #0d1028;\n}\n\n.navbar-brand {\n  width: 10vw;\n  @media (max-width: 767px) {\n    width: 60vw;\n  }\n  @media (max-width: 575px) {\n    padding-left: 4vw;\n  }\n}\n\n/*section-title*/\n.EventsPage {\n  background: linear-gradient(90deg, #18284d, #101a33);\n}\n.speakers-section {\n  background-image: url(\"../assets/events_images/speaker-top.webp\");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 40vh;\n  position: relative;\n  display: flex;\n  align-items: center;\n  @media (max-width: 993px) {\n    height: 30vh;\n  }\n  @media (max-width: 768px) {\n    height: 45vh;\n  }\n}\n\n.speakers-row {\n  @media (max-width: 993px) {\n    padding: 12px;\n  }\n}\n\n.speakers-section .bg-title {\n  color: transparent;\n  -webkit-text-stroke: 0.5px #fff;\n  font-weight: 700;\n  font-size: 90px;\n  font-family: Arial, Helvetica, sans-serif !important;\n  line-height: 150%;\n  position: absolute;\n  bottom: 2%;\n  left: 5%;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  z-index: 0;\n  margin-top: -25px;\n  @media (min-width: 1600px) {\n    font-size: 5.625vw;\n  }\n  @media (max-width: 991px) {\n    font-size: 50px !important;\n  }\n  @media (max-width: 767px) {\n    font-size: 30px !important;\n  }\n}\n.section-title {\n  z-index: 100;\n  padding-top: 120px;\n  @media (min-width: 2000px) {\n    padding-top: 25vh;\n  }\n  @media (max-width: 993px) {\n    padding-top: 80px;\n  }\n  @media (max-width: 768px) {\n    padding-top: 60px;\n  }\n}\n.speakers-section-title {\n  z-index: 100;\n}\n.section-title h1 {\n  color: #e74860;\n  font-size: 40px;\n  text-align: center;\n  @media (min-width: 1600px) {\n    font-size: 2.5vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 36px;\n  }\n}\n\n.speakers-section-title h1 {\n  color: #e74860;\n  font-size: 40px;\n  text-align: center;\n  @media (min-width: 1600px) {\n    font-size: 2.5vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 36px;\n  }\n}\n.section-title span {\n  color: #ffffff;\n  letter-spacing: 1px;\n  font-size: 16px;\n  text-transform: uppercase;\n  display: block;\n  text-align: right;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw;\n  }\n}\n\n.speakers-section-title span {\n  color: #ffffff !important;\n  letter-spacing: 1px;\n  font-size: 16px !important;\n  text-transform: uppercase !important;\n  display: block;\n  text-align: right !important;\n  @media (min-width: 1600px) {\n    font-size: 1.1vw !important;\n  }\n}\n.section-title h2 {\n  color: #e74860;\n  font-size: 40px;\n  text-align: right;\n  @media (min-width: 1600px) {\n    font-size: 2.5vw;\n  }\n}\n.speakers-section-title h2 {\n  color: #e74860;\n  font-size: 40px;\n  text-align: right;\n  @media (min-width: 1600px) {\n    font-size: 2.5vw;\n  }\n}\n.section-title h2 b {\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 80%, #ff2d55 80%);\n  font-weight: unset;\n  background-size: 100px 1.07em !important;\n}\n.section-title .btn {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  margin-top: -18px;\n}\n\n/*owl-carousel-btn*/\n.owl-theme .owl-nav.disabled + .owl-dots {\n  margin-top: 0;\n  line-height: 0.01;\n}\n.owl-theme .owl-dots .owl-dot span {\n  width: 15px;\n  height: 15px;\n  margin: 0 4px;\n  background: transparent;\n  border: 1px solid #dfdfdf;\n  display: block;\n  transition: 0.5s;\n  border-radius: 50%;\n  position: relative;\n}\n.owl-theme .owl-dots .owl-dot:hover,\n.owl-theme .owl-dots .owl-dot:focus {\n  outline: 0;\n  box-shadow: unset !important;\n}\n.owl-theme .owl-dots .owl-dot:hover span,\n.owl-theme .owl-dots .owl-dot:focus span {\n  background: #00acee;\n  border-color: #00acee;\n}\n.owl-theme .owl-dots .owl-dot.active span {\n  background: #ff2d55;\n  border-color: #ff2d55;\n}\n\n/*form-control*/\n.form-control {\n  height: 50px;\n  padding: 15px;\n  font-size: 14px;\n  font-weight: 500;\n  border: 1px solid #eeeeee;\n  border-radius: 0;\n  transition: 0.5s;\n}\n.form-control:hover,\n.form-control:focus,\n.form-control.active {\n  box-shadow: unset;\n  border-color: #ff2d55;\n}\n\n/*================================================\nPreloader CSS\n=================================================*/\n.preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999999;\n  overflow: hidden;\n  background: #0d1028;\n}\n.preloader .loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 50%;\n  width: 110px;\n  height: 110px;\n  margin: -80px 0 0 -75px;\n  border-radius: 50%;\n  border: 7px solid transparent;\n  border-top-color: #ff2d55;\n  animation: spin 1.7s linear infinite;\n  z-index: 11;\n}\n.preloader .loader:before {\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  right: 5px;\n  bottom: 5px;\n  border-radius: 50%;\n  border: 7px solid transparent;\n  border-top-color: #efa506;\n  animation: spin-reverse 0.6s linear infinite;\n}\n.preloader .loader:after {\n  content: \"\";\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  right: 15px;\n  bottom: 15px;\n  border-radius: 50%;\n  border: 7px solid transparent;\n  border-top-color: #00acee;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes spin-reverse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n/*================================================\nNavbar CSS\n=================================================*/\n.elkevent-nav {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding-top: 20px;\n  width: 100%;\n  z-index: 999;\n  height: auto;\n}\n.elkevent-nav nav ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.elkevent-nav nav .navbar-nav .nav-item {\n  position: relative;\n  padding: 15px 0;\n}\n.elkevent-nav nav .navbar-nav .nav-item a {\n  font-weight: 500;\n  font-size: 16px;\n  text-transform: uppercase;\n  color: #ffffff !important;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-left: 15px;\n  margin-right: 15px;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw;\n  }\n}\n.elkevent-nav nav .navbar-nav .nav-item a:hover,\n.elkevent-nav nav .navbar-nav .nav-item a:focus,\n.elkevent-nav nav .navbar-nav .nav-item a.active {\n  color: #ff2d55;\n}\n.elkevent-nav nav .navbar-nav .nav-item:hover a {\n  color: #ff2d55;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu {\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.05);\n  background: #0d1028;\n  position: absolute;\n  top: 80px;\n  right: 0;\n  width: 250px;\n  z-index: 99;\n  display: block;\n  padding-top: 20px;\n  padding-left: 5px;\n  padding-right: 5px;\n  padding-bottom: 20px;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease-in-out;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li {\n  position: relative;\n  padding: 0;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a {\n  font-size: 15px;\n  font-weight: 500;\n  text-transform: capitalize;\n  padding: 9px 15px;\n  margin: 0;\n  display: block;\n  color: #ffffff;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a:hover,\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a:focus,\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li a.active {\n  color: #ff2d55;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li .dropdown-menu {\n  position: absolute;\n  right: 220px;\n  top: 0;\n  opacity: 0 !important;\n  visibility: hidden !important;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li .dropdown-menu li a {\n  color: #ffffff;\n  text-transform: capitalize;\n}\n.elkevent-nav\n  nav\n  .navbar-nav\n  .nav-item\n  .dropdown-menu\n  li\n  .dropdown-menu\n  li\n  a:hover,\n.elkevent-nav\n  nav\n  .navbar-nav\n  .nav-item\n  .dropdown-menu\n  li\n  .dropdown-menu\n  li\n  a:focus,\n.elkevent-nav\n  nav\n  .navbar-nav\n  .nav-item\n  .dropdown-menu\n  li\n  .dropdown-menu\n  li\n  a.active {\n  color: #ff2d55;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li:hover .dropdown-menu {\n  opacity: 1 !important;\n  visibility: visible !important;\n  top: -20px !important;\n}\n.elkevent-nav nav .navbar-nav .nav-item .dropdown-menu li:hover a {\n  color: #ff2d55;\n}\n.elkevent-nav nav .navbar-nav .nav-item:hover ul {\n  opacity: 1;\n  visibility: visible;\n  top: 100%;\n}\n.elkevent-nav nav .others-option {\n  margin-left: 13px;\n}\n.elkevent-nav.is-sticky {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 5px 0;\n  z-index: 999;\n  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);\n  background-color: #0d1028 !important;\n  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;\n}\n\n.navbar-toggler {\n  border: none;\n  /* background: #eee !important; */\n  padding: 10px;\n  border-radius: 0;\n  border: none !important;\n}\n.navbar-toggler:focus {\n  box-shadow: none !important;\n}\n.navbar-toggler .icon-bar {\n  width: 28px;\n  transition: all 0.3s;\n  background: #ff2d55;\n  height: 2px;\n  display: block;\n}\n.navbar-toggler .top-bar {\n  transform: rotate(45deg);\n  transform-origin: 10% 10%;\n  left: 4px;\n  position: relative;\n}\n.navbar-toggler .middle-bar {\n  opacity: 0;\n  margin: 6px 0;\n}\n.navbar-toggler .bottom-bar {\n  transform: rotate(-45deg);\n  transform-origin: 10% 90%;\n  left: 4px;\n  position: relative;\n}\n.navbar-toggler.collapsed .top-bar {\n  transform: rotate(0);\n  left: 0;\n}\n.navbar-toggler.collapsed .middle-bar {\n  opacity: 1;\n}\n.navbar-toggler.collapsed .bottom-bar {\n  transform: rotate(0);\n  left: 0;\n}\n\n/*================================================\nMain Banner CSS\n=================================================*/\n.main-banner-sec-col {\n  margin-left: 1vw;\n  @media (max-width: 551px) {\n    margin-left: 0vw;\n  }\n}\n.main-banner {\n  height: 100vh;\n  position: relative;\n  z-index: 1;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  @media only screen and (min-width: 600px) and (max-width: 993px) {\n    height: 60vh !important;\n  }\n}\n\n.main-banner-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: -2;\n}\n\n.main-banner-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.21);\n  z-index: -1;\n}\n\n@media (max-width: 575px) {\n  .main-banner {\n    background: url(\"../assets/events_images//Banner-Image.webp\") no-repeat\n      center center/cover;\n  }\n\n  .main-banner-video {\n    display: none;\n  }\n}\n\n.main-banner::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  background: #0d1028;\n  opacity: 0.77;\n}\n\n.slideshow-banner::before {\n  z-index: 1;\n}\n.slideshow-banner .main-banner-content {\n  margin-top: 50px;\n}\n.slideshow-banner .main-banner-content::before {\n  display: none;\n}\n.slideshow-banner .slideshow {\n  z-index: -1;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.slideshow-banner .slideshow li span {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: transparent;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  opacity: 0;\n  z-index: 0;\n  backface-visibility: hidden;\n  animation: imageAnimation 24s linear infinite 0s;\n}\n.slideshow-banner .slideshow li:nth-child(2) span {\n  animation-delay: 6s;\n}\n.slideshow-banner .slideshow li:nth-child(3) span {\n  animation-delay: 12s;\n}\n.slideshow-banner .slideshow li:nth-child(4) span {\n  animation-delay: 18s;\n}\n.slideshow-banner .event-countdown {\n  position: relative;\n  right: 0;\n  bottom: 0;\n  text-align: left;\n}\n.slideshow-banner .event-countdown #days {\n  margin-left: 0;\n}\n\n.video-banner {\n  overflow: hidden;\n}\n.video-banner .video-background {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: auto;\n  height: auto;\n  min-height: 100%;\n  min-width: 100%;\n  z-index: -2;\n}\n\n/* .item-bg1 {\n  background-image: url(\"/images/main-bg1.jpg\");\n}\n\n.item-bg2 {\n  background-image: url(\"/images/main-bg2.jpg\");\n}\n\n.item-bg3 {\n  background-image: url(\"/images/slider-bg1.jpg\");\n}\n\n.item-bg4 {\n  background-image: url(\"/images/slider-bg2.jpg\");\n}\n\n.item-bg5 {\n  background-image: url(\"/images/slider-bg3.jpg\");\n} */\n\n.main-banner-content {\n  /* max-width: 850px; */\n  position: relative;\n  z-index: 1;\n}\n/* .main-banner-content::before {\n  content: \"\";\n  position: absolute;\n  top: -75px;\n  width: 100%;\n  max-width: 380px;\n  text-align: center;\n  height: 500px;\n  left: 18%;\n  margin-left: -190px;\n  z-index: -1;\n  border: 18px solid rgba(104, 89, 222, 0.24);\n  box-sizing: border-box;\n  box-shadow: 0 60px 40px -40px rgba(0, 0, 0, 0.3);\n} */\n.main-banner-content h1 {\n  color: #ffffff;\n  margin-bottom: 8px;\n  font-weight: 900;\n  font-size: 65px;\n  @media (min-width: 1600px) {\n    font-size: 4vw;\n  }\n}\n.main-banner-content h2 {\n  background: linear-gradient(180deg, #f15a2b, #e74860);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  margin-bottom: 40px;\n  font-weight: 600;\n  font-size: 32px !important;\n  line-height: 150%;\n  @media (min-width: 1600px) {\n    font-size: 2vw !important;\n  }\n  @media (max-width: 991px) {\n    font-size: 25px !important;\n    margin-bottom: 20px;\n  }\n  @media (max-width: 768px) {\n    font-size: 24px !important;\n  }\n}\n.main-banner-content h3 {\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw;\n  }\n  @media (max-width: 768px) {\n    font-size: 16px !important;\n    gap: 10px;\n  }\n  @media (max-width: 375px) {\n    gap: 3px;\n  }\n}\n\n.main-banner-icons {\n  padding: 0 !important;\n  width: 1.5vw !important;\n  height: 1.5vw !important;\n  @media (max-width: 991px) {\n    width: 24px !important;\n    height: 24px !important;\n  }\n  @media (max-width: 768px) {\n    width: 14px !important;\n    height: 14px !important;\n  }\n}\n\n.main-banner-content h3 span {\n  margin-left: 24px;\n  @media (max-width: 768px) {\n    margin-left: 0px;\n    width: 90vw;\n  }\n}\n\n.main-banner-content h1 span {\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 80%, #ff2d55 80%);\n  background-size: 100px 1.2em !important;\n}\n.main-banner-content h1 b:nth-of-type(1) {\n  color: #efa506;\n}\n.main-banner-content h1 b:nth-of-type(2) {\n  color: #ff2d55;\n}\n.main-banner-content h1 b:nth-of-type(3) {\n  color: #ffffff;\n  animation: colorchange 20s;\n}\n.main-banner-content h1 b:nth-of-type(4) {\n  color: #00acee;\n}\n.main-banner-content ul {\n  padding: 0;\n  margin: 25px 0 40px;\n  list-style-type: none;\n}\n.main-banner-content ul li {\n  color: #fff;\n  margin-right: 20px;\n  font-size: 17px;\n  display: inline-block;\n}\n.main-banner-content ul li i {\n  margin-right: 3px;\n  color: #ff2d55;\n}\n.main-banner-content ul li:last-child {\n  margin-right: 0;\n}\n.main-banner-content p {\n  color: #efa506;\n  font-size: 22px;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n}\n.main-banner-content p span {\n  color: #00acee;\n}\n.main-banner-content .button-box a {\n  display: inline-block;\n}\n.main-banner-content .button-box .video-btn {\n  margin-left: 30px;\n  color: #fff;\n  font-weight: 500;\n  cursor: pointer;\n}\n.main-banner-content .button-box .video-btn i {\n  width: 50px;\n  display: inline-block;\n  height: 50px;\n  line-height: 51px;\n  text-align: center;\n  background-color: #00acee;\n  border-radius: 50%;\n  font-size: 17px;\n  margin-right: 8px;\n  z-index: 1;\n  position: relative;\n  transition: 0.5s;\n}\n.main-banner-content .button-box .video-btn i::after {\n  z-index: -1;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 50px;\n  height: 50px;\n  animation: ripple 1.6s ease-out infinite;\n  animation-delay: 3s;\n  opacity: 0;\n  border-radius: 50%;\n  background: rgba(51, 102, 204, 0.5);\n}\n.main-banner-content .button-box .video-btn:hover,\n.main-banner-content .button-box .video-btn:focus {\n  color: #00acee;\n}\n.main-banner-content .button-box .video-btn:hover i,\n.main-banner-content .button-box .video-btn:focus i {\n  background-color: #ff2d55;\n  color: #ffffff;\n}\n.main-banner-content.banner-content-center {\n  text-align: center;\n}\n\n.countdown-area {\n  padding: 50px 0;\n  background: #8dc63f;\n}\n.countdown-area .event-countdown {\n  position: relative;\n  right: 0;\n  bottom: 0;\n  text-align: center;\n}\n.countdown-area .event-countdown #timer div {\n  margin: 0 55px;\n}\n.countdown-area .event-countdown #timer div#seconds {\n  color: #ff2d55;\n}\n\n.event-countdown {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 20px;\n  text-align: center;\n  width: 100%;\n}\n.event-countdown #timer div {\n  display: inline-block;\n  font-size: 55px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 35px;\n  position: relative;\n}\n.event-countdown #timer div#days {\n  color: #ff2d55;\n}\n.event-countdown #timer div#hours {\n  color: #00acee;\n}\n.event-countdown #timer div#hours span {\n  right: -50px;\n  margin-top: -12px;\n}\n.event-countdown #timer div#minutes {\n  color: #ffffff;\n}\n.event-countdown #timer div#minutes span {\n  right: -55px;\n  margin-top: -12px;\n}\n.event-countdown #timer div#seconds {\n  color: #efa506;\n}\n.event-countdown #timer div#seconds span {\n  right: -60px;\n  margin-top: -12px;\n}\n.event-countdown #timer span {\n  display: block;\n  color: #ffffff;\n  margin-top: 0;\n  font-size: 14px;\n  font-weight: 500;\n  position: absolute;\n  right: -40px;\n  top: 50%;\n  text-transform: uppercase;\n  transform: rotate(-90deg);\n  margin-top: -10px;\n  letter-spacing: 2px;\n}\n\n.countdown1 {\n  bottom: 15px !important;\n}\n.countdown1 #timer div {\n  font-size: 60px;\n}\n.countdown1 #timer span {\n  display: inline-block;\n  font-size: 14px;\n  position: initial;\n  transform: rotate(0deg);\n}\n\n@keyframes ripple {\n  0%,\n  35% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.5);\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(2);\n  }\n}\n.shape1 {\n  position: absolute;\n  left: 70px;\n  bottom: 70px;\n  z-index: -1;\n  animation: movebounce 5s linear infinite;\n  opacity: 0.6;\n}\n\n.shape2 {\n  position: absolute;\n  right: 70px;\n  bottom: 70px;\n  z-index: -1;\n  opacity: 0.6;\n}\n\n.shape3 {\n  position: absolute;\n  left: 70px;\n  top: 70px;\n  z-index: -1;\n  opacity: 0.6;\n}\n\n.shape4 {\n  position: absolute;\n  right: 100px;\n  top: 100px;\n  z-index: -1;\n  opacity: 0.6;\n  animation: movebounce 5s linear infinite;\n}\n\n.rotateme {\n  animation-name: rotateme;\n  animation-duration: 40s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n@keyframes rotateme {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes movebounce {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(20px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes colorchange {\n  0% {\n    color: #ff2d55;\n  }\n  25% {\n    color: #ffffff;\n  }\n  50% {\n    color: red;\n  }\n  75% {\n    color: #00acee;\n  }\n  0% {\n    color: #efa506;\n  }\n}\n.home-slides .swiper-button-next,\n.home-slides .swiper-button-prev {\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  background-color: #00acee;\n  color: #ffffff;\n  transition: 0.5s;\n  opacity: 0.7;\n}\n.home-slides .swiper-button-next::after,\n.home-slides .swiper-button-prev::after {\n  font-size: 25px;\n}\n.home-slides .swiper-button-next:hover,\n.home-slides .swiper-button-prev:hover {\n  background-color: #ff2d55;\n  color: #ffffff;\n}\n\n/*================================================\nAbout CSS\n=================================================*/\n.about-area {\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.about-area.bg-image {\n  background-image: url(\"../assets/events_images/bg.webp\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.about-content span {\n  color: #ffffff;\n  letter-spacing: 1px;\n  font-size: 16px;\n  text-transform: uppercase;\n  display: block;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw !important;\n  }\n}\n.about-content h2 {\n  font-size: 32px !important;\n  margin-top: 10px;\n  margin-bottom: 25px;\n  color: #e74860;\n  @media (min-width: 1600px) {\n    font-size: 2vw !important;\n  }\n  @media (max-width: 768px) {\n    font-size: 28px !important;\n  }\n}\n.about-content h2 b {\n  /* background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 80%, #ff2d55 80%); */\n  font-weight: unset;\n  background-size: 100px 1.05em !important;\n}\n.about-content .signature {\n  margin-top: 35px;\n  margin-bottom: 35px;\n}\n.about-content .btn-primary {\n  margin-right: 20px;\n}\n\n.about-image {\n  position: relative;\n  object-fit: cover;\n}\n.about-image .about-img {\n  width: 100%;\n  height: 100%;\n}\n.about-image .about-img2 {\n  position: absolute;\n  left: 20px;\n  bottom: -80px;\n}\n.about-image .shape-img {\n  position: absolute;\n  top: -28px;\n  left: 48%;\n  animation: movebounce 5s linear infinite;\n}\n.about-image .btn {\n  position: absolute;\n  bottom: -20px;\n  right: 0;\n}\n\n/*about-style-two*/\n.about-area-two {\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n.about-area-two.bg-image {\n  /* background-image: url(\"/images/bg.jpg\"); */\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.about-area-two .about-image .about-img1 {\n  position: relative;\n  right: 0;\n  top: 0;\n}\n.about-area-two .about-image .btn {\n  bottom: 0;\n}\n.about-area-two .about-content .signature {\n  margin-bottom: 0;\n}\n\n/*about-style-three*/\n.about-area-three {\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n.about-area-three.bg-image {\n  /* background-image: url(\"/images/bg.jpg\"); */\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.about-area-three .about-image .about-img1 {\n  position: relative;\n  right: 0;\n  top: 0;\n}\n.about-area-three .about-image .btn {\n  bottom: 0;\n  left: 70px;\n  right: auto;\n}\n.about-area-three .about-content .signature {\n  margin-bottom: 0;\n}\n.about-area-three .about-content h6 {\n  font-weight: 600;\n  line-height: 24px;\n  margin-bottom: 20px;\n}\n.about-area-three .about-content p {\n  margin-bottom: 0;\n}\n.about-area-three .about-content ul {\n  padding: 0;\n  margin: 20px 0 0;\n  list-style-type: none;\n}\n.about-area-three .about-content ul li {\n  list-style-type: disc;\n  margin-bottom: 10px;\n  color: #ffffff;\n  margin-left: 20px;\n  position: relative;\n}\n.about-area-three .about-content ul li i {\n  color: #ff2d55;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  margin-top: -7px;\n}\n.about-area-three .about-content ul li:last-child {\n  margin-bottom: 0;\n}\n\n.about-tab {\n  color: #ffffff !important;\n  font-size: 16px !important;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw !important;\n  }\n  /* @media only screen and (min-width: 600px) and (max-width: 993px) {\n    min-height: 32vh !important;\n  } */\n}\n\n.anticon .anticon-ellipsis {\n  display: none;\n}\n\n.about-tab .ant-tabs-nav-wrap {\n  justify-content: left;\n}\n\n.ant-tabs-top > .ant-tabs-nav::before {\n  border-bottom: none !important;\n}\n\n.about-tab .ant-tabs-tab {\n  color: #ffffff !important;\n  font-size: 16px;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw !important;\n  }\n}\n\n.ant-tabs .ant-tabs-tab:hover {\n  color: #ffffff !important;\n}\n\n.ant-tabs .ant-tabs-tab-btn:focus:not(:focus-visible) {\n  color: #ffffff !important;\n}\n\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #f0592a !important;\n}\n\n.about-tab .ant-tabs-ink-bar::after {\n  background: #f0592a !important;\n  height: 2px !important;\n  border-radius: 1px;\n}\n\n/*================================================\nWhy Choose Us CSS\n=================================================*/\n.why-choose-us {\n  position: relative;\n  z-index: 1;\n}\n.why-choose-us::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background: #0d1028;\n  opacity: 0.7;\n}\n.why-choose-us .slideshow {\n  z-index: -1;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.why-choose-us .slideshow li span {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: transparent;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  opacity: 0;\n  z-index: 0;\n  backface-visibility: hidden;\n  animation: imageAnimation 24s linear infinite 0s;\n}\n.why-choose-us .slideshow li:nth-child(2) span {\n  animation-delay: 6s;\n}\n.why-choose-us .slideshow li:nth-child(3) span {\n  animation-delay: 12s;\n}\n.why-choose-us .slideshow li:nth-child(4) span {\n  animation-delay: 18s;\n}\n\n.col-lg-3:first-child .single-box {\n  border-left: none;\n}\n\n.single-box {\n  position: relative;\n  z-index: 1;\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  text-align: center;\n  height: 450px;\n}\n.single-box .d-table-cell {\n  vertical-align: bottom;\n}\n.single-box .content {\n  position: absolute;\n  padding-left: 25px;\n  padding-right: 25px;\n  bottom: 0;\n  left: 0;\n  transition: 0.5s;\n}\n.single-box .content::before {\n  content: \"\";\n  position: absolute;\n  bottom: 5px;\n  width: 100%;\n  max-width: 280px;\n  text-align: center;\n  height: 260px;\n  left: 50%;\n  margin-left: -155px;\n  z-index: -1;\n  border: 10px solid rgba(104, 89, 222, 0.03);\n}\n.single-box .content .icon {\n  font-size: 45px;\n  color: #ff2d55;\n}\n.single-box .content h3 {\n  font-size: 26px;\n  color: #ffffff;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.single-box .content p {\n  color: #ffffff;\n  margin-bottom: 0;\n  transition: 0.5s;\n}\n.single-box .content .btn {\n  opacity: 0;\n  visibility: hidden;\n}\n.single-box:hover .content,\n.single-box:focus .content {\n  bottom: 35px;\n}\n.single-box:hover .content p,\n.single-box:focus .content p {\n  margin-bottom: 25px;\n}\n.single-box:hover .content .btn,\n.single-box:focus .content .btn {\n  opacity: 1;\n  visibility: visible;\n}\n\n@keyframes imageAnimation {\n  0% {\n    opacity: 0;\n    animation-timing-function: ease-in;\n  }\n  12.5% {\n    opacity: 1;\n    animation-timing-function: ease-out;\n  }\n  25% {\n    opacity: 1;\n  }\n  37.5% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.no-cssanimations .slideshow li span {\n  opacity: 1;\n}\n\n/*why-choose-style-two*/\n.why-choose-us-two {\n  max-width: 1920px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.why-choose-content {\n  text-align: center;\n  padding: 20px 25px;\n  position: relative;\n  z-index: 1;\n}\n.why-choose-content h3 {\n  font-size: 24px;\n  margin-bottom: 15px;\n}\n.why-choose-content p {\n  margin-bottom: 0;\n}\n.why-choose-content a {\n  color: #ff2d55;\n  margin-top: 15px;\n}\n.why-choose-content a:hover,\n.why-choose-content a:focus {\n  letter-spacing: 1px;\n}\n.why-choose-content span {\n  font-size: 100px;\n  font-weight: 700;\n  color: #f2f2f2;\n  line-height: 90px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: -10px auto 0;\n  z-index: -1;\n  top: 0;\n}\n\n/*================================================\nCTA CSS\n=================================================*/\n.cta-area {\n  background-color: #ff2d55;\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n.cta-area span {\n  display: block;\n  color: #ffffff;\n  font-size: 20px;\n}\n.cta-area h3 {\n  color: #ffffff;\n  font-size: 35px;\n  margin-bottom: 10px;\n}\n\n/*================================================\nSpeakers CSS\n=================================================*/\n.single-speakers {\n  overflow: hidden;\n  position: relative;\n}\n.single-speakers::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: linear-gradient(\n    transparent 0%,\n    transparent 40%,\n    rgba(0, 0, 0, 0.3) 58%,\n    rgba(0, 0, 0, 0.8) 89%,\n    rgba(0, 0, 0, 0.63) 100%\n  );\n  width: 100%;\n  height: 100%;\n}\n.single-speakers .speakers-content {\n  position: absolute;\n  bottom: 35px;\n  left: 35px;\n  transition: 0.5s;\n}\n\n.single-speakers .speakers-content h3 {\n  font-size: 24px;\n  margin-bottom: 0;\n  color: #ff2d55;\n}\n.sponsors-row {\n  @media (max-width: 520px) {\n    margin-bottom: 20vw !important;\n  }\n}\n.more-speakers-content {\n  background-image: url(\"../assets/events_images/MoreSpeaker.webp\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n  width: 100%;\n  padding: 1vw;\n  @media (max-width: 993px) {\n    height: 100%;\n    /* height: calc(100% + 8vh); */\n  }\n}\n\n.more-speakers-content h3 {\n  line-height: 200%;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 32px !important;\n  line-height: 150%;\n  @media (min-width: 1600px) {\n    font-size: 2vw !important;\n  }\n  @media (max-width: 991px) {\n    font-size: 25px !important;\n    margin-bottom: 20px;\n  }\n  @media (max-width: 768px) {\n    font-size: 24px !important;\n  }\n}\n\n.more-speakers-content h3 span {\n  background: linear-gradient(180deg, #f15a2b, #e74860);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-weight: bold;\n}\n\n.coming-soon-speakers {\n  position: relative;\n  z-index: 1;\n  background-image: url(\"../assets/events_images/MoreSpeaker.webp\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  height: 70vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  @media (max-width: 993px) {\n    height: 50vh;\n  }\n}\n/* .coming-soon-speakers::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  opacity: 0.88;\n} */\n.coming-soon-speakers h3 {\n  color: #fff !important;\n  font-size: 32px;\n  font-weight: 400;\n  @media (min-width: 1600px) {\n    font-size: 2vw !important;\n  }\n\n  @media (max-width: 767px) {\n    font-size: 20px !important;\n  }\n}\n.coming-soon-speakers h1 {\n  font-size: 64px;\n  font-weight: 900;\n  color: #e74860 !important;\n  @media (min-width: 1600px) {\n    font-size: 4vw !important;\n  }\n  @media (max-width: 767px) {\n    font-size: 36px !important;\n  }\n}\n\n.single-speakers .speakers-content h3:hover,\n.single-speakers .speakers-content h3:focus {\n  color: #8dc63f;\n}\n.single-speakers .speakers-content span {\n  display: block;\n  margin-top: 6px;\n  color: #ffffff;\n  transition: 0.5s;\n}\n.single-speakers ul {\n  padding: 15px;\n  margin: 0 0 0;\n  opacity: 0;\n  visibility: hidden;\n  list-style-type: none;\n  transition: 0.5s;\n  position: absolute;\n  right: -15px;\n  top: 0;\n  background-color: #ffffff;\n}\n.single-speakers ul li {\n  display: block;\n  margin-bottom: 10px;\n}\n.single-speakers ul li:last-child {\n  margin-bottom: 0;\n}\n.single-speakers ul li a {\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n  text-align: center;\n  background-color: #ff2d55;\n  color: #ffffff;\n  border-radius: 50%;\n  font-size: 14px;\n}\n.single-speakers ul li a.facebook {\n  background-color: #4267b2;\n}\n.single-speakers ul li a.twitter {\n  background-color: #38a1f3;\n}\n.single-speakers ul li a.instagram {\n  background: radial-gradient(\n      circle farthest-corner at 35% 90%,\n      #fec564,\n      transparent 50%\n    ),\n    radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),\n    radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),\n    radial-gradient(\n      ellipse farthest-corner at 20% -50%,\n      #5258cf,\n      transparent 50%\n    ),\n    radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),\n    radial-gradient(\n      ellipse farthest-corner at 60% -20%,\n      #893dc2,\n      transparent 50%\n    ),\n    radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),\n    linear-gradient(\n      #6559ca,\n      #bc318f 30%,\n      #e33f5f 50%,\n      #f77638 70%,\n      #fec66d 100%\n    );\n}\n.single-speakers ul li a.linkedin {\n  background-color: #0077b5;\n}\n.single-speakers ul li a:hover,\n.single-speakers ul li a:focus {\n  background-color: #ff2d55;\n  color: #ffffff;\n}\n.single-speakers:hover .speakers-content,\n.single-speakers:focus .speakers-content {\n  bottom: 45px;\n}\n.single-speakers:hover ul,\n.single-speakers:focus ul {\n  right: 0;\n  opacity: 1;\n  visibility: visible;\n}\n\n/*Speakers-Style-Two*/\n.elkevent-single-speakers {\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n  /* padding: 15px; */\n  @media (max-width: 993px) {\n    /* padding-bottom: 8vh; */\n  }\n}\n.elkevent-single-speakers .speakers-content {\n  position: absolute;\n  bottom: -25px;\n  left: 0;\n  background-color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 25px;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.5s;\n  @media (max-width: 993px) {\n    min-height: 10vh;\n    bottom: 0 !important ;\n    opacity: 1 !important;\n    visibility: visible !important;\n  }\n}\n.elkevent-single-speakers .speakers-content h3 {\n  font-size: 24px;\n  font-weight: 900 !important;\n  color: #121d39;\n  margin-bottom: 0;\n  text-align: center;\n  @media (min-width: 1600px) {\n    font-size: 1.5vw;\n  }\n}\n.elkevent-single-speakers .speakers-content h3 a {\n  color: #121d39;\n}\n.elkevent-single-speakers .speakers-content h3 a:hover,\n.elkevent-single-speakers .speakers-content h3 a:focus {\n  color: #121d39;\n}\n.elkevent-single-speakers .speakers-content span {\n  text-align: center;\n  display: block;\n  font-size: 16px;\n  margin-top: 8px;\n  color: #e74860;\n  transition: 0.5s;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw;\n  }\n}\n.elkevent-single-speakers ul {\n  padding: 15px 20px 10px;\n  margin: 0 0 0;\n  opacity: 0;\n  visibility: hidden;\n  list-style-type: none;\n  transition: 0.5s;\n  position: absolute;\n  right: -15px;\n  top: 0;\n  background-color: #ffffff;\n}\n.elkevent-single-speakers ul li {\n  display: block;\n  margin-bottom: 5px;\n}\n.elkevent-single-speakers ul li a {\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n  text-align: center;\n  background-color: #ff2d55;\n  color: #ffffff;\n  border-radius: 50%;\n  font-size: 14px;\n}\n.elkevent-single-speakers ul li a.facebook {\n  background-color: #4267b2;\n}\n.elkevent-single-speakers ul li a.twitter {\n  background-color: #38a1f3;\n}\n.elkevent-single-speakers ul li a.instagram {\n  background: radial-gradient(\n      circle farthest-corner at 35% 90%,\n      #fec564,\n      transparent 50%\n    ),\n    radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),\n    radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),\n    radial-gradient(\n      ellipse farthest-corner at 20% -50%,\n      #5258cf,\n      transparent 50%\n    ),\n    radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),\n    radial-gradient(\n      ellipse farthest-corner at 60% -20%,\n      #893dc2,\n      transparent 50%\n    ),\n    radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),\n    linear-gradient(\n      #6559ca,\n      #bc318f 30%,\n      #e33f5f 50%,\n      #f77638 70%,\n      #fec66d 100%\n    );\n}\n.elkevent-single-speakers ul li a.linkedin {\n  background-color: #0077b5;\n}\n.elkevent-single-speakers ul li a:hover,\n.elkevent-single-speakers ul li a:focus {\n  background-color: #ff2d55;\n  color: #ffffff;\n}\n.elkevent-single-speakers img {\n  transition: 0.5s;\n  position: relative;\n}\n.elkevent-single-speakers:hover .speakers-content,\n.elkevent-single-speakers:focus .speakers-content {\n  bottom: 0;\n  opacity: 1;\n  visibility: visible;\n}\n.elkevent-single-speakers:hover ul,\n.elkevent-single-speakers:focus ul {\n  right: 0;\n  opacity: 1;\n  visibility: visible;\n}\n.elkevent-single-speakers:hover img,\n.elkevent-single-speakers:focus img {\n  transform: scale(1.1);\n  filter: brightness(1) drop-shadow(0 0 10px rgba(255, 255, 255, 0.4));\n  transition: transform 0.5s ease, filter 0.5s ease;\n}\n\n/*Speakers-style-three*/\n.speakers-area {\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n\n.speakers-area-two {\n  padding-bottom: 90px;\n}\n\n.single-speakers-box {\n  margin-bottom: 30px;\n  text-align: center;\n  transition: 0.5s;\n  box-shadow: 0 15px 20px 0 rgba(0, 0, 0, 0.06);\n}\n.single-speakers-box .speakers-content {\n  background: #ffffff;\n  padding: 30px 0;\n  position: relative;\n  transition: 0.5s;\n}\n.single-speakers-box .speakers-content::before {\n  content: \"\";\n  width: 0;\n  height: 20px;\n  color: #ffffff;\n  background: #ff2d55;\n  position: absolute;\n  top: -20px;\n  right: 0;\n  transition: 0.5s;\n}\n.single-speakers-box .speakers-content h3 {\n  font-size: 20px;\n  margin-bottom: 10px;\n  color: #0d1028;\n}\n.single-speakers-box .speakers-content span {\n  display: block;\n  text-transform: capitalize;\n  transition: 0.5s;\n  color: #ff2d55;\n}\n.single-speakers-box .speakers-content .social {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n  position: absolute;\n  top: -37px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  transform: scale(0);\n  transition: 0.5s;\n}\n.single-speakers-box .speakers-content .social li {\n  display: inline-block;\n}\n.single-speakers-box .speakers-content .social li a {\n  display: block;\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n  font-size: 16px;\n  color: #a0a0a0;\n  margin-right: 10px;\n  position: relative;\n  z-index: 1;\n}\n.single-speakers-box .speakers-content .social li a:hover {\n  color: #ffffff;\n}\n.single-speakers-box .speakers-content .social li a:hover::before {\n  background: #00acee;\n  color: #ffffff;\n  transform: rotate(-45deg);\n}\n.single-speakers-box .speakers-content .social li a::before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #ffffff;\n  transform: rotate(45deg);\n  z-index: -1;\n  transition: 0.5s;\n}\n.single-speakers-box:hover {\n  box-shadow: 0 0 28px 0 rgba(6, 74, 255, 0.22);\n}\n.single-speakers-box:hover::before,\n.single-speakers-box:hover::after {\n  border-color: #ff2d55;\n  transform: scale(1);\n}\n.single-speakers-box:hover .speakers-content {\n  background: #ff2d55;\n}\n.single-speakers-box:hover .speakers-content::before {\n  width: 100%;\n}\n.single-speakers-box:hover .speakers-content .social {\n  transform: scale(1);\n}\n.single-speakers-box:hover .speakers-content h3,\n.single-speakers-box:hover .speakers-content span {\n  color: #ffffff;\n}\n\n/*================================================\nSchedule CSS\n=================================================*/\n.agenda-top-area {\n  background-image: url(\"../assets/events_images/agenda-top.webp\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 40vh;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  @media (max-width: 993px) {\n    height: 15vh !important;\n  }\n}\n.coming-soon-speakers h1 {\n  font-size: 64px;\n  font-weight: 900;\n  color: #e74860 !important;\n}\n\n.schedule-area {\n  position: relative;\n}\n.schedule-area.bg-image {\n  background-image: url(\"../assets/events_images/agenda-pattern.webp\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.events-last-div {\n  margin-bottom: 0;\n}\n\n.events-div {\n  margin-bottom: 4vh;\n  @media (max-width: 767px) {\n    margin-bottom: 16px;\n  }\n}\n\n.event-tabs {\n  box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);\n  margin: 60px 0 120px 0;\n  @media (max-width: 767px) {\n    margin: 30px 0 60px 0;\n  }\n}\n.event-tabs .react-tabs__tab-list {\n  border: none;\n  margin: 0;\n  display: flex;\n  width: 100%;\n  text-align: center;\n}\n.event-tabs .react-tabs__tab-list li {\n  display: block;\n  flex: 1;\n  background-color: #ffffff;\n  transition: 0.5s;\n  position: relative;\n  border: none;\n  font-size: 28px;\n  font-weight: 700;\n  color: #121d39;\n  text-transform: uppercase;\n  padding: 25px 10px;\n  border-radius: 5px 5px 0 0;\n  @media (min-width: 1600px) {\n    font-size: 1.5vw;\n  }\n}\n.event-tabs .react-tabs__tab-list li::before {\n  width: 30px;\n  height: 30px;\n  left: 0;\n  bottom: -15px;\n  position: absolute;\n  background: #e74860;\n  color: #253d77;\n  content: \"\";\n  transform: rotate(45deg);\n  right: 0;\n  margin: 0 auto;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.5s;\n}\n.event-tabs .react-tabs__tab-list li span {\n  display: block;\n  font-size: 16px;\n  text-transform: capitalize;\n  margin-top: 5px;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw;\n    margin-top: 1.5vh;\n  }\n}\n.event-tabs .react-tabs__tab-list li:focus::after {\n  background-color: transparent;\n}\n/* .event-tabs .react-tabs__tab-list li:nth-child(2) {\n  background-color: #E74860;\n}\n.event-tabs .react-tabs__tab-list li:nth-child(3) {\n  background-color: #8dc63f;\n}\n.event-tabs .react-tabs__tab-list  {\n  background-color: #efa506;\n} */\n.event-tabs .react-tabs__tab-list li.react-tabs__tab--selected {\n  background-color: #e74860;\n  color: #ffffff;\n}\n.event-tabs .react-tabs__tab-list li.react-tabs__tab--selected::before {\n  opacity: 1;\n  visibility: visible;\n}\n.event-tabs .react-tabs__tab-panel {\n  padding: 30px;\n  background-color: #f8f8f830;\n}\n.event-tabs .react-tabs__tab-panel .accordion {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n.event-tabs .react-tabs__tab-panel .accordion .accordion__item {\n  display: block;\n  margin-bottom: 15px;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  background-color: #ffffff;\n  border-radius: 10px;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.event-tabs .react-tabs__tab-panel .accordion .accordion__item:hover {\n  background-color: #121d39;\n}\n\n.event-tabs .react-tabs__tab-panel .accordion .accordion__item:last-child {\n  margin-bottom: 0;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button {\n  background-color: transparent;\n  display: flex;\n  position: relative;\n  align-items: center !important;\n  padding-left: 25px;\n  padding-bottom: 35px;\n  padding-top: 35px;\n  @media (max-width: 767px) {\n    padding-bottom: 0 !important;\n  }\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button::before {\n  display: none;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .author {\n  max-width: 100px;\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .author-multi {\n  overflow: hidden;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .author-multi\n  img {\n  width: 47%;\n  border-radius: 50%;\n  margin-bottom: 0.2rem;\n  margin-right: 1.5%;\n  margin-left: 1.5%;\n  margin-top: 0.2rem;\n  float: left;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-info\n  h3 {\n  font-size: 36px;\n  margin-bottom: 15px;\n  text-transform: capitalize;\n  color: #121d39;\n  font-weight: 600;\n  @media (min-width: 1600px) {\n    font-size: 2.25vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px !important;\n  }\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button:hover\n  .schedule-info\n  h3 {\n  color: #e74860;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-info\n  h4 {\n  color: #121d39;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 15px;\n  text-transform: capitalize;\n  line-height: 140%;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 16px !important;\n  }\n}\n\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button:hover\n  .schedule-info\n  h4 {\n  color: #ffffff;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-time {\n  color: #e74860 !important;\n  font-weight: 600 !important;\n  font-size: 20px !important;\n  display: flex;\n  justify-content: right;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw !important;\n  }\n  @media (max-width: 767px) {\n    justify-content: center;\n    font-size: 16px !important;\n  }\n}\n\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item:hover\n  .accordion__button\n  .schedule-time {\n  color: #ffffff !important;\n}\n\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-info\n  ul {\n  padding: 0;\n  list-style-type: none;\n  margin: 0;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-info\n  ul\n  li {\n  display: inline-block;\n  color: #707070;\n  margin-right: 20px;\n  font-size: 14px;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-info\n  ul\n  li:last-child {\n  margin-right: 0;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-info\n  ul\n  li\n  i {\n  margin-right: 5px;\n  color: #ff2d55;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .accordion__button\n  .schedule-info\n  ul\n  li\n  span {\n  color: #00acee;\n}\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .schedule-desc\n  p {\n  color: #121d39 !important;\n  font-size: 16px;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 14px;\n    margin-top: 20px;\n  }\n  @media (max-width: 600px) {\n    display: none;\n  }\n}\n\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item:hover\n  .schedule-desc\n  p {\n  color: #ffffff !important;\n}\n\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item\n  .schedule-desc\n  li {\n  color: #e74860 !important;\n  font-size: 1rem;\n}\n\n.event-tabs\n  .react-tabs__tab-panel\n  .accordion\n  .accordion__item:hover\n  .schedule-desc\n  li {\n  color: #e74860 !important;\n}\n\n.btn-box {\n  text-align: center;\n  margin-top: 50px;\n}\n.btn-box .btn {\n  margin: 0 15px;\n}\n\n/*schedule-style-two*/\n.schedule-slides-item .single-schedule {\n  position: relative;\n  background: #ffffff;\n  text-align: center;\n  padding: 0 0 0 200px;\n}\n.schedule-slides-item .single-schedule .schedule-date {\n  font-size: 24px;\n  color: #ffffff;\n  background: #ff2d55;\n  text-transform: uppercase;\n  padding: 25px 40px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 200px;\n}\n.schedule-slides-item .single-schedule .schedule-date span {\n  display: block;\n  font-size: 15px;\n  text-transform: capitalize;\n  margin-top: 5px;\n}\n.schedule-slides-item .single-schedule .schedule-content {\n  display: flex;\n  align-items: center !important;\n  border-bottom: 1px solid #eeeeee;\n  padding: 20px;\n  text-align: left;\n}\n.schedule-slides-item .single-schedule .schedule-content .author {\n  max-width: 100px;\n  margin-right: 25px;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(1) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    38.11% 6.7%,\n    24.99% 6.72%,\n    18.06% 18.44%,\n    6.7% 25%,\n    6.56% 38.64%,\n    0% 50%,\n    6.7% 61.89%,\n    6.7% 75%,\n    18.44% 81.94%,\n    25% 93.3%,\n    38.64% 93.44%,\n    50% 100%,\n    61.88% 93.3%,\n    75% 93.3%,\n    81.94% 81.56%,\n    93.3% 74.9%,\n    93.44% 61.36%,\n    100% 50%,\n    93.3% 38.11%,\n    93.3% 25%,\n    81.56% 18.06%,\n    74.96% 6.7%,\n    61.36% 6.56%,\n    50% 0%\n  );\n  clip-path: polygon(\n    50% 0%,\n    38.11% 6.7%,\n    24.99% 6.72%,\n    18.06% 18.44%,\n    6.7% 25%,\n    6.56% 38.64%,\n    0% 50%,\n    6.7% 61.89%,\n    6.7% 75%,\n    18.44% 81.94%,\n    25% 93.3%,\n    38.64% 93.44%,\n    50% 100%,\n    61.88% 93.3%,\n    75% 93.3%,\n    81.94% 81.56%,\n    93.3% 74.9%,\n    93.44% 61.36%,\n    100% 50%,\n    93.3% 38.11%,\n    93.3% 25%,\n    81.56% 18.06%,\n    74.96% 6.7%,\n    61.36% 6.56%,\n    50% 0%\n  );\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(2) {\n  -webkit-clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);\n  clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(3) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    100% 25%,\n    100% 75%,\n    50% 100%,\n    0% 75%,\n    0% 25%\n  );\n  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(4) {\n  border-radius: 50%;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(5) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n  clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(6) {\n  -webkit-clip-path: polygon(\n    30% 0%,\n    70% 0%,\n    100% 30%,\n    100% 70%,\n    70% 100%,\n    30% 100%,\n    0% 70%,\n    0% 30%\n  );\n  clip-path: polygon(\n    30% 0%,\n    70% 0%,\n    100% 30%,\n    100% 70%,\n    70% 100%,\n    30% 100%,\n    0% 70%,\n    0% 30%\n  );\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(7) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    83% 12%,\n    100% 43%,\n    94% 78%,\n    68% 100%,\n    32% 100%,\n    6% 78%,\n    0% 43%,\n    17% 12%\n  );\n  clip-path: polygon(\n    50% 0%,\n    83% 12%,\n    100% 43%,\n    94% 78%,\n    68% 100%,\n    32% 100%,\n    6% 78%,\n    0% 43%,\n    17% 12%\n  );\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(8) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    80% 10%,\n    100% 35%,\n    100% 70%,\n    80% 90%,\n    50% 100%,\n    20% 90%,\n    0% 70%,\n    0% 35%,\n    20% 10%\n  );\n  clip-path: polygon(\n    50% 0%,\n    80% 10%,\n    100% 35%,\n    100% 70%,\n    80% 90%,\n    50% 100%,\n    20% 90%,\n    0% 70%,\n    0% 35%,\n    20% 10%\n  );\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(9) {\n  -webkit-clip-path: circle(50% at 50% 50%);\n  clip-path: circle(50% at 50% 50%);\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .author\n  img:nth-child(10) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n  clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n}\n.schedule-slides-item .single-schedule .schedule-content .author-multi {\n  overflow: hidden;\n}\n.schedule-slides-item .single-schedule .schedule-content .author-multi img {\n  width: 47%;\n  border-radius: 50%;\n  margin-bottom: 0.4rem;\n  margin-right: 3%;\n  float: left;\n}\n.schedule-slides-item .single-schedule .schedule-content .schedule-info h3 {\n  font-size: 20px;\n  margin-bottom: 12px;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw;\n  }\n}\n.schedule-slides-item .single-schedule .schedule-content .schedule-info h3 a {\n  color: #0d1028;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  h3\n  a:hover,\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  h3\n  a:focus {\n  color: #ff2d55;\n}\n.schedule-slides-item .single-schedule .schedule-content .schedule-info ul {\n  padding: 0;\n  list-style-type: none;\n  margin: 0;\n}\n.schedule-slides-item .single-schedule .schedule-content .schedule-info ul li {\n  display: inline-block;\n  color: #707070;\n  margin-right: 20px;\n  font-size: 14px;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  ul\n  li:last-child {\n  margin-right: 0;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  i {\n  margin-right: 6px;\n  color: #ff2d55;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  ul\n  li:last-child {\n  margin-right: 0;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  a {\n  display: inline-block;\n  color: #00acee;\n}\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  a:hover,\n.schedule-slides-item\n  .single-schedule\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  a:focus {\n  color: #ff2d55;\n}\n.schedule-slides-item .single-schedule:nth-child(2) .schedule-date {\n  background: #00acee;\n}\n.schedule-slides-item .single-schedule:nth-child(3) .schedule-date {\n  background: #efa506;\n}\n.schedule-slides-item .single-schedule:nth-child(4) .schedule-date {\n  background: #8dc63f;\n}\n.schedule-slides-item .single-schedule:nth-child(5) .schedule-date {\n  background: #00acee;\n}\n.schedule-slides-item .single-schedule:nth-child(6) .schedule-date {\n  background: #efa506;\n}\n.schedule-slides-item .single-schedule:nth-child(7) .schedule-date {\n  background: #8dc63f;\n}\n\n.schedule-slides .swiper-button-next,\n.schedule-slides .swiper-button-prev {\n  color: #0d1028;\n  transition: 0.5s;\n}\n.schedule-slides .swiper-button-next::after,\n.schedule-slides .swiper-button-prev::after {\n  font-size: 25px;\n}\n.schedule-slides .swiper-button-next:hover,\n.schedule-slides .swiper-button-next:focus,\n.schedule-slides .swiper-button-prev:hover,\n.schedule-slides .swiper-button-prev:focus {\n  color: #ff2d55;\n}\n\n/*schedule-style-three*/\n.schedule-style-three {\n  padding-bottom: 90px;\n}\n.schedule-style-three\n  .col-lg-6:nth-child(2)\n  .single-schedule-item\n  .schedule-date {\n  background-color: #00acee;\n}\n.schedule-style-three\n  .col-lg-6:nth-child(3)\n  .single-schedule-item\n  .schedule-date {\n  background-color: #efa506;\n}\n.schedule-style-three\n  .col-lg-6:nth-child(4)\n  .single-schedule-item\n  .schedule-date {\n  background-color: #8dc63f;\n}\n.schedule-style-three\n  .col-lg-6:nth-child(5)\n  .single-schedule-item\n  .schedule-date {\n  background-color: #00acee;\n}\n.schedule-style-three\n  .col-lg-6:nth-child(6)\n  .single-schedule-item\n  .schedule-date {\n  background-color: #efa506;\n}\n.schedule-style-three\n  .col-lg-6:nth-child(7)\n  .single-schedule-item\n  .schedule-date {\n  background-color: #8dc63f;\n}\n\n.single-schedule-item {\n  text-align: center;\n  margin-bottom: 30px;\n  background-color: #ffffff;\n  box-shadow: 0 15px 20px 0 rgba(0, 0, 0, 0.06);\n}\n.single-schedule-item .schedule-date {\n  font-size: 24px;\n  color: #ffffff;\n  background: #ff2d55;\n  text-transform: uppercase;\n  padding: 20px;\n}\n.single-schedule-item .schedule-date span {\n  display: block;\n  font-size: 14px;\n  text-transform: capitalize;\n  margin-top: 5px;\n}\n.single-schedule-item .schedule-item-wrapper .schedule-content {\n  display: flex;\n  align-items: center !important;\n  border-bottom: 1px solid #eeeeee;\n  padding: 25px 20px;\n  text-align: left;\n}\n.single-schedule-item .schedule-item-wrapper .schedule-content .author {\n  max-width: 90px;\n  margin-right: 20px;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(1) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    38.11% 6.7%,\n    24.99% 6.72%,\n    18.06% 18.44%,\n    6.7% 25%,\n    6.56% 38.64%,\n    0% 50%,\n    6.7% 61.89%,\n    6.7% 75%,\n    18.44% 81.94%,\n    25% 93.3%,\n    38.64% 93.44%,\n    50% 100%,\n    61.88% 93.3%,\n    75% 93.3%,\n    81.94% 81.56%,\n    93.3% 74.9%,\n    93.44% 61.36%,\n    100% 50%,\n    93.3% 38.11%,\n    93.3% 25%,\n    81.56% 18.06%,\n    74.96% 6.7%,\n    61.36% 6.56%,\n    50% 0%\n  );\n  clip-path: polygon(\n    50% 0%,\n    38.11% 6.7%,\n    24.99% 6.72%,\n    18.06% 18.44%,\n    6.7% 25%,\n    6.56% 38.64%,\n    0% 50%,\n    6.7% 61.89%,\n    6.7% 75%,\n    18.44% 81.94%,\n    25% 93.3%,\n    38.64% 93.44%,\n    50% 100%,\n    61.88% 93.3%,\n    75% 93.3%,\n    81.94% 81.56%,\n    93.3% 74.9%,\n    93.44% 61.36%,\n    100% 50%,\n    93.3% 38.11%,\n    93.3% 25%,\n    81.56% 18.06%,\n    74.96% 6.7%,\n    61.36% 6.56%,\n    50% 0%\n  );\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(2) {\n  -webkit-clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);\n  clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(3) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    100% 25%,\n    100% 75%,\n    50% 100%,\n    0% 75%,\n    0% 25%\n  );\n  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(4) {\n  border-radius: 50%;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(5) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n  clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(6) {\n  -webkit-clip-path: polygon(\n    30% 0%,\n    70% 0%,\n    100% 30%,\n    100% 70%,\n    70% 100%,\n    30% 100%,\n    0% 70%,\n    0% 30%\n  );\n  clip-path: polygon(\n    30% 0%,\n    70% 0%,\n    100% 30%,\n    100% 70%,\n    70% 100%,\n    30% 100%,\n    0% 70%,\n    0% 30%\n  );\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(7) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    83% 12%,\n    100% 43%,\n    94% 78%,\n    68% 100%,\n    32% 100%,\n    6% 78%,\n    0% 43%,\n    17% 12%\n  );\n  clip-path: polygon(\n    50% 0%,\n    83% 12%,\n    100% 43%,\n    94% 78%,\n    68% 100%,\n    32% 100%,\n    6% 78%,\n    0% 43%,\n    17% 12%\n  );\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(8) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    80% 10%,\n    100% 35%,\n    100% 70%,\n    80% 90%,\n    50% 100%,\n    20% 90%,\n    0% 70%,\n    0% 35%,\n    20% 10%\n  );\n  clip-path: polygon(\n    50% 0%,\n    80% 10%,\n    100% 35%,\n    100% 70%,\n    80% 90%,\n    50% 100%,\n    20% 90%,\n    0% 70%,\n    0% 35%,\n    20% 10%\n  );\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(9) {\n  -webkit-clip-path: circle(50% at 50% 50%);\n  clip-path: circle(50% at 50% 50%);\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author\n  img:nth-child(10) {\n  -webkit-clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n  clip-path: polygon(\n    50% 0%,\n    90% 20%,\n    100% 60%,\n    75% 100%,\n    25% 100%,\n    0% 60%,\n    10% 20%\n  );\n}\n.single-schedule-item .schedule-item-wrapper .schedule-content .author-multi {\n  overflow: hidden;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .author-multi\n  img {\n  width: 47%;\n  border-radius: 50%;\n  margin-bottom: 0.4rem;\n  margin-right: 3%;\n  float: left;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  h3 {\n  font-size: 18px;\n  margin-bottom: 12px;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  h3\n  a {\n  color: #0d1028;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  h3\n  a:hover,\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  h3\n  a:focus {\n  color: #ff2d55;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul {\n  padding: 0;\n  list-style-type: none;\n  margin: 0;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul\n  li {\n  display: inline-block;\n  color: #707070;\n  margin-right: 20px;\n  line-height: 1.9;\n  font-size: 14px;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  i {\n  margin-right: 5px;\n  color: #ff2d55;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  .icofont-user-suited {\n  margin-right: 8px;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul\n  li:last-child {\n  margin-right: 0;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  a {\n  display: inline-block;\n  color: #00acee;\n}\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  a:hover,\n.single-schedule-item\n  .schedule-item-wrapper\n  .schedule-content\n  .schedule-info\n  ul\n  li\n  a:focus {\n  color: #ff2d55;\n}\n.single-schedule-item .schedule-item-wrapper .schedule-content:last-child {\n  border-bottom: none;\n}\n\n/*schedule-style-four*/\n.schedule-style-four .event-tabs {\n  background-color: transparent;\n  box-shadow: unset;\n}\n.schedule-style-four .react-tabs__tab-list {\n  display: block;\n}\n.schedule-style-four .react-tabs__tab-list li::before {\n  left: -15px;\n  bottom: 37%;\n  margin: 0 0 0;\n  right: auto;\n}\n.schedule-style-four .tab_content {\n  box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);\n}\n\n/*================================================\nFunFacts CSS\n=================================================*/\n.funfacts-area {\n  position: relative;\n  z-index: 1;\n  /* background-image: url(\"../assets/events_images/funfacts-bg.jpg\"); */\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n.funfacts-area::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  background: #0d1028;\n  opacity: 0.88;\n}\n\n.single-funfact {\n  text-align: center;\n}\n.single-funfact .icon {\n  color: #ffffff;\n  font-size: 40px;\n}\n.single-funfact h3 {\n  color: #ffffff;\n  font-size: 55px;\n  margin-top: 10px;\n  margin-bottom: 8px;\n}\n.single-funfact p {\n  color: #ffffff;\n  letter-spacing: 1px;\n  font-size: 16px;\n  margin-bottom: 0;\n  line-height: 1;\n}\n\n/*funfact-style-two*/\n.funFact {\n  position: relative;\n  padding-left: 60px;\n}\n.funFact .icon {\n  color: #ffffff;\n  font-size: 40px;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.funFact h3 {\n  color: #ffffff;\n  font-size: 55px;\n  margin-top: 0;\n  margin-bottom: 8px;\n}\n.funFact p {\n  color: #ffffff;\n  letter-spacing: 1px;\n  font-size: 16px;\n  margin-bottom: 0;\n  line-height: 1;\n}\n\n.col-lg-3:nth-child(1) .single-funfact h3,\n.col-lg-3:nth-child(1) .funFact h3 {\n  color: #ff2d55;\n}\n.col-lg-3:nth-child(2) .single-funfact h3,\n.col-lg-3:nth-child(2) .funFact h3 {\n  color: #00acee;\n}\n.col-lg-3:nth-child(3) .single-funfact h3,\n.col-lg-3:nth-child(3) .funFact h3 {\n  color: #efa506;\n}\n.col-lg-3:nth-child(4) .single-funfact h3,\n.col-lg-3:nth-child(4) .funFact h3 {\n  color: #8dc63f;\n}\n\n/*================================================\nPricing CSS\n=================================================*/\n.pricing-area {\n  position: relative;\n  z-index: 1;\n}\n.pricing-area.bg-image {\n  background-image: url(\"../assets/events_images/bg.webp\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n.pricing-table-box {\n  padding-bottom: 30px;\n  background: #ffffff;\n  text-align: center;\n  z-index: 1;\n  position: relative;\n  border-radius: 5px;\n  /* background-image: url(\"/images/patt.png\"); */\n  background-position: center center;\n  overflow: hidden;\n  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);\n  transition: 0.5s;\n}\n.pricing-table-box .pricingTable-header {\n  padding: 30px 15px 10px;\n  background: #ff2d55;\n  -webkit-clip-path: polygon(50% 100%, 100% 60%, 100% 0, 0 0, 0 60%);\n  clip-path: polygon(50% 100%, 100% 60%, 100% 0, 0 0, 0 60%);\n  position: relative;\n}\n.pricing-table-box .pricingTable-header::before {\n  content: \"\";\n  width: 400px;\n  height: 400px;\n  border-radius: 50%;\n  position: absolute;\n  right: -50%;\n  top: -130%;\n  background: repeating-radial-gradient(\n    rgba(255, 255, 255, 0.04),\n    rgba(255, 255, 255, 0.17) 20%\n  );\n  transition: 0.5s;\n}\n.pricing-table-box .title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  text-transform: uppercase;\n  margin-bottom: 15px;\n}\n.pricing-table-box .price-value {\n  display: block;\n  font-size: 55px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 30px;\n}\n.pricing-table-box .price-value sup {\n  font-size: 23px;\n  top: -25px;\n}\n.pricing-table-box .pricing-content {\n  padding: 35px 0;\n  margin-bottom: 0;\n  list-style-type: none;\n}\n.pricing-table-box .pricing-content li {\n  color: #707070;\n  text-transform: capitalize;\n  border-bottom: 1px solid #eeeeee;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n}\n.pricing-table-box .pricing-content li:last-child {\n  margin-bottom: 0;\n}\n.pricing-table-box .pricing-content li:first-child {\n  border-top: 1px solid #eeeeee;\n  padding-top: 12px;\n}\n.pricing-table-box:hover,\n.pricing-table-box:focus,\n.pricing-table-box.active {\n  transform: translateY(-10px);\n}\n.pricing-table-box:hover .pricingTable-header::before,\n.pricing-table-box:focus .pricingTable-header::before,\n.pricing-table-box.active .pricingTable-header::before {\n  right: 50%;\n}\n\n/*pricing-style-two*/\n.pricing-plan {\n  position: relative;\n  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);\n  text-align: center;\n  padding-bottom: 30px;\n  transition: 0.5s;\n  background-color: #ffffff;\n}\n.pricing-plan h3 {\n  font-size: 24px;\n  padding: 30px 15px;\n  margin-bottom: 100px;\n  background-color: #ff2d55;\n  color: #ffffff;\n  transition: 0.5s;\n}\n.pricing-plan h3 span {\n  display: block;\n  color: #ff2d55;\n  background: #ffffff;\n  height: 150px;\n  width: 150px;\n  line-height: 155px;\n  font-size: 35px;\n  box-shadow: 7px 5px 30px 0 rgba(72, 73, 121, 0.15);\n  margin: 30px auto -95px;\n  border-radius: 50%;\n  transition: 0.5s;\n}\n.pricing-plan h3 span sup {\n  font-weight: 500;\n}\n.pricing-plan .pricing-content {\n  padding: 0 0 35px;\n  margin-bottom: 0;\n  list-style-type: none;\n}\n.pricing-plan .pricing-content li {\n  color: #707070;\n  text-transform: capitalize;\n  border-bottom: 1px solid #eeeeee;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n}\n.pricing-plan .pricing-content li:last-child {\n  margin-bottom: 0;\n}\n.pricing-plan .pricing-content li:first-child {\n  border-top: 1px solid #eeeeee;\n  padding-top: 12px;\n}\n.pricing-plan:hover,\n.pricing-plan:focus {\n  transform: translateY(-8px);\n}\n\n.col-lg-4:nth-child(2) .pricing-table-box .pricingTable-header {\n  background: #00acee;\n}\n.col-lg-4:nth-child(2) .pricing-table-box .btn-primary::before,\n.col-lg-4:nth-child(2) .pricing-table-box .btn-primary::after {\n  background: #00acee;\n}\n.col-lg-4:nth-child(2) .pricing-plan h3 {\n  background: #00acee;\n}\n.col-lg-4:nth-child(2) .pricing-plan h3 span {\n  color: #00acee;\n}\n.col-lg-4:nth-child(2) .pricing-plan .btn-primary::before,\n.col-lg-4:nth-child(2) .pricing-plan .btn-primary::after {\n  background: #00acee;\n}\n.col-lg-4:nth-child(3) .pricing-table-box .pricingTable-header {\n  background: #8dc63f;\n}\n.col-lg-4:nth-child(3) .pricing-table-box .btn-primary::before,\n.col-lg-4:nth-child(3) .pricing-table-box .btn-primary::after {\n  background: #8dc63f;\n}\n.col-lg-4:nth-child(3) .pricing-plan h3 {\n  background: #8dc63f;\n}\n.col-lg-4:nth-child(3) .pricing-plan h3 span {\n  color: #8dc63f;\n}\n.col-lg-4:nth-child(3) .pricing-plan .btn-primary::before,\n.col-lg-4:nth-child(3) .pricing-plan .btn-primary::after {\n  background: #8dc63f;\n}\n\n/*================================================\nPartner CSS\n=================================================*/\n.partner-area {\n  overflow: hidden;\n  background-color: #ffffff;\n}\n.partner-section-title h2 {\n  color: #121d39;\n  font-size: 28px;\n  font-weight: 400;\n  margin-bottom: 10px;\n  text-align: center;\n  text-transform: uppercase;\n  @media (min-width: 1600px) {\n    font-size: 1.75vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n.partner-section-title h1 {\n  font-size: 52px;\n  padding-bottom: 24px;\n  text-align: center;\n  background: linear-gradient(180deg, #f15a2b, #e74860);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  margin: 0;\n  border-bottom: 1px solid #d1d1d1;\n  @media (min-width: 1600px) {\n    font-size: 3.25vw;\n  }\n\n  @media (max-width: 767px) {\n    font-size: 36px;\n  }\n}\n\n.diamond-sponsors {\n  background: linear-gradient(180deg, #d9317a, #e74860);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-size: 28px;\n  font-weight: 600;\n  margin: 0;\n  padding-top: 30px;\n  text-align: center;\n  text-transform: uppercase;\n  @media (min-width: 1600px) {\n    font-size: 1.75vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n\n.platinum-sponsors {\n  background: linear-gradient(180deg, #00acee, #121d39);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-size: 28px;\n  font-weight: 600;\n  margin: 0;\n  padding: 30px 0;\n  text-align: center;\n  /* border-bottom: 1px solid #d1d1d1; */\n  text-transform: uppercase;\n  @media (min-width: 1600px) {\n    font-size: 1.75vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n\n.platinum-sponsors span {\n  color: #121d39;\n  font-size: 20px;\n  font-weight: 400;\n  margin: 0;\n  text-align: center;\n  text-transform: capitalize;\n  @media (min-width: 1600px) {\n    font-size: 1.5vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n\n.gold-sponsors {\n  background: linear-gradient(180deg, #c6b23f, #f15a2b);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  /* padding: 30px 0; */\n  /* border-bottom: 1px solid #d1d1d1; */\n  font-size: 28px;\n  font-weight: 600;\n  text-align: center;\n  text-transform: uppercase;\n  @media (min-width: 1600px) {\n    font-size: 1.75vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n\n.silver-sponsors {\n  background: linear-gradient(180deg, #a8a9ab, #838989);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-size: 28px;\n  font-weight: 600;\n  margin: 30px 0 0 0;\n  text-align: center;\n  text-transform: uppercase;\n  @media (min-width: 1600px) {\n    font-size: 1.75vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n\n.other-sponsors span {\n  color: #121d39;\n  font-size: 20px;\n  font-weight: 400;\n  margin: 0;\n  text-align: center;\n  text-transform: capitalize;\n  @media (min-width: 1600px) {\n    font-size: 1.5vw;\n  }\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n\n.partners-col {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20%;\n  padding: 1vw;\n  @media (max-width: 767px) {\n    width: 50%;\n  }\n  /* @media (max-width: 575px) {\n    width: 100%;\n  } */\n}\n\n.partners-img {\n  width: 100%;\n  border-radius: 8px;\n  transition: box-shadow 0.3s ease-in-out;\n}\n\n.partners-img:hover {\n  box-shadow: 4px 4px 4px 4px #d8dde6;\n}\n\n.partner-area .partner-title {\n  text-align: center;\n  margin-bottom: 50px;\n}\n.partner-area .partner-title h3 {\n  font-size: 24px;\n  font-weight: 900;\n  margin-bottom: 0;\n  color: #ff2d55;\n  text-transform: uppercase;\n  transform: translateX(0) !important;\n}\n.partner-area .partner-title.gold-sponsor h3 {\n  color: #8dc63f;\n}\n.partner-area .partner-item {\n  text-align: center;\n}\n.partner-area .partner-item a {\n  position: relative;\n}\n.partner-area .partner-item a img {\n  width: unset !important;\n  display: inline-block !important;\n}\n.partner-area .partner-item a img:last-child {\n  position: absolute;\n  left: 0;\n  top: 30px;\n  right: 0;\n  margin: 0 auto;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.5s;\n}\n.partner-area .partner-item:hover a img:last-child {\n  opacity: 1;\n  visibility: visible;\n  top: 0;\n}\n.partner-area .border {\n  border: 0.3px solid #eeeeee !important;\n  margin-top: 40px;\n  margin-bottom: 40px;\n}\n\n/*================================================\nBlog CSS\n=================================================*/\n.blog-area {\n  position: relative;\n  z-index: 1;\n}\n.blog-area.bg-image {\n  background-image: url(\"../assets/events_images/bg.webp\");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n.single-blog-post {\n  margin-bottom: 30px;\n  background-color: #ffffff;\n  box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.06);\n}\n.single-blog-post .blog-image {\n  position: relative;\n  overflow: hidden;\n}\n.single-blog-post .blog-image a {\n  display: block;\n}\n.single-blog-post .blog-image a img {\n  transition: 0.5s;\n}\n.single-blog-post .blog-image .post-tag {\n  position: absolute;\n  right: 0;\n  top: 60px;\n  transition: 0.5s;\n}\n.single-blog-post .blog-image .post-tag a {\n  background: #ff2d55;\n  color: #ffffff;\n  padding: 9px 28px;\n}\n.single-blog-post .blog-post-content {\n  padding: 25px;\n}\n.single-blog-post .blog-post-content .date {\n  color: #8dc63f;\n  display: block;\n  text-transform: uppercase;\n  font-size: 14px;\n  transition: 0.5s;\n}\n.single-blog-post .blog-post-content h3 {\n  margin-top: 13px;\n  margin-bottom: 15px;\n  line-height: 30px;\n  font-size: 22px;\n}\n.single-blog-post .blog-post-content h3 a {\n  color: #0d1028;\n}\n.single-blog-post .blog-post-content h3 a:hover,\n.single-blog-post .blog-post-content h3 a:focus {\n  color: #ff2d55;\n}\n.single-blog-post .blog-post-content p {\n  margin-bottom: 15px;\n}\n.single-blog-post .read-more-btn {\n  position: relative;\n  font-weight: 500;\n  color: #ff2d55;\n}\n.single-blog-post .read-more-btn:hover {\n  color: #00acee;\n  letter-spacing: 1px;\n}\n.single-blog-post:hover .blog-image a img,\n.single-blog-post:focus .blog-image a img {\n  transform: scale(1.2);\n}\n.single-blog-post:hover .blog-image .post-tag,\n.single-blog-post:focus .blog-image .post-tag {\n  top: 70px;\n}\n.single-blog-post:hover .blog-image .post-tag a,\n.single-blog-post:focus .blog-image .post-tag a {\n  background: #8dc63f;\n  color: #ffffff;\n}\n\n.blog-slides .swiper-pagination {\n  position: sticky;\n}\n.blog-slides .swiper-pagination .swiper-pagination-bullet {\n  width: 10px;\n  height: 10px;\n}\n.blog-slides\n  .swiper-pagination\n  .swiper-pagination-bullet.swiper-pagination-bullet-active,\n.blog-slides .swiper-pagination .swiper-pagination-bullet:hover {\n  background-color: #ff2d55;\n}\n\n/*blog-style-two*/\n.blog-section {\n  padding-bottom: 90px;\n}\n\n.single-blog-card {\n  position: relative;\n  margin-bottom: 30px;\n}\n.single-blog-card > a {\n  display: block;\n}\n.single-blog-card > a img {\n  width: 100%;\n}\n.single-blog-card::before {\n  opacity: 0.6;\n  background: #0d1028;\n  content: \"\";\n  height: 100%;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  right: 0;\n  position: absolute;\n  width: 100%;\n}\n.single-blog-card .post-tag {\n  position: absolute;\n  right: 0;\n  top: 30px;\n  transition: 0.5s;\n  z-index: 2;\n}\n.single-blog-card .post-tag a {\n  background: #ff2d55;\n  color: #ffffff;\n  padding: 9px 28px;\n}\n.single-blog-card .blog-post-content {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: 20px 30px 0;\n  transition: 0.5s;\n  z-index: 2;\n}\n.single-blog-card .blog-post-content h3 {\n  font-size: 22px;\n  margin-bottom: 15px;\n  line-height: 1.5;\n}\n.single-blog-card .blog-post-content h3 a {\n  color: #ffffff;\n}\n.single-blog-card .blog-post-content h3 a:hover,\n.single-blog-card .blog-post-content h3 a:focus {\n  color: #ff2d55;\n}\n.single-blog-card .blog-post-content p {\n  color: #ffffff;\n}\n.single-blog-card .blog-post-content .read-more-btn {\n  position: relative;\n  font-weight: 500;\n  opacity: 0;\n  visibility: hidden;\n  color: #ff2d55;\n}\n.single-blog-card .blog-post-content .read-more-btn:hover {\n  color: #00acee;\n  letter-spacing: 1px;\n}\n.single-blog-card:hover .post-tag,\n.single-blog-card:focus .post-tag {\n  top: 40px;\n}\n.single-blog-card:hover .post-tag a,\n.single-blog-card:focus .post-tag a {\n  background: #8dc63f;\n  color: #ffffff;\n}\n.single-blog-card:hover .blog-post-content,\n.single-blog-card:focus .blog-post-content {\n  padding-bottom: 30px;\n}\n.single-blog-card:hover .blog-post-content .read-more-btn,\n.single-blog-card:focus .blog-post-content .read-more-btn {\n  opacity: 1;\n  visibility: visible;\n}\n\n/*================================================\nBuy Tickets CSS\n=================================================*/\n.buy-tickets-area {\n  position: relative;\n  z-index: 1;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n.buy-tickets-area::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  background: #0d1028;\n  opacity: 0.88;\n}\n.buy-tickets-area.ptb-120 {\n  padding-bottom: 200px;\n}\n\n.buy-tickets .section-title {\n  margin-bottom: 0;\n}\n.buy-tickets .section-title h2 {\n  color: #ffffff;\n}\n.buy-tickets .section-title p {\n  color: #ffffff;\n  margin: 0;\n}\n.buy-tickets .buy-ticket-btn {\n  text-align: right;\n}\n\n/*================================================\nSubscribe CSS\n=================================================*/\n.subscribe-area {\n  text-align: center;\n  position: absolute;\n  z-index: 2;\n  top: -120px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80%;\n  @media (min-width: 2560px) {\n    top: -10vh;\n  }\n  @media (max-width: 767px) {\n    margin-top: 5rem;\n  }\n  @media (max-width: 500px) {\n    width: 90%;\n  }\n}\n\n.form-mobile-view{\n  @media (max-width: 767px) {\n    margin-top: 4rem;\n  }\n}\n\n.subscribe-area::before {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 72%;\n  content: \"\";\n  z-index: -1;\n}\n.subscribe-area .subscribe-inner {\n  padding: 20px 50px;\n  transform: unset !important;\n  background: linear-gradient(60deg, #e74860, #f15a2b);\n  background-repeat: no-repeat;\n}\n.subscribe-area .subscribe-inner p {\n  color: #121d39;\n  font-size: 20px;\n  letter-spacing: 1px;\n  display: block;\n  text-transform: uppercase;\n  margin-bottom: 0 !important;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw;\n  }\n}\n.subscribe-area .subscribe-inner p span {\n  color: #ffffff;\n  text-transform: capitalize !important;\n}\n\n.learn-about-us a {\n  color: #ffffff !important;\n  font-size: 20px !important;\n  margin-top: 12px;\n  display: block;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw !important;\n  }\n}\n\n.subscribe-area .subscribe-inner h2 a {\n  font-size: 36px;\n  margin-top: 12px;\n  margin-bottom: 12px;\n  color: #ffffff !important;\n  text-decoration: none !important;\n  @media (min-width: 1600px) {\n    font-size: 2vw;\n  }\n}\n.subscribe-area .subscribe-inner .newsletter-form {\n  max-width: 650px;\n  position: relative;\n  margin: 12px auto 24px;\n}\n.subscribe-area .subscribe-inner .newsletter-form .form-control {\n  border: none;\n  height: 60px;\n  box-shadow: 0 8px 6px -6px rgba(50, 51, 51, 0.4);\n}\n.subscribe-area .subscribe-inner .newsletter-form .btn {\n  position: absolute;\n  right: 0;\n  top: 0;\n  text-transform: uppercase;\n  height: 60px;\n}\n.subscribe-area .subscribe-inner .newsletter-form .btn:after,\n.subscribe-area .subscribe-inner .newsletter-form .btn::before {\n  background: #121d39;\n}\n\n/*================================================\nPage Title CSS\n=================================================*/\n.page-title-area {\n  position: relative;\n  z-index: 1;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  text-align: center;\n  padding-top: 250px;\n  padding-bottom: 180px;\n}\n.page-title-area::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  background: #0d1028;\n  opacity: 0.88;\n}\n.page-title-area h1 {\n  color: #ffffff;\n  margin-bottom: 0;\n  text-transform: uppercase;\n  font-size: 40px;\n}\n.page-title-area span {\n  display: block;\n  color: #ffffff;\n  margin-top: 10px;\n  font-size: 17px;\n}\n.page-title-area ul {\n  padding: 0;\n  margin: 12px 0 0;\n  list-style-type: none;\n}\n.page-title-area ul li {\n  display: inline-block;\n  position: relative;\n  color: #ff2d55;\n  font-size: 16px;\n  margin: 0 13px;\n}\n.page-title-area ul li a {\n  color: #ffffff;\n}\n.page-title-area ul li a:hover,\n.page-title-area ul li a:focus {\n  color: #00acee;\n}\n.page-title-area ul li::before {\n  content: \"\";\n  position: absolute;\n  left: -15px;\n  top: 50%;\n  width: 2px;\n  height: 15px;\n  background: #efa506;\n  margin-top: -9px;\n  transform: rotate(10deg);\n}\n.page-title-area ul li:first-child {\n  margin-left: 0;\n}\n.page-title-area ul li:first-child::before {\n  display: none;\n}\n.page-title-area ul li:last-child {\n  margin-right: 0;\n}\n\n/*================================================\nLogin CSS\n=================================================*/\n.login-area {\n  height: 100vh;\n  position: relative;\n  z-index: 100000;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.login-area::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  background: #ff2d55;\n  opacity: 0.77;\n}\n.login-area .login-form {\n  max-width: 540px;\n  background: #ffffff;\n  margin: 0 auto;\n}\n.login-area .login-form h3 {\n  background: #00acee;\n  padding: 30px 0 25px;\n  font-size: 24px;\n  margin-bottom: 0;\n  color: #ffffff;\n  text-align: center;\n  text-transform: uppercase;\n}\n.login-area .login-form form {\n  padding: 35px;\n}\n.login-area .login-form form label {\n  font-weight: 500;\n}\n.login-area .login-form form .form-control {\n  background: transparent;\n  font-size: 13px;\n}\n.login-area .login-form .btn {\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n}\n.login-area .login-form p {\n  overflow: hidden;\n  margin-bottom: 0;\n  margin-top: 20px;\n}\n.login-area .login-form p a {\n  color: #0d1028;\n  font-weight: 600;\n}\n.login-area .login-form p a:hover,\n.login-area .login-form p a:focus {\n  color: #ff2d55;\n}\n.login-area .login-form p a.pull-left {\n  float: left;\n}\n.login-area .login-form p a.pull-right {\n  float: right;\n}\n\n/*================================================\nSignup CSS\n=================================================*/\n.signup-area {\n  height: 100vh;\n  position: relative;\n  z-index: 10000;\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.signup-area::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  background: #ff2d55;\n  opacity: 0.77;\n}\n.signup-area .signup-form {\n  max-width: 540px;\n  background: #ffffff;\n  margin: 0 auto;\n}\n.signup-area .signup-form h3 {\n  background: #00acee;\n  padding: 30px 0 25px;\n  font-size: 24px;\n  margin-bottom: 0;\n  color: #ffffff;\n  text-align: center;\n  text-transform: uppercase;\n}\n.signup-area .signup-form form {\n  padding: 35px;\n}\n.signup-area .signup-form form label {\n  font-weight: 500;\n}\n.signup-area .signup-form form .form-control {\n  background: transparent;\n  font-size: 13px;\n}\n.signup-area .signup-form .btn {\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n}\n.signup-area .signup-form p {\n  text-align: center;\n  color: #0d1028;\n  margin-bottom: 0;\n  margin-top: 20px;\n}\n.signup-area .signup-form p a {\n  color: #0d1028;\n  display: inline-block;\n  font-weight: 600;\n}\n.signup-area .signup-form p a:hover,\n.signup-area .signup-form p a:focus {\n  color: #ff2d55;\n}\n\n/*================================================\n404 Error CSS\n=================================================*/\n.error-area {\n  background-color: #f1f1f1;\n  padding: 30px 15px;\n  height: 100vh;\n  text-align: center;\n  z-index: 10000;\n  position: relative;\n}\n.error-area h1 {\n  font-size: 150px;\n  font-weight: bold;\n  line-height: 110px;\n  margin: 0;\n  color: #ff2d55;\n}\n.error-area h1 span {\n  color: #efa506;\n}\n.error-area h1 b {\n  font-weight: unset;\n  color: #8dc63f;\n}\n.error-area h3 {\n  margin: 35px 0 15px;\n}\n.error-area p {\n  margin: 10px 0 20px;\n}\n\n/*================================================\nFAQ CSS\n=================================================*/\n.faq-accordion {\n  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);\n  padding: 60px;\n  background: #ffffff;\n  border-radius: 10px;\n}\n.faq-accordion .accordion {\n  border: none;\n  border-radius: 0;\n}\n.faq-accordion .accordion__item {\n  margin-bottom: 15px;\n}\n.faq-accordion .accordion__item .accordion__button {\n  background-color: #ffffff;\n  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);\n  color: #0d1028;\n  outline: 0;\n  font-weight: 600;\n  font-size: 18px;\n}\n.faq-accordion .accordion__item:last-child {\n  margin-bottom: 0;\n}\n.faq-accordion .accordion__item + .accordion__item {\n  border: none;\n}\n\n.faq-contact {\n  margin-top: 45px;\n  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);\n  padding: 60px;\n  text-align: center;\n  border-radius: 4px;\n}\n.faq-contact h3 {\n  font-size: 25px;\n  margin-bottom: 35px;\n}\n.faq-contact .form-group {\n  margin-bottom: 25px;\n}\n.faq-contact .form-control {\n  background-color: #f5f5f5;\n}\n\n/*================================================\nComing Soon CSS\n=================================================*/\n.coming-soon {\n  position: relative;\n  z-index: 1000;\n  height: 100vh;\n  text-align: center;\n  /* background-image: url(\"../assets/events_images/main-bg3.jpg\"); */\n  background-position: center center;\n  background-size: cover;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n}\n.coming-soon::before {\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: #0d1028;\n  opacity: 0.66;\n  position: absolute;\n  content: \"\";\n}\n.coming-soon .coming-soon-content {\n  max-width: 650px;\n  margin: 0 auto;\n}\n.coming-soon .coming-soon-content h1 {\n  color: #ffffff;\n  font-size: 45px;\n  text-transform: uppercase;\n  margin-bottom: 0;\n  line-height: 57px;\n}\n.coming-soon .coming-soon-content p {\n  color: #c7c3c7;\n  margin-top: 20px;\n  margin-bottom: 35px;\n}\n.coming-soon .coming-soon-content form {\n  position: relative;\n}\n.coming-soon .coming-soon-content form .form-control {\n  background: transparent;\n  border: 1px solid #ffffff;\n  border-radius: 50px;\n  color: #ffffff;\n  height: 55px;\n  padding-left: 20px;\n}\n.coming-soon .coming-soon-content form .form-control:focus,\n.coming-soon .coming-soon-content form .form-control:hover {\n  border-color: #ff2d55;\n}\n.coming-soon .coming-soon-content form .form-control::-moz-placeholder {\n  color: #c7c3c7;\n}\n.coming-soon .coming-soon-content form .form-control::placeholder {\n  color: #c7c3c7;\n}\n.coming-soon .coming-soon-content form button {\n  position: absolute;\n  right: -1px;\n  height: 100%;\n  background: #ff2d55;\n  top: 0;\n  color: #ffffff;\n  border: none;\n  width: 130px;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-weight: 500;\n  border-radius: 0 50px 50px 0;\n  transition: 0.5s;\n  outline: 0 !important;\n  border: none;\n}\n.coming-soon .coming-soon-content form button:hover,\n.coming-soon .coming-soon-content form button:focus {\n  background: #00acee;\n}\n.coming-soon .coming-soon-content #timer {\n  margin-bottom: 35px;\n}\n.coming-soon .coming-soon-content #timer div {\n  display: inline-block;\n  font-size: 45px;\n  font-weight: 700;\n  color: #ffffff;\n  width: 135px;\n  height: 135px;\n  border: 1px solid #eeeeee;\n  border-radius: 50%;\n  padding-top: 34px;\n  line-height: 40px;\n  margin: 0 10px;\n}\n.coming-soon .coming-soon-content #timer span {\n  display: block;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n/*================================================\nPagination CSS\n=================================================*/\n.pagination-area {\n  margin-top: 30px;\n}\n.pagination-area ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.pagination-area ul li a {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  margin: 0 5px;\n  background-color: #ffffff;\n  border-radius: 0 !important;\n  text-align: center;\n  line-height: 40px;\n  color: #0d1028;\n  font-size: 17px;\n  font-weight: 500;\n  box-shadow: 0 2px 10px 0 #d8dde6;\n  border: none;\n}\n.pagination-area ul li a.active,\n.pagination-area ul li a:hover,\n.pagination-area ul li a:focus {\n  background: #ff2d55;\n  color: #ffffff;\n  box-shadow: unset;\n}\n\n/*================================================\nBlog Details CSS\n=================================================*/\n.blog-details .post-image {\n  margin-bottom: 35px;\n}\n.blog-details h3 {\n  font-size: 25px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n}\n.blog-details .blog-meta ul {\n  padding: 0;\n  margin: 15px 0;\n  list-style-type: none;\n}\n.blog-details .blog-meta ul li {\n  display: inline-block;\n  position: relative;\n  color: #707070;\n  font-size: 14px;\n  margin-left: 9px;\n  margin-right: 9px;\n}\n.blog-details .blog-meta ul li i {\n  margin-right: 4px;\n  color: #ff2d55;\n}\n.blog-details .blog-meta ul li::before {\n  width: 2px;\n  height: 14px;\n  background: #707070;\n  left: -10px;\n  top: 50%;\n  position: absolute;\n  content: \"\";\n  margin-top: -6px;\n  transform: rotate(11deg);\n}\n.blog-details .blog-meta ul li a {\n  display: inline-block;\n  color: #707070;\n}\n.blog-details .blog-meta ul li a:hover,\n.blog-details .blog-meta ul li a:focus {\n  color: #00acee;\n}\n.blog-details .blog-meta ul li:last-child {\n  margin-right: 0;\n}\n.blog-details .blog-meta ul li:first-child {\n  margin-left: 0;\n}\n.blog-details .blog-meta ul li:first-child::before {\n  display: none;\n}\n.blog-details p {\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n.blog-details p:last-child {\n  margin-bottom: 0;\n}\n.blog-details blockquote,\n.blog-details .blockquote {\n  background: #f6f6f6 none repeat scroll 0 0;\n  padding: 35px 20px 35px 100px;\n  position: relative;\n  margin-top: 25px;\n  margin-bottom: 25px;\n}\n.blog-details blockquote::before,\n.blog-details .blockquote::before {\n  font-family: IcoFont !important;\n  position: absolute;\n  content: \"\\efcd\";\n  left: 25px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 55px;\n  color: #ff2d55;\n}\n.blog-details blockquote p,\n.blog-details .blockquote p {\n  color: #0d1028;\n  font-style: italic;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.post-tag-media {\n  background-color: #f5f7fb;\n  padding: 20px;\n  margin-top: 25px;\n  margin-bottom: 35px;\n}\n.post-tag-media ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.post-tag-media ul li {\n  display: inline-block;\n}\n.post-tag-media ul li span {\n  font-weight: 600;\n  margin-right: 5px;\n  display: inline-block;\n}\n.post-tag-media ul li a {\n  color: #707070;\n  margin-right: 4px;\n}\n.post-tag-media ul li a:hover,\n.post-tag-media ul li a:focus {\n  color: #ff2d55;\n}\n.post-tag-media ul.social-share {\n  text-align: right;\n}\n.post-tag-media ul.social-share li {\n  padding-left: 5px;\n}\n\n.comments-area .comments-title,\n.comments-area .comment-reply-title {\n  font-size: 22px;\n  margin-bottom: 25px;\n}\n.comments-area .comment-reply-title {\n  margin-bottom: 8px;\n}\n.comments-area ol,\n.comments-area ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.comments-area ol li ol li,\n.comments-area ol li ul li,\n.comments-area ul li ol li,\n.comments-area ul li ul li {\n  margin-top: 15px;\n  margin-left: 35px;\n  margin-bottom: 15px;\n}\n.comments-area ol li .comment-body,\n.comments-area ul li .comment-body {\n  background: #f7f7ff;\n  padding: 25px 20px;\n  position: relative;\n}\n.comments-area ol li .comment-body .comment-meta,\n.comments-area ul li .comment-body .comment-meta {\n  position: relative;\n  padding-left: 85px;\n  padding-top: 8px;\n}\n.comments-area ol li .comment-body .comment-meta .comment-author img,\n.comments-area ul li .comment-body .comment-meta .comment-author img {\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 50%;\n  max-width: 68px;\n}\n.comments-area ol li .comment-body .comment-meta .comment-author .fn,\n.comments-area ul li .comment-body .comment-meta .comment-author .fn {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  display: block;\n}\n.comments-area ol li .comment-body .comment-meta .comment-author .says,\n.comments-area ul li .comment-body .comment-meta .comment-author .says {\n  display: none;\n}\n.comments-area ol li .comment-body .comment-meta .comment-metadata a,\n.comments-area ul li .comment-body .comment-meta .comment-metadata a {\n  display: inline-block;\n  color: #707070;\n  font-size: 14px;\n}\n.comments-area ol li .comment-body .comment-meta .comment-metadata a:hover,\n.comments-area ol li .comment-body .comment-meta .comment-metadata a:focus,\n.comments-area ul li .comment-body .comment-meta .comment-metadata a:hover,\n.comments-area ul li .comment-body .comment-meta .comment-metadata a:focus {\n  color: #ff2d55;\n}\n.comments-area ol li .comment-body .comment-content,\n.comments-area ul li .comment-body .comment-content {\n  margin-top: 25px;\n}\n.comments-area ol li .comment-body .reply,\n.comments-area ul li .comment-body .reply {\n  position: absolute;\n  right: 30px;\n  top: 30px;\n}\n.comments-area ol li .comment-body .reply a,\n.comments-area ul li .comment-body .reply a {\n  display: inline-block;\n  background: #0d1028;\n  padding: 5px 15px;\n  color: #ffffff;\n}\n.comments-area ol li .comment-body .reply a:hover,\n.comments-area ol li .comment-body .reply a:focus,\n.comments-area ul li .comment-body .reply a:hover,\n.comments-area ul li .comment-body .reply a:focus {\n  background: #ff2d55;\n}\n.comments-area .comment-respond {\n  margin-top: 30px;\n}\n.comments-area .comment-respond .comment-notes {\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n.comments-area .comment-respond .comment-form p {\n  margin-bottom: 25px;\n}\n.comments-area .comment-respond .comment-form-comment input,\n.comments-area .comment-respond .comment-form-comment textarea,\n.comments-area .comment-respond .comment-form-author input,\n.comments-area .comment-respond .comment-form-author textarea,\n.comments-area .comment-respond .comment-form-email input,\n.comments-area .comment-respond .comment-form-email textarea,\n.comments-area .comment-respond .comment-form-url input,\n.comments-area .comment-respond .comment-form-url textarea {\n  display: block;\n  width: 100%;\n  height: 50px;\n  background-color: #f5f5f5;\n  outline: 0 !important;\n  box-shadow: unset !important;\n  border: 1px solid #eeeeee;\n  padding: 10px 20px;\n  border-radius: 6px;\n  transition: 0.5s;\n}\n.comments-area .comment-respond .comment-form-comment input:focus,\n.comments-area .comment-respond .comment-form-comment textarea:focus,\n.comments-area .comment-respond .comment-form-author input:focus,\n.comments-area .comment-respond .comment-form-author textarea:focus,\n.comments-area .comment-respond .comment-form-email input:focus,\n.comments-area .comment-respond .comment-form-email textarea:focus,\n.comments-area .comment-respond .comment-form-url input:focus,\n.comments-area .comment-respond .comment-form-url textarea:focus {\n  border-color: #ff2d55;\n}\n.comments-area .comment-respond .comment-form-comment textarea,\n.comments-area .comment-respond .comment-form-author textarea,\n.comments-area .comment-respond .comment-form-email textarea,\n.comments-area .comment-respond .comment-form-url textarea {\n  height: auto;\n}\n.comments-area .comment-respond .form-submit {\n  margin: 0 !important;\n}\n.comments-area .comment-respond .form-submit input {\n  display: inline-block;\n  background: #ff2d55;\n  border: none;\n  color: #ffffff;\n  padding: 13px 25px;\n  text-transform: uppercase;\n  font-weight: 600;\n  outline: 0 !important;\n  margin-top: 5px;\n  transition: 0.5s;\n}\n.comments-area .comment-respond .form-submit input:hover,\n.comments-area .comment-respond .form-submit input:focus {\n  background: #0d1028;\n  box-shadow: 0 13px 27px 0 rgba(255, 82, 2, 0.11);\n}\n\n/*================================================\nSidebar CSS\n=================================================*/\n.sidebar .widget {\n  margin-bottom: 40px;\n}\n.sidebar .widget:last-child {\n  margin-bottom: 0;\n}\n.sidebar .widget .widget-title {\n  font-size: 22px;\n  margin-bottom: 25px;\n  position: relative;\n}\n.sidebar .widget .widget-title::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 2px;\n  width: 17px;\n  height: 17px;\n  background: #ff2d55;\n  -webkit-clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);\n  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);\n  transition: 0.5s;\n}\n.sidebar .widget:hover .widget-title::before,\n.sidebar .widget:focus .widget-title::before {\n  transform: rotate(180deg);\n}\n.sidebar .widget.widget_search {\n  background: #ffffff;\n  box-shadow: 0px 0px 29px 0px rgba(102, 102, 102, 0.1);\n  padding: 15px;\n}\n.sidebar .widget.widget_search form {\n  position: relative;\n}\n.sidebar .widget.widget_search form .form-control {\n  background: transparent;\n}\n.sidebar .widget.widget_search form button {\n  position: absolute;\n  right: 5px;\n  top: 0;\n  height: 100%;\n  border: none;\n  outline: 0;\n  box-shadow: unset;\n  background: transparent;\n  color: #ff2d55;\n  transition: 0.5s;\n}\n.sidebar .widget.widget_search form button:hover,\n.sidebar .widget.widget_search form button:focus {\n  color: #00acee;\n}\n.sidebar .widget.widget_categories ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.sidebar .widget.widget_categories ul li {\n  position: relative;\n  border-top: 1px solid #eeeeee;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 18px;\n}\n.sidebar .widget.widget_categories ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  width: 10px;\n  height: 10px;\n  background: #ff2d55;\n  margin-top: -5px;\n  transition: 0.5s;\n}\n.sidebar .widget.widget_categories ul li:last-child {\n  border-bottom: 1px solid #eeeeee;\n}\n.sidebar .widget.widget_categories ul li a {\n  color: #707070;\n}\n.sidebar .widget.widget_categories ul li a:hover {\n  color: #ff2d55;\n}\n.sidebar .widget.widget_categories ul li:hover::before {\n  border-radius: 50%;\n}\n.sidebar .widget.widget_recent_entries ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.sidebar .widget.widget_recent_entries ul li {\n  position: relative;\n  padding-left: 100px;\n  margin-bottom: 15px;\n  padding-right: 20px;\n}\n.sidebar .widget.widget_recent_entries ul li a {\n  display: block;\n}\n.sidebar .widget.widget_recent_entries ul li a img {\n  position: absolute;\n  left: 0;\n  top: 3px;\n  width: 85px;\n  height: 65px;\n}\n.sidebar .widget.widget_recent_entries ul li h5 {\n  font-size: 15px;\n  line-height: 22px;\n  margin-bottom: 2px;\n  font-weight: 600;\n}\n.sidebar .widget.widget_recent_entries ul li h5 a {\n  color: #0d1028;\n  display: inline-block;\n}\n.sidebar .widget.widget_recent_entries ul li h5 a:hover,\n.sidebar .widget.widget_recent_entries ul li h5 a:focus {\n  color: #ff2d55;\n}\n.sidebar .widget.widget_recent_entries ul li:last-child {\n  margin-bottom: 0;\n}\n.sidebar .widget.widget_tag_cloud .tagcloud a {\n  font-size: 14px !important;\n  border: 1px dashed #eeeeee;\n  padding: 6px 20px;\n  margin-top: 5px;\n  color: #707070;\n  display: inline-block;\n  background: #f5f5f5;\n  margin-right: 7px;\n  border-radius: 30px;\n  margin-bottom: 5px;\n}\n.sidebar .widget.widget_tag_cloud .tagcloud a:hover {\n  background: #ff2d55;\n  color: #ffffff;\n  border-color: #ff2d55;\n}\n.sidebar .widget.widget_archive ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.sidebar .widget.widget_archive ul li {\n  position: relative;\n  border-top: 1px solid #eeeeee;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 18px;\n}\n.sidebar .widget.widget_archive ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  width: 10px;\n  height: 10px;\n  background: #ff2d55;\n  margin-top: -5px;\n  transition: 0.5s;\n}\n.sidebar .widget.widget_archive ul li:last-child {\n  border-bottom: 1px solid #eeeeee;\n}\n.sidebar .widget.widget_archive ul li a {\n  color: #707070;\n  display: inline-block;\n}\n.sidebar .widget.widget_archive ul li a:hover {\n  color: #ff2d55;\n}\n.sidebar .widget.widget_archive ul li:hover::before {\n  border-radius: 50%;\n}\n\n/*================================================\nContact Us CSS\n=================================================*/\n.contact-box {\n  background: #ffffff;\n  padding: 30px 20px 30px 90px;\n  border-radius: 5px;\n  position: relative;\n  transition: 0.5s;\n  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);\n}\n.contact-box .icon {\n  position: absolute;\n  left: 20px;\n  top: 30px;\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  line-height: 47px;\n  border: 1px dashed #ff2d55;\n  border-radius: 50%;\n  color: #ff2d55;\n  font-size: 20px;\n  transition: 0.5s;\n}\n.contact-box h4 {\n  font-size: 20px;\n  margin-bottom: 10px;\n}\n.contact-box .content p {\n  margin-bottom: 0;\n}\n.contact-box .content p a {\n  color: #707070;\n}\n.contact-box .content p a:hover,\n.contact-box .content p a:focus {\n  color: #ff2d55;\n}\n.contact-box .content p:last-child {\n  margin-bottom: 0;\n}\n.contact-box:hover,\n.contact-box:focus {\n  box-shadow: 0 0 30px 0 rgba(67, 67, 67, 0.15);\n  transform: translateY(-5px);\n}\n.contact-box:hover .icon,\n.contact-box:focus .icon {\n  background: #ff2d55;\n  color: #ffffff;\n}\n\n#map {\n  height: 400px;\n  width: 100%;\n}\n\n.contact-form {\n  margin-top: 50px;\n}\n\n.leave-your-message h3 {\n  margin-bottom: 12px;\n  font-size: 22px;\n}\n.leave-your-message .stay-connected {\n  margin-top: 25px;\n}\n.leave-your-message .stay-connected h3 {\n  margin-bottom: 20px;\n}\n.leave-your-message .stay-connected ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.leave-your-message .stay-connected ul li {\n  margin-bottom: 10px;\n}\n.leave-your-message .stay-connected ul li:last-child {\n  margin-bottom: 0;\n}\n.leave-your-message .stay-connected ul li a {\n  font-weight: 500;\n  display: inline-block;\n  color: #707070;\n}\n.leave-your-message .stay-connected ul li a i {\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  display: inline-block;\n  line-height: 40px;\n  border: 1px solid;\n  border-radius: 50%;\n  margin-right: 10px;\n  font-size: 15px;\n}\n.leave-your-message .stay-connected ul li a:hover,\n.leave-your-message .stay-connected ul li a:focus {\n  color: #ff2d55;\n}\n\n#contactForm {\n  background: #ffffff;\n  padding: 30px;\n  box-shadow: 0 0 1.25rem rgba(108, 118, 134, 0.1);\n}\n#contactForm label {\n  font-weight: 500;\n}\n#contactForm .form-control {\n  background-color: #f1f1f1;\n}\n#contactForm ul {\n  padding: 0;\n  margin: 0;\n}\n#contactForm ul li {\n  color: red;\n  margin-top: 10px;\n  font-size: 14px;\n}\n#contactForm .text-danger,\n#contactForm .text-success {\n  margin-bottom: 0;\n  margin-top: 20px;\n}\n#contactForm .h4 {\n  font-size: 15px;\n}\n\n/*================================================\nFooter CSS\n=================================================*/\n.footer-area {\n  padding-top: 60px;\n  position: relative;\n  background-image: url(\"../assets/events_images/footer-patterns.webp\");\n  background-position: center top;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.single-footer-widget {\n  z-index: 100;\n  position: relative;\n  text-align: center;\n}\n\n.footer-venue-logo {\n  padding: 1vw;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 10px !important;\n  width: 12vw !important;\n  height: auto !important;\n  margin-bottom: 16px !important;\n  @media (max-width: 768px) {\n    padding: 12px;\n    width: 20vw !important;\n  }\n  @media (max-width: 600px) {\n    width: 40vw !important;\n  }\n}\n\n.single-footer-widget h3 {\n  color: #ffffff;\n  font-size: 36px;\n  margin-bottom: 20px;\n  @media (min-width: 1600px) {\n    font-size: 2.25vw;\n  }\n}\n.single-footer-widget span {\n  color: rgba(255, 255, 255, 1);\n  display: block;\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n.single-footer-widget span i {\n  margin-right: 5px;\n}\n.single-footer-widget p {\n  margin-bottom: 0;\n  color: rgba(255, 255, 255, 1);\n  font-size: 20px;\n  @media (min-width: 1600px) {\n    font-size: 1.25vw;\n  }\n  @media (max-width: 767px) {\n    text-align: center;\n    font-size: 16px;\n  }\n}\n.single-footer-widget .location {\n  position: relative;\n  padding-left: 25px;\n}\n.single-footer-widget .location i {\n  margin-right: 5px;\n  position: absolute;\n  left: 0;\n  top: 6px;\n}\n.single-footer-widget .contact-authority {\n  margin-top: 8px;\n  color: rgba(255, 255, 255, 0.6);\n}\n.single-footer-widget .contact-authority:hover,\n.single-footer-widget .contact-authority:focus {\n  color: #ff2d55;\n}\n.single-footer-widget .contact-authority i {\n  margin-right: 5px;\n}\n.single-footer-widget .social-links {\n  padding: 0;\n  margin: 20px 0 0;\n  list-style-type: none;\n  text-align: center;\n  @media (max-width: 767px) {\n    display: flex;\n    justify-content: center;\n  }\n}\n.single-footer-widget .social-links li {\n  display: inline-block;\n  margin-right: 10px;\n}\n.single-footer-widget .social-links li a {\n  color: #ffffff;\n  border: 1px solid #525164;\n  width: 35px !important;\n  height: 35px !important;\n  line-height: 35px;\n  text-align: center;\n  border-radius: 50%;\n  font-size: 14px;\n  text-decoration: none;\n  font-size: 24px;\n  display: flex;\n}\n.single-footer-widget .social-links li a.facebook {\n  border: none;\n  background-color: #4267b2;\n}\n.single-footer-widget .social-links li a.twitter {\n  border: none;\n  background-color: #38a1f3;\n}\n.single-footer-widget .social-links li a.instagram {\n  border: none;\n  background: radial-gradient(\n      circle farthest-corner at 35% 90%,\n      #fec564,\n      transparent 50%\n    ),\n    radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),\n    radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),\n    radial-gradient(\n      ellipse farthest-corner at 20% -50%,\n      #5258cf,\n      transparent 50%\n    ),\n    radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),\n    radial-gradient(\n      ellipse farthest-corner at 60% -20%,\n      #893dc2,\n      transparent 50%\n    ),\n    radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),\n    linear-gradient(\n      #6559ca,\n      #bc318f 30%,\n      #e33f5f 50%,\n      #f77638 70%,\n      #fec66d 100%\n    );\n}\n.single-footer-widget .social-links li a.linkedin {\n  border: none;\n  background-color: #0077b5;\n}\n.single-footer-widget .social-links li a:hover,\n.single-footer-widget .social-links li a:focus {\n  background-color: #ff2d55;\n  color: #ffffff;\n  border-color: #ff2d55;\n}\n\n.copyright-area {\n  position: relative;\n  z-index: 1000 !important;\n  border-top: 1px solid #f5f5f5;\n  padding-top: 40px;\n  padding-bottom: 30px;\n  margin-top: 80px;\n  text-align: center;\n  width: 70%;\n  @media (max-width: 768px) {\n    width: 90%;\n  }\n}\n.copyright-area .logo a {\n  display: inline-block;\n}\n.copyright-area ul {\n  padding: 0;\n  margin: 30px 0 20px;\n  text-align: center !important;\n}\n.copyright-area ul li {\n  position: relative;\n  margin: 5px 15px;\n  display: inline-block;\n  font-size: 16px;\n  text-decoration: none !important;\n}\n.copyright-area ul li::before {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  content: \"\";\n  background: #ffffff;\n  left: -18px;\n  top: 50%;\n  margin-top: -2px;\n  border-radius: 50%;\n}\n.copyright-area ul li a {\n  font-size: 16px;\n  color: #ffffff;\n  text-decoration: none !important;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw;\n  }\n}\n.copyright-area ul li a:hover,\n.copyright-area ul li a:focus {\n  color: #ffffff;\n}\n.copyright-area ul li:first-child {\n  margin-left: 0;\n}\n.copyright-area ul li::before {\n  display: none;\n}\n.copyright-area ul li:last-child {\n  margin-right: 0;\n}\n.copyright-area p {\n  font-size: 16px;\n  color: #ffffff;\n  @media (min-width: 1600px) {\n    font-size: 1.05vw;\n  }\n}\n\n/*================================================\nBack To Top CSS\n=================================================*/\n.back-to-top {\n  position: fixed;\n  right: 1.5%;\n  bottom: 15px;\n  height: 15px;\n  cursor: pointer;\n  width: 40px;\n  padding: 3px 5px;\n  font-size: 10px;\n  font-weight: bold;\n  color: transparent;\n  text-align: center;\n  z-index: 3;\n  outline: 0 !important;\n  transition: 0.5s;\n  background-color: #0c3246;\n  box-shadow: 0 0 10px 0 rgba(137, 173, 255, 0.35);\n}\n.back-to-top::before,\n.back-to-top::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 0;\n  height: 0;\n  border: 20px solid transparent;\n  border-top: 0;\n}\n.back-to-top::before {\n  top: -20px;\n  z-index: 4;\n  border-bottom: 20px solid #0c3246;\n}\n.back-to-top::after {\n  bottom: 0;\n  z-index: 5;\n  border-bottom: 20px solid #e74860;\n}\n.back-to-top:hover,\n.back-to-top:focus {\n  opacity: 1;\n  text-decoration: none;\n  height: 40px;\n  color: #ffffff;\n}\n.back-to-top.show-back-to-top {\n  display: block;\n  bottom: 1.25%;\n  visibility: visible;\n}\n\n:invalid {\n  box-shadow: none;\n}\n\n:-moz-submit-invalid {\n  box-shadow: none;\n}\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n.modal-video {\n  position: absolute !important;\n}\n\n.main-textarea h1,\n.main-textarea h2,\n.main-textarea h3,\n.main-textarea h4,\n.main-textarea h5,\n.main-textarea h6 {\n  margin-bottom: 15px;\n}\n.main-textarea ul li,\n.main-textarea ol li {\n  color: #707070;\n  margin-bottom: 10px;\n  line-height: 1.8;\n} /*# sourceMappingURL=style.css.map */\n\n.ant-tabs-top > .ant-tabs-nav {\n  border: none;\n}\n\n.register-area {\n  background-image: url(\"../assets/events_images/register-bg.webp\");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  padding: 120px 0 120px 0;\n  position: relative;\n  @media (max-width: 993px) {\n    padding: 80px 0 80px 0;\n  }\n  @media (max-width: 767px) {\n    padding: 60px 0 60px 0;\n\n  }\n}\n\n.register-area h1 {\n  font-size: 52px;\n  line-height: 150%;\n  margin: 60px 0;\n  text-align: center;\n  background: linear-gradient(180deg, #f15a2b, #e74860);\n  -webkit-background-clip: text;\n  -moz-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  @media (min-width: 2560px) {\n    margin: 10vh 0 8vh 0;\n  }\n\n  @media (min-width: 1600px) {\n    font-size: 3.25vw;\n  }\n  @media (max-width: 993px) {\n    margin-bottom: 30px;\n  }\n  @media (max-width: 767px) {\n    font-size: 40px;\n  }\n}\n\n#hubspotForm {\n  border-radius: 1.2vw;\n  background: #f8f8f820 !important;\n  padding: 24px !important;\n  color: #fff !important;\n  @media (max-width: 767px) {\n    padding: 20px !important;\n  }\n}\n\n.align-participants{\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
